const bloxSpanishSubscriptionMessages = {
  label: 'Suscripción',
  subscriptions: 'Suscripciones',
  new_subscription: 'Nueva Suscripción',
  rate: {
    label: 'Tarifa',
  },
  nextRate: 'Próxima tarifa',
  termExpires: 'Vencimiento del plazo',
  termExpired: 'Plazo vencido',
  expireTime: {
    label: 'Fecha de vencimiento',
    edit: 'Editar fecha de vencimiento',
    success: 'Fecha de vencimiento actualizada.',
    error: 'Error de actualización: {{error}}',
    noDateSelected: 'No se seleccionó ninguna fecha.',
    invalidDate:
      'La fecha seleccionada no es válida. Por favor, actualice e intente de nuevo.',
    formatError: 'No se pudo formatear la fecha de vencimiento.',
  },
  nextRetryDate: 'Próxima fecha de reintento',
  nextRenewalDate: 'Próxima fecha de renovación',
  graceEnds: 'Fin del período de gracia',
  autorenews: {
    label: 'Renovación automática',
    success: 'Renovación automática actualizada',
    error: 'Error al actualizar la renovación automática',
  },
  startDate: 'Inicio de suscripción',
  every: 'cada',
  for: 'por',
  fields: {
    account: 'Cuenta',
    productId: 'ID de producto',
    subscriptionId: 'ID de suscripción',
    edition: 'Edición',
  },
  managedOnOriginatingSite:
    'Este tipo de suscripción se puede gestionar en el sitio de origen.',
  actions: {
    change_rate: 'Cambiar tarifa',
    cancel_subscription: 'Cancelar suscripción',
  },
  change_rate_wizard: {
    title: 'Cambiar tarifa de suscripción',
    steps: {
      offers: 'Ofertas',
      payment: 'Pago',
      review: 'Revisión',
      confirmation: 'Confirmación',
    },
    alerts: {
      subscription_error:
        'Error al cargar los datos de la suscripción. Vuelve a intentarlo más tarde.',
      missing_data:
        'No hay datos de suscripción ni de usuario disponibles. Verifica los identificadores e inténtalo de nuevo.',
    },
    fallbacks: {
      unnamed_subscriber: 'Suscriptor sin nombre',
    },
    buttons: {
      processing: 'Procesando...',
      confirm_change: 'Confirmar cambio',
      close: 'Cerrar',
      next: 'Siguiente',
    },
    notifications: {
      change_success: 'La tarifa de la suscripción se cambió correctamente',
      change_warning: 'Cambio de tarifa completado (respuesta: {{status}})',
      change_error: 'Error al cambiar la tarifa de la suscripción: {{message}}',
      user_error: 'Error al cargar los datos del usuario: {{message}}',
      subscription_error: 'Error al cargar los datos de la suscripción: {{message}}',
    },
    labels: {
      unknown_status: 'desconocido',
    },
    review: {
      taxQuoteWarning:
        'Estimación de impuestos no disponible. Los impuestos se calcularán al finalizar la compra y pueden no reflejarse en el total mostrado.',
      taxUnavailable: 'No disponible',
    },
  },
  loading: {
    rateDetails: 'Cargando detalles de tarifa...',
  },
  error: {
    fetchingRateDetails: 'Error al obtener los detalles de la tarifa.',
  },
  transactions: {
    label: 'Transacciones',
    history: 'Historial',
    loading: 'Cargando transacciones...',
    loadMore: 'Cargar más',
    transactionDate: 'Fecha de transacción',
    error: {
      fetching: 'Error al obtener las transacciones.',
    },
    refund: {
      success: '¡Reembolso exitoso!',
      error: 'Error de reembolso: {{error}}',
      confirmPrompt:
        '¿Está seguro que desea reembolsar el monto total de esta transacción?',
      processing: 'Procesando reembolso...',
      confirmButton: 'Reembolsar {{amount}} {{emoji}}',
      completed: 'Reembolsado',
      issueButton: 'Emitir reembolso',
    },
    refundId: 'ID de reembolso',
    addressLine1: 'Dirección línea 1',
    addressLine2: 'Dirección línea 2',
    amount: 'Monto',
    duration: 'Duración',
    durationDays: '{{days}} días',
    taxAmount: 'Monto de impuesto',
    taxRegion: 'Región fiscal',
    taxRate: 'Tasa de impuesto',
    id: 'ID de transacción',
    filters: {
      title: 'Filtrar transacciones',
      transactionId: 'ID de transacción',
      userUuid: 'UUID del usuario',
      externalId: 'ID externo',
      product: 'Producto',
      serviceName: 'Nombre del servicio',
      formName: 'Nombre del formulario',
      transactionState: {
        label: 'Estado de la transacción',
        all: 'Todos los estados',
        succeeded: 'Completada',
        failed: 'Fallida',
        gateway_processing_failed: 'Error de procesamiento',
        gateway_processing_result_unknown: 'Estado de pasarela desconocido',
      },
      transactionType: {
        label: 'Tipo de transacción',
        all: 'Todos los tipos',
        purchase: 'Compra',
        authorization: 'Autorización',
        capture: 'Captura',
        credit: 'Crédito',
        refund: 'Reembolso',
        void: 'Anulación',
        replace_payment_method: 'Reemplazar método de pago',
        invalid_replace_payment_method: 'Reemplazo inválido de método de pago',
        contact_card_holder: 'Contactar al titular',
        close_payment_method: 'Cerrar método de pago',
      },
      application: {
        label: 'Aplicación',
        all: 'Todas las aplicaciones',
        subscriptions: 'Suscripciones',
        forms: 'Formularios',
        adowl: 'AdOwl',
        classifieds: 'Clasificados',
      },
      testStatus: {
        label: 'Estado de prueba',
        all: 'Todos',
        test: 'Prueba',
        live: 'Activa',
      },
      paymentHandler: {
        label: 'Procesador de pagos',
        all: 'Todos los procesadores',
        payflow_pro: 'Payflow Pro',
        elavon_authorize: 'Elavon Authorize',
        paypal: 'PayPal',
        adyen: 'Adyen',
        other: 'Otro',
      },
      paymentType: {
        label: 'Tipo de pago',
        all: 'Todos los tipos',
        purchase: 'Compra',
        authorization: 'Autorización',
        capture: 'Captura',
        credit: 'Crédito',
        refund: 'Reembolso',
        void: 'Anulación',
        replace_payment_method: 'Reemplazar método de pago',
        invalid_replace_payment_method: 'Reemplazo inválido de método de pago',
        contact_card_holder: 'Contactar al titular',
        close_payment_method: 'Cerrar método de pago',
      },
      subscriptionService: {
        label: 'Servicio de suscripción',
        all: 'Todos los servicios',
        digital_access: 'Acceso digital',
        print_delivery: 'Entrega impresa',
      },
      citMit: {
        label: 'CIT / MIT',
        all: 'Todos',
        cit: 'CIT',
        mit: 'MIT',
      },
      initiatedBy: {
        label: 'Iniciada por',
        all: 'Todos',
        customer: 'Cliente',
        admin: 'Administrador NXT',
        system: 'Sistema',
      },
      lifecycle: {
        label: 'Ciclo de suscripción',
        all: 'Todos',
        renewal: 'Renovación',
        new_start: 'Nuevo inicio',
      },
      dateFrom: 'Fecha de transacción desde',
      dateTo: 'Fecha de transacción hasta',
      transactionDate: 'Rango de fechas de la transacción',
    },
    table: {
      date: 'Fecha / hora',
      customer: 'Nombre del cliente',
      type: 'Tipo',
      amount: 'Monto',
      state: 'Estado',
      paymentHandler: 'Procesador de pagos',
      email: 'Correo electrónico',
      application: 'Aplicación',
      test: 'Prueba',
      stateValues: {
        succeeded: 'Completada',
        failed: 'Fallida',
        gateway_processing_failed: 'Error de procesamiento',
        gateway_processing_result_unknown: 'Estado de pasarela desconocido',
      },
    },
    search: {
      placeholder: 'Buscar transacciones...',
    },
    breadcrumbs: {
      backToSearch: 'Volver a los resultados de búsqueda',
      search: 'Búsqueda de transacciones',
    },
    detail: {
      untitled: 'Detalles de la transacción',
      customer: 'Cliente',
      customerName: 'Nombre del cliente',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      openCustomerProfile: 'Abrir perfil del cliente',
      addresses: {
        billing: 'Dirección de facturación',
        shipping: 'Dirección de envío',
      },
      transaction: 'Detalles de la transacción',
      message: 'Mensaje',
      error: 'Error',
      paymentHandler: 'Procesador de pagos',
      transactionId: 'ID de transacción',
      description: 'Descripción',
      overviewTitle: 'Resumen de la transacción',
      totalAmount: 'Monto total',
      date: 'Fecha',
      latestActivity: 'Actividad reciente',
      paymentMethodTitle: 'Método de pago',
      viewCard: 'Ver tarjeta',
      unknownProcessor: 'Procesador desconocido',
      paymentUnavailable: 'Detalles de pago no disponibles.',
      statusUpdate: 'Actualización de estado',
      testTransaction: 'Transacción de prueba',
      liveTransaction: 'Transacción en producción',
      testModeLabel: 'Modo',
      gatewayDetails: 'Detalles de la pasarela',
      metadata: 'Metadatos',
      processedBy: 'Procesada por',
      userWidgetTitle: 'Usuario',
      user: {
        loadError: 'No se pudo cargar la información del usuario.',
        noUser: 'Ningún usuario está asociado a esta transacción.',
      },
      errors: {
        notFound: 'Transacción no encontrada',
        missingId: 'Falta el ID de la transacción',
        missingUserId: 'Falta el ID del usuario',
        missingPaymentIdentifiers: 'Faltan identificadores del método de pago',
      },
      fields: {
        state: 'Estado',
        paymentToken: 'Token de pago',
        avsResponse: 'Respuesta AVS',
        cvvResponse: 'Respuesta CVV',
        spreedlyToken: 'Token de Spreedly',
        ipAddress: 'Dirección IP',
        rateName: 'Nombre de la tarifa',
        recurring: 'Recurrente',
      },
      recurring: {
        yes: 'Sí',
        no: 'No',
      },
    },
  },
  paymentMethod: {
    label: 'Método de pago',
    changeButton: 'Cambiar método de pago',
    expiredWarning: 'Esta tarjeta ha caducado y debe actualizarse.',
    selectTitle: 'Seleccionar método de pago',
    noMethodAvailable: 'No hay métodos de pago disponibles.',
    preferred: 'Preferido',
    expired: 'Caducado',
    expires: 'Caduca',
    addCard: 'Añadir tarjeta',
    addNewCard: 'Añadir nueva tarjeta',
    addCardCaption: 'O añadir una tarjeta',
    failedToLoad: 'No pudimos cargar tus métodos de pago. Por favor, inténtalo de nuevo.',
    noValidPaymentMethods: 'No se encontraron métodos de pago válidos para esta cuenta.',
    new_card_success: 'Nueva tarjeta agregada exitosamente',
    removeError: 'No se pudo eliminar el método de pago',
    updateError: 'No se pudo actualizar el método de pago',
    notAvailable: 'N/D',
    details: {
      title: 'Detalles del pago',
      cardholder: 'Titular de la tarjeta',
      name: 'Nombre',
      expiration: 'Vencimiento',
      billingAddress: 'Dirección de facturación',
      street: 'Calle',
      cityStateZip: 'Ciudad / Estado / Código postal',
      country: 'País',
      activity: 'Actividad',
      created: 'Creado',
      lastUpdated: 'Última actualización',
      addedVia: 'Añadido vía {{wallet}}',
      paypalAccount: 'Cuenta de PayPal',
      wallet: 'Cartera',
      unknownCard: 'Tarjeta desconocida',
    },
  },
  detail: {
    loading: 'Cargando detalles de la suscripción...',
  },
  ltv: {
    defaultName: 'Este cliente',
    tooltipText:
      'El valor de vida (LTV) es la suma de los pagos de este cliente a lo largo de la vida de sus suscripciones y cualquier otra transacción a través de BLOX.',
    label: 'LTV del cliente:',
    shortLabel: 'LTV:',
    hasContributed: 'ha contribuido {{amount}}',
    hasNotContributed: 'no ha contribuido',
    since: ' desde {{startdate}}',
  },
  search: {
    new_starts: 'Nuevos Inicios',
    new_starts_info: 'Activos y comenzados en los últimos 30 días',
    stops: 'Paradas',
    stops_info: 'Cancelados en los últimos 30 días',
  },
  rate_modal: {
    title: {
      add: 'Agregar tarifa',
      edit: 'Editar tarifa',
    },
    actions: {
      save: 'Guardar',
      saving: 'Guardando...',
      cancel: 'Cancelar',
    },
    sections: {
      general: 'General',
      lifecycle: 'Ciclo de vida',
      transition: 'Configuraciones de transición',
      additional_settings: 'Configuraciones adicionales',
      preview: 'Vista previa',
    },
    messages: {
      failed_to_save: 'Error al guardar la tarifa',
      fix_validation_errors:
        'Por favor, corrige los errores de validación a continuación.',
    },
    service_warnings: {
      disabled:
        'Este servicio está deshabilitado, por lo que los usuarios no pueden comprar esta tarifa hasta que el servicio esté habilitado.',
      hidden:
        'Este servicio está oculto, por lo que los usuarios no pueden comprar esta tarifa hasta que el servicio esté habilitado.',
      test: 'Este servicio está en modo de prueba, por lo que esta tarifa solo se puede comprar con tarjetas de prueba.',
    },
    promo_code_validation: {
      empty: 'El código promocional no puede estar vacío',
      max_length: 'El código promocional no puede exceder 50 caracteres',
      invalid_format:
        'El código promocional solo puede contener letras, números, guiones y guiones bajos',
      duplicate: 'Este código promocional ya existe',
    },
    fields: {
      name: {
        label: 'Nombre de la tarifa',
        validation: {
          required: 'El nombre de la tarifa es obligatorio',
          max_length: 'El nombre de la tarifa no puede exceder 40 caracteres',
        },
        description:
          'Este nombre aparecerá en la búsqueda de administración y en los correos electrónicos de los clientes (máx. 40 caracteres)',
      },
      campaign: {
        recurrence: {
          description:
            'Elige con qué frecuencia se repite la campaña y en qué días se enviará.',
          frequency_label: '¿Con qué frecuencia?',
          frequency_options: {
            weekly: 'Cada semana',
            biweekly: 'Cada dos semanas',
            every_four_weeks: 'Cada cuatro semanas',
          },
          custom_label: 'Personalizado',
          custom_every_prefix: 'Cada',
          week_singular: 'semana',
          week_plural: 'semanas',
          days_heading: '¿Qué días?',
          days_presets: {
            weekdays: 'Entre semana',
            weekends: 'Fines de semana',
            mwf: 'Lun/Mié/Vie',
            tth: 'Mar/Jue',
          },
          monthly_heading: '¿Cuándo en el mes?',
        },
      },
      price: {
        label: 'Precio',
        placeholder: '0,00',
        validation: {
          required: 'El precio es obligatorio',
          valid_price: 'Por favor, ingrese un precio válido',
          greater_than_zero: 'El precio debe ser mayor a $0,00',
          max_amount: 'El precio no puede exceder $999.999,99',
        },
        help: {
          format: 'Ingrese el monto en dólares (ej., 4,50 para $4,50)',
          editing_disabled: 'El precio no se puede editar después del guardado inicial',
        },
      },
      duration: {
        label: 'Duración (días)',
        validation: {
          required: 'Se requiere una duración válida',
          valid_number: 'Por favor, ingrese un número de días válido mayor a 0',
        },
        help: {
          format: 'Duración en días (ej., 28)',
          editing_disabled: 'La duración no se puede editar después del guardado inicial',
        },
      },
      terms: {
        label: 'Términos',
        description: 'Términos legales para esta tarifa',
      },
      start_date: {
        label: 'Fecha y hora de inicio',
        description: 'Cuándo la tarifa estará disponible (por defecto es ahora)',
      },
      always_available: {
        label: 'La tarifa está siempre disponible',
      },
      end_date: {
        label: 'La tarifa termina el',
        description: 'Cuándo la tarifa deja de estar disponible',
      },
      hide_date: {
        label: 'Disponible hasta',
        description: 'Última fecha y hora en que se puede comprar la tarifa',
      },
      enable_rate_changes: {
        label: 'Habilitar cambios de tarifa',
      },
      end_cycles: {
        label: 'Total de transacciones',
        validation: {
          required: 'El total de transacciones es obligatorio',
          valid_number: 'Por favor, ingrese un número de transacciones válido mayor a 0',
        },
        description: 'Número de veces que se cobrará esta tarifa antes de la transición',
      },
      end_id: {
        label: 'Seguido por',
        validation: {
          required: 'Debe seleccionar una tarifa de seguimiento',
        },
        placeholder: {
          loading: 'Cargando tarifas...',
          search: 'Buscar y seleccionar una tarifa...',
        },
        help: {
          loading: 'Cargando tarifas disponibles...',
          choose: 'Elegir entre {{count}} tarifas activas',
        },
        no_options: {
          loading: 'Cargando tarifas...',
          no_rates: 'No hay tarifas activas disponibles',
          no_match: 'Ninguna tarifa coincide con su búsqueda',
        },
      },
      save_rate: {
        label: 'Tarifa de guardado para cancelación',
        description:
          'Hacer de esta tarifa una "Tarifa de guardado" para ofertas de retención en cancelaciones',
      },
      hidden: {
        label: 'Ocultar tarifa del sitio web',
        description:
          'Esta tarifa solo se usará para transacciones de renovación automática',
        warning:
          'Ocultar esta tarifa no permitirá que los usuarios la compren en el sitio web. Esta tarifa solo se puede usar para transacciones de renovación automática. Para permitir que los usuarios la compren, desactive "Ocultar tarifa".',
      },
      external_id: {
        label: 'ID externo',
        description: 'Identificador opcional para integración con sistemas externos',
        placeholder: 'Ingrese el identificador externo (opcional)',
        validation: {
          max_length: 'El ID externo no puede exceder 100 caracteres',
        },
      },
      promo_needs_code: {
        label: 'Requerir código promocional',
        description:
          'Los usuarios deben ingresar un código promocional para acceder a esta tarifa',
      },
      promo_codes: {
        label: 'Códigos promocionales',
        placeholder: 'Ingrese códigos promocionales (ej., SAVE20, WELCOME)',
        validation: {
          required_when_enabled:
            'Se requiere al menos un código promocional cuando "Requerir código promocional" está habilitado',
        },
        help: {
          mobile: 'Toque Enter para agregar códigos. Toque chips para eliminar.',
          desktop:
            'Presione Enter o coma para agregar códigos promocionales. Use Retroceso para eliminar el último código.',
          validation_rules:
            'Los códigos promocionales se convierten automáticamente a mayúsculas y solo pueden contener letras, números, guiones y guiones bajos. Máximo 50 caracteres cada uno.',
        },
        warning: {
          required_but_empty:
            'Ha habilitado "Requerir código promocional" pero no ha agregado ningún código promocional. Los usuarios no podrán acceder a esta tarifa hasta que agregue al menos un código promocional.',
        },
      },
    },
    transition: {
      for: 'por',
      days: 'días',
      save_rate_chip: 'TARIFA GUARDADO',
      ends: 'TERMINA',
    },
    preview: {
      title: 'Vista previa de la tarifa',
      new_rate: 'Nueva tarifa',
      for: 'por',
      days: 'días',
      charged: 'Cobrado',
      time: 'vez',
      times: 'veces',
      then: 'luego',
      auto_renews_indefinitely: 'Luego se renueva automáticamente indefinidamente',
      expires_without_auto_renewal: 'Luego expira sin renovación automática',
      terms: 'Términos',
      promo_codes: 'Códigos promocionales',
      required: 'Requerido',
      blox_rate_id: 'ID de tarifa BLOX',
      external_id: 'ID externo',
      will_be_generated: 'Se generará al guardar',
      copy_blox_rate_id: 'Copiar ID de tarifa BLOX',
      blox_rate_id_copied: '¡ID de tarifa BLOX copiado!',
      copy_external_id: 'Copiar ID externo',
      external_id_copied: '¡ID externo copiado!',
    },
  },
  deliveryPhone: 'Teléfono de entrega',
  deliveryAddress: {
    label: 'Dirección de entrega',
    edit: 'Editar dirección de entrega',
    editTitle: 'Editar dirección de entrega',
    line1: 'Línea de dirección 1',
    line2: 'Línea de dirección 2',
    city: 'Ciudad',
    state: 'Estado/Región',
    country: 'País',
    zip: 'Código postal',
    phone: 'Número de teléfono',
    phoneHelperText: 'Por favor, ingrese un número de teléfono válido de 10 dígitos',
    requiredFields: 'Por favor, complete todos los campos obligatorios',
    invalidPhone: 'Por favor, ingrese un número de teléfono válido',
    updateSuccess: 'Dirección de entrega actualizada con éxito',
    updateError: 'Error al actualizar la dirección de entrega: {error}',
  },
  new_sub_wizard: {
    title: 'Iniciar una nueva suscripción',
    steps: {
      userDetails: 'Detalles del usuario',
      packageSelection: 'Selección de paquete',
      paymentDetails: 'Detalles de pago',
      reviewPurchase: 'Revisar y comprar',
      confirmation: 'Confirmación',
    },
    buttons: {
      processing: 'Procesando...',
      createUserAndContinue: 'Crear usuario y continuar',
      purchase: 'Comprar',
      returnToReview: 'Volver a la revisión',
      next: 'Siguiente',
      closeWizard: 'Cerrar asistente',
    },
    notifications: {
      userCreated: 'Nueva cuenta de usuario creada con éxito',
      subscriptionCreated: 'Suscripción creada con éxito',
      passwordResetSent:
        'Usuario creado y correo de restablecimiento de contraseña enviado con éxito',
      passwordResetError:
        'Error al enviar el correo de restablecimiento de contraseña: {{message}}',
      subscriptionError: 'Error al crear la suscripción: {{message}}',
      fetchUserError: 'Error al obtener los datos del usuario: {{message}}',
    },
    errors: {
      missingData: 'Faltan datos requeridos para la compra',
    },
    review: {
      title: 'Revisar y comprar',
      confirmationEmail: 'Se enviará un correo de confirmación a:',
      cards: {
        userInformation: 'Información del usuario',
        subscription: 'Suscripción',
        paymentAndSubscription: 'Pago y suscripción',
      },
      labels: {
        name: 'Nombre',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        primaryAddress: 'Dirección principal',
        service: 'Servicio',
        freeServiceFallback: 'Servicio gratuito',
        deliveryAddress: 'Dirección de entrega',
        deliveryRequired: 'Se requiere una dirección de entrega para este servicio.',
        cost: 'Costo',
        freeServiceCost: 'No se requiere pago (servicio gratuito)',
        billingAddress: 'Dirección de facturación',
        plan: 'Plan',
        pricing: 'Precio',
        subtotal: 'Subtotal',
        tax: 'Impuesto',
        total: 'Total',
      },
      editMenu: {
        editPayment: 'Editar pago',
        editSubscription: 'Editar suscripción',
      },
      errors: {
        missingInfo: 'Falta información requerida para la revisión.',
        missingRate: 'Falta la tarifa requerida para un servicio de pago.',
        missingPaymentMethod:
          'Falta el método de pago requerido para un servicio de pago.',
        taxQuoteWarning:
          'Estimación de impuestos no disponible. Los impuestos se calcularán al finalizar la compra y pueden no reflejarse en el total mostrado.',
        taxUnavailable: 'No disponible',
      },
    },
  },
  cancel_wizard: {
    title: 'Cancelar suscripción',
    steps: {
      reason: 'Motivo',
      offers: 'Ofertas',
      review: 'Revisión',
      confirmation: 'Confirmación',
    },
    buttons: {
      processing: 'Procesando...',
      continue_to_cancel: 'No, continuar con la cancelación',
      confirm_rate_change: 'Confirmar cambio de tarifa',
      confirm_cancel: 'Confirmar cancelación',
      accept_offer: 'Sí, aceptar oferta',
      select_rate_placeholder: 'Por favor, seleccione una tarifa...',
    },
    notifications: {
      cancel_success: 'Suscripción cancelada',
      update_success: 'Suscripción actualizada',
    },
    alerts: {
      expire_warning: 'La suscripción de {{name}} vencerá el',
      loading_error:
        'Error al cargar los datos. Por favor, inténtelo de nuevo más tarde.',
    },
    cancel_reasons: {
      title: '¿Por qué desea cancelar?',
      select_reason: 'Seleccione un motivo',
      notes_label: 'Notas',
      notes_helper: '{{count}}/200 caracteres',
      error_fetching: 'Error al obtener los motivos de cancelación.',
      benefits_lost: 'Después de esa fecha, se perderá el acceso a estos beneficios:',
    },
    errors: {
      fetching_benefits: 'Error al obtener los detalles de beneficios.',
    },
    save_offers: {
      title: '¿Podemos ofrecerle un precio especial para quedarse?',
      current_rate: 'La tarifa actual de {{name}} es {{price}} / {{duration}}',
      show_hidden_rates: 'Mostrar tarifas ocultas',
      save_offers_only: 'Solo ofertas de retención',
      will_pay: 'pagará',
      same_amount: 'la misma cantidad.',
      select_rate_prompt: 'Por favor, seleccione una tarifa para comparar.',
      save_offer_chip: 'Oferta de retención',
      no_results: 'No se encontraron resultados.',
      showing_results: 'Mostrando {{shown}} de {{total}} resultados totales.',
      error_fetching_rates: 'Error al obtener las tarifas de comparación.',
      no_other_rates: 'No hay otras tarifas disponibles.',
      rates_label: 'Tarifas',
      compare: {
        daily: 'Diario',
        monthly: 'Mensual',
        yearly: 'Anual',
        less: 'menos',
        more: 'más',
      },
    },
    review: {
      title: 'Revisar y confirmar cambios',
      changing_rate: '{{name}} está cambiando a una nueva tarifa.',
      new_rate_begins: 'La nueva tarifa comienza el {{date}}',
      card_will_be_charged: 'Se cobrará {{amount}} a la tarjeta registrada',
      terms_prefix: 'Términos:',
      benefits_lost: 'Después de esa fecha, se perderá el acceso a estos beneficios:',
      error_fetching_benefits: 'Error al obtener los detalles de beneficios.',
    },
    confirm: {
      new_rate_title: 'Confirmado — Nueva tarifa aceptada',
      cancel_title: 'Confirmado — Suscripción cancelada',
      subscription_updated: 'La suscripción de {{name}} ha sido actualizada.',
      subscription_canceled: 'La suscripción de {{name}} ha sido cancelada.',
      new_rate_begins: 'La nueva tarifa comienza el {{date}}',
      access_ends: 'El acceso finalizará el {{date}}.',
      confirmation_email_sent: 'Se ha enviado un correo de confirmación a',
    },
  },
};

const bloxSpanishServiceMessages = {
  label: 'Servicios',
  breadcrumbs: {
    backToSearch: 'Volver a los resultados de búsqueda',
    search: 'Búsqueda de servicios',
  },
  delimited: {
    manager: {
      steps: {
        uploadFile: 'Cargar Archivo',
        mapColumns: 'Mapear Columnas',
        cleanData: 'Limpiar Datos',
        confirmImport: 'Confirmar Importación',
        results: 'Resultados',
      },
      processing: {
        uploading: 'Cargando tu archivo...',
        verifying: 'Verificando datos...',
        checkingErrors: 'Verificando errores...',
      },
      navigation: {
        back: 'Atrás',
        next: 'Siguiente',
        startImport: 'Iniciar Importación',
        processing: 'Procesando...',
        selectFile: 'Selecciona un archivo para continuar',
      },
      errors: {
        unknownStep: 'Paso desconocido',
        unresolvedErrors:
          'No puedes continuar hasta que se corrijan todos los errores. Edita cada fila con un problema y vuelve a intentar Siguiente.',
      },
      confirmMappingDialog: {
        title: 'Confirmar Actualizaciones de Mapeo',
        unmapped: 'No mapeado',
        columnLabel: 'Columna {{value}}',
        headerLabel: 'Fila de encabezados',
        delimiterLabel: 'Delimitador',
        enclosureLabel: 'Calificador de texto',
        messageWithChangesIntro:
          'Guardar este mapeo de columnas actualizará lo siguiente:',
        message:
          'Guardar este mapeo de columnas actualizará la configuración del servicio para todas las cargas futuras. ¿Continuar?',
        unsetValue: 'Ninguno',
        headerEnabled: 'Fila de encabezados: Activada',
        headerDisabled: 'Fila de encabezados: Desactivada',
      },
    },
    upload: {
      title: 'Cargar Archivo CSV',
      subtitle:
        'Selecciona o arrastra tu archivo CSV para comenzar el proceso de importación',
      dropzone: {
        processing: 'Procesando tu archivo...',
        validating: 'Validando datos y verificando errores',
        invalidFile: 'Archivo inválido seleccionado',
        selectValid: 'Por favor selecciona un archivo CSV válido',
        fileReady: 'Archivo listo para importar',
        dropHere: 'Suelta tu archivo CSV aquí',
        orBrowse: 'o haz clic para buscar',
        maxSize: 'Tamaño máximo: 50MB • Solo formato CSV',
      },
      buttons: {
        removeFile: 'Eliminar Archivo',
        changeFile: 'Cambiar Archivo',
        showLess: 'Mostrar Menos',
        viewAll: 'Ver Todas las {{count}} Filas',
      },
      settings: {
        hasHeaders: {
          label: 'La primera fila contiene encabezados',
          withHeaders: 'Los encabezados se usarán para el mapeo de columnas',
          withoutHeaders: 'Las columnas se nombrarán genéricamente',
        },
      },
      stats: {
        rows: 'Filas',
        columns: 'Columnas',
      },
      preview: {
        title: 'Vista Previa de Datos',
        showingAll: 'Mostrando todas las {{count}} filas',
        showingPartial: 'Mostrando las primeras {{shown}} de {{total}} filas',
        empty: 'vacío',
        showLess: 'Mostrar solo vista previa',
        viewAll: 'Ver todas las filas',
      },
      errors: {
        validation: {
          title: 'Error de Validación de Archivo',
          invalidType:
            'Tipo de archivo inválido. Por favor carga un archivo CSV. Cargaste: {{fileName}}',
          invalidFormat:
            'Formato de archivo inválido. Se esperaba CSV pero se obtuvo {{fileType}}',
          tooLarge: 'Archivo muy grande ({{size}}). El tamaño máximo es 50MB.',
          empty: 'El archivo está vacío. Por favor carga un archivo CSV con datos.',
          onlyOne: 'Solo se puede proporcionar un archivo a la vez.',
        },
        upload: {
          title: 'Carga Fallida',
          helpText:
            'Por favor verifica el formato del archivo e intenta nuevamente. Si el problema persiste, contacta soporte.',
        },
        processing: {
          title: 'Problemas al Procesar el Archivo',
          description:
            'El archivo se cargó pero no se pudo procesar correctamente. Causas comunes:',
          causes: {
            delimiter: 'Delimitador incorrecto (debe ser separado por comas)',
            encoding: 'Problemas de codificación de texto (guardar como UTF-8)',
            structure: 'Estructura CSV mal formada',
            dataTypes: 'Tipos de datos mezclados en columnas',
          },
          suggestion:
            'Intenta abrir en una aplicación de hoja de cálculo y volver a guardar como CSV (UTF-8).',
        },
      },
    },
    mapping: {
      title: 'Mapear Columnas CSV',
      subtitle:
        'Relaciona tus columnas CSV con los campos del sistema para una importación adecuada',
      detection: {
        title: 'Detección de Columnas',
        allMapped: 'Todos los campos requeridos mapeados',
        fieldsDetected: '{{count}} campos auto-detectados',
        instruction: 'Mapea tus columnas CSV a los campos del sistema',
        retrying: 'Reintentando la detección con IA (intento {{attempt}} de {{max}})',
      },
      buttons: {
        aiDetect: 'Auto-Detección IA',
        reDetect: 'Re-detectar',
        detecting: 'Detectando...',
        retrying: 'Reintentando...',
      },
      field: {
        selectPlaceholder: 'Seleccionar campo...',
        sample: 'Muestra: {{value}}',
        mappedTo: 'Mapeado a {{fieldName}}',
        used: 'Usado',
        required: 'Requerido',
      },
      alerts: {
        success: 'IA mapeó {{count}} columnas exitosamente',
        error: {
          title: 'Detección IA Falló',
          generic: 'El mapeo con IA falló. Por favor mapea las columnas manualmente.',
          instruction:
            'Por favor mapea tus columnas manualmente usando los menús desplegables.',
        },
        missingFields: {
          title: 'Campos requeridos faltantes',
          fields: '{{fields}}',
        },
      },
      ai: {
        analyzing: 'La IA está analizando tus columnas',
        detecting: 'Detectando las mejores coincidencias...',
        retrying:
          'Reintentando después de un error temporal (intento {{attempt}} de {{max}})...',
        badge: 'IA',
      },
      autoMap: {
        noHeaders: 'El mapeo con IA requiere encabezados en el archivo CSV',
      },
    },
    cleanup: {
      title: 'Revisar la calidad de los datos',
      subtitle: 'Revise y corrija cualquier problema de datos antes de importar',

      checking: {
        checking: 'Verificando errores',
        rechecking: 'Verificando errores nuevamente',
        attempt: 'Verificación #{{attempt}}',
      },

      recheck: {
        info: 'Se corrigieron {{fixed}} de {{previous}} errores. {{remaining}} error{{plural}} restante{{plural}}.',
        success: '¡Se corrigieron exitosamente los {{count}} errores!',
      },

      healthScore: {
        title: 'Puntuación de salud de datos',
        description: '{{clean}} de {{total}} filas están limpias',
      },

      pending: {
        title: '{{count}} cambio{{plural}} pendiente{{plural}}',
        description:
          '{{modified}} edición{{modifiedPlural}}, {{deleted}} eliminación{{deletedPlural}} sin aplicar',
        apply: 'Aplicar cambios ({{count}})',
        discard: 'Descartar',
      },

      rowEditModal: {
        title: 'Editar fila {{row}}',
        titleNoRow: 'Editar fila',
        saveRow: 'Guardar fila',
        deleteRow: 'Eliminar fila',
        noChanges:
          'No se hicieron cambios. Actualice un campo para resolver el problema.',
      },

      alerts: {
        summary:
          'Se encontraron {{errors}} problema{{errorPlural}} en {{rows}} fila{{rowPlural}}. Haga clic en Editar para corregirlos.',
        noErrors: {
          title: '¡Perfecto! Todos los datos validados',
          description:
            'Sus datos están limpios y listos para importar sin problemas detectados',
        },
        tooManyErrors: {
          title: 'Demasiados errores para editar',
          description:
            'Este archivo CSV contiene demasiados errores para corregirlos aquí. Revise y corrija el archivo de origen, luego cárguelo de nuevo.',
        },
      },

      table: {
        title: {
          default: 'Datos con problemas',
          editMode: 'Haga clic en cualquier celda para editar',
        },
        headers: {
          row: 'Fila',
          more: 'Más',
          issues: 'Problemas',
          actions: 'Acciones',
        },
        moreFields: '+{{count}} campos',
        issueCount: '{{count}} problema{{plural}}',

        expanded: {
          issuesFound: 'Problemas encontrados en la fila {{row}}:',
          editData: 'Editar datos de la fila:',
          viewData: 'Datos de la fila:',
          collapse: 'Contraer',
          expand: 'Expandir para ver todos los campos',
          enterValue: 'Ingrese {{header}}',
          deletedNotice:
            'Esta fila ha sido marcada para eliminación y se eliminará durante la importación.',
        },

        chips: {
          deleted: 'Eliminado',
          modified: 'Modificado',
        },

        showing: {
          all: 'Mostrando todas las {{count}} filas con errores',
          partial: 'Mostrando {{shown}} de {{total}} filas con errores',
        },

        buttons: {
          viewAll: 'Ver las {{count}} filas con errores',
          showLess: 'Mostrar menos',
        },

        actions: {
          editRow: 'Editar',
          deleteRow: 'Eliminar fila',
          undoDelete: 'Deshacer eliminación',
        },

        badges: {
          modified: 'M',
          deleted: 'E',
        },

        empty: '-',
      },

      errors: {
        truncated: '+{{count}}',
      },

      tooltips: {
        showAll: 'Ver todas las filas con errores',
        showLess: 'Mostrar solo vista previa',
      },
    },
    dataViewer: {
      title: 'Carga de Archivo',
      uploadCsvButton: 'Cargar CSV',
      exportButton: 'Exportar',
      lastUpdated: 'última actualización: hace {{relative}}',
      download: {
        tooltip: 'Descargar el archivo procesado más reciente',
      },
      preview: {
        title: 'Vista Previa de Datos',
        showing: 'Mostrando los primeros {{shown}} de {{total}} registros',
      },
      search: {
        placeholder: 'Buscar registros...',
        clear: 'Limpiar búsqueda',
      },
      viewAll: 'Ver todos los {{total}} registros',
      empty: {
        noRecords: 'Aún no se han procesado registros de suscriptores.',
        noMatches: 'Ningún registro coincide con tu búsqueda.',
      },
      errors: {
        loadFailed: 'No se pudieron cargar los registros de suscriptores.',
      },
      export: {
        queued:
          'Preparando la exportación CSV. Recibirás una notificación cuando esté lista para descargar.',
        error: 'No se pudo iniciar la exportación CSV.',
      },
      modal: {
        title: 'Todos los Registros',
        subtitle: 'Total: {{total}} registros',
        downloadCsv: 'Descargar CSV',
        loadingMore: 'Cargando más registros...',
      },
    },
    preview: {
      title: 'Revisar y Confirmar Importación',
      subtitle: 'Revisa tus datos antes de importar',
      summary: {
        title: 'Resumen de Importación',
        fileName: 'Nombre del Archivo',
        totalRecords: 'Total de Registros',
        recordsCount: '{{count}} filas',
        dataStatus: 'Estado de Datos',
        allValid: 'Todas las filas válidas',
        validWithIssues: '{{valid}} válidas / {{errors}} con problemas',
        unknown: 'Desconocido',
      },
      alerts: {
        warning: {
          title: '{{count}} filas tienen problemas.',
          description:
            'Estas filas pueden fallar durante la importación. Puedes regresar al paso anterior para corregirlas o proceder con la importación.',
        },
        success: {
          title: 'Listo para importar {{count}} registros.',
          description: 'Haz clic en "Iniciar Importación" para comenzar el proceso.',
        },
      },
      dataPreview: {
        title: 'Vista Previa de Datos',
        showingAll: 'Mostrando todas las {{count}} filas',
        showingPartial: 'Mostrando las primeras {{shown}} de {{total}} filas',
        empty: 'vacío',
        buttons: {
          showLess: 'Mostrar Menos',
          viewAll: 'Ver Todas las {{count}} Filas',
        },
      },
      tooltips: {
        showAll: 'Ver todas las filas',
        showLess: 'Mostrar solo vista previa',
      },
    },
    results: {
      title: 'Importación Completa',
      subtitle: 'Tu importación ha sido procesada',
      success: {
        title: 'Importación Completada Exitosamente',
        description: '{{count}} registros han sido importados a tu sistema',
      },
      error: {
        title: 'Importación Fallida',
        duplicateAccount:
          'Número de cuenta duplicado "{{account}}" encontrado en la línea {{line}}',
      },
      summary: {
        title: 'Resumen de Importación',
        fileName: 'Nombre del Archivo',
        recordsCount: '{{count}} filas',
        rowsProcessed: 'Filas Procesadas',
        completedAt: 'Completado a las',
        status: 'Estado',
        statusSuccess: 'Éxito',
        statusFailed: 'Fallido',
        unknown: 'Desconocido',
      },
      help: {
        title: 'Qué hacer a continuación:',
        items: {
          checkDuplicates: 'Verifica números de cuenta duplicados en tu archivo CSV',
          ensureFields:
            'Asegúrate de que todos los campos requeridos estén mapeados correctamente',
          fixRows: 'Elimina o corrige las filas problemáticas e intenta nuevamente',
          contactSupport: 'Contacta soporte si el problema persiste',
        },
      },
      preview: {
        title: 'Vista Previa de Registros Importados',
        showingAll: 'Mostrando todos los {{count}} registros importados',
        showingPartial: 'Mostrando los primeros {{shown}} registros importados',
        empty: 'vacío',
        buttons: {
          showLess: 'Mostrar Menos',
          viewAll: 'Ver Todos los {{count}} Registros',
        },
      },
      tooltips: {
        showAll: 'Ver todos los registros',
        showLess: 'Mostrar solo vista previa',
      },
    },
  },
  details: {
    label: 'Detalles del servicio',
    loading: 'Cargando servicio',
    error: {
      missingId: 'Error: Falta el ID del servicio en la URL',
      loading: 'Error al cargar los detalles del servicio',
      update: 'Error al actualizar el servicio: {{message}}',
      copy: 'Error al copiar el ID del servicio',
      create: 'Error al crear el servicio',
    },
    success: {
      update: 'Servicio actualizado correctamente',
      create: 'Servicio creado correctamente',
      copy: '¡Copiado!',
    },
    header: {
      serviceId: 'ID: {{id}}',
      copyTooltip: 'Copiar ID',
      copyAriaLabel: 'Copiar ID del servicio',
      sectionLabel: 'Servicios',
      save: 'Guardar',
      saveChanges: 'Guardar cambios',
      saving: 'Guardando',
      savingWithEllipsis: 'Guardando...',
      createService: 'Crear servicio',
      creatingWithEllipsis: 'Creando...',
      expandDetails: 'Expandir detalles',
      collapseDetails: 'Contraer detalles',
    },
    sections: {
      serviceSettings: 'Configuración del servicio',
      purchaseRates: 'Tarifas de compra',
      emailNotifications: 'Notificaciones por correo',
      domainManagement: 'Gestión de dominios',
      fileUpload: 'Carga de archivo',
    },
    accordions: {
      generalSettings: {
        label: 'Configuración general',
      },
      configuration: {
        label: 'Configuración',
      },
      customProperties: {
        label: 'Propiedades personalizadas',
      },
    },
    warnings: {
      title: 'Confirmar cambio',
      disabled: {
        enable: {
          message:
            'Habilitar este servicio permitirá a los usuarios comprar y renovar suscripciones. ¿Está seguro de que desea habilitar este servicio?',
          confirmButton: 'Sí, habilitar servicio',
        },
        disable: {
          message:
            'Deshabilitar este servicio cancelará las suscripciones e interrumpirá las renovaciones. ¿Está seguro de que desea deshabilitar este servicio?',
          confirmButton: 'Sí, deshabilitar servicio',
        },
      },
      hidden: {
        hide: {
          message:
            'Ocultar este servicio evitará que los usuarios lo vean, pero aún podrán vincularse automáticamente a él. ¿Está seguro de que desea ocultar este servicio?',
          confirmButton: 'Sí, ocultar servicio',
        },
        unhide: {
          message:
            'Mostrar este servicio lo hará visible para los usuarios en el sitio web. ¿Está seguro de que desea mostrar este servicio?',
          confirmButton: 'Sí, mostrar servicio',
        },
      },
      testmode: {
        enable: {
          message:
            'Cambiar al modo de prueba solo permitirá tarjetas de prueba para las compras. ¿Está seguro de que desea cambiar al modo de prueba?',
          confirmButton: 'Sí, cambiar a modo de prueba',
        },
        disable: {
          message:
            'Cambiar al modo en vivo solo permitirá tarjetas de crédito reales para las compras. ¿Está seguro de que desea cambiar al modo en vivo?',
          confirmButton: 'Sí, cambiar a modo en vivo',
        },
      },
    },
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      disabled: 'Deshabilitado',
      hidden: 'Oculto',
      testmode: 'Modo de prueba',
      type: 'Tipo',
    },
    customProperties: {
      key: 'Clave',
      value: 'Valor',
      add: 'Agregar propiedad personalizada',
      remove: 'Eliminar',
      errors: {
        keyEmpty: 'La clave no puede estar vacía.',
        keyExists: 'La clave "{{key}}" ya existe.',
      },
      title: 'Propiedades personalizadas',
      caption:
        'Las propiedades personalizadas le permiten agregar metadatos a su servicio',
      about: {
        title: 'Acerca de las propiedades personalizadas',
        description:
          'Las propiedades son pares clave-valor que se pueden usar para almacenar datos de configuración adicionales para su servicio.',
      },
      empty:
        'No hay propiedades personalizadas definidas. Haga clic en "Agregar propiedad personalizada" para crear una.',
      propertyName: 'Nombre de la propiedad',
      propertyValue: 'Valor de la propiedad',
      placeholders: {
        name: 'Ingrese el nombre de la propiedad',
        value: 'Ingrese el valor de la propiedad',
      },
      removeTooltip: 'Eliminar propiedad',
      removeAriaLabel: 'Eliminar propiedad {{name}}',
    },
    noDescription: 'No se proporcionó descripción',
    configuration: {
      loading: 'Cargando configuración...',
      noFields: 'No hay campos de configuración disponibles para este tipo de servicio.',
      sections: {
        service: 'Configuración del servicio',
        payment: 'Configuración de pago',
        tax: 'Configuración fiscal',
        additional: 'Configuración adicional',
      },
    },
    generalSettings: {
      fields: {
        serviceName: {
          label: 'Nombre del servicio',
          tooltip: 'Ingrese el nombre de este servicio',
        },
        notificationEmail: {
          label: 'Correo de notificación',
          help: 'Dirección de correo para notificaciones del servicio',
          tooltip:
            'Ingrese la dirección de correo donde se enviarán las notificaciones del servicio',
        },
        linkedAccounts: {
          label: 'Permitir cuentas vinculadas',
          help: 'Permitir a los usuarios vincular múltiples cuentas',
          tooltip:
            'Habilite esto para permitir que los usuarios conecten múltiples cuentas a este servicio',
        },
        deliveryRequired: {
          label: 'Requerir dirección de entrega',
          help: 'Hacer obligatoria la información de entrega',
          tooltip:
            'Requerir que los usuarios proporcionen información de dirección de entrega',
        },
        disabled: {
          label: 'Servicio deshabilitado',
          help: 'Deshabilitar temporalmente el servicio',
          tooltip:
            'Cuando está habilitado, este servicio estará temporalmente no disponible',
        },
        hidden: {
          label: 'Ocultar al público',
          help: 'Ocultar servicio de la vista pública',
          tooltip:
            'Cuando está habilitado, este servicio no será visible para los usuarios',
        },
        testMode: {
          label: 'Modo de prueba',
          help: 'Habilitar entorno de prueba',
          tooltip: 'Habilitar el modo de prueba para desarrollo y pruebas',
        },
        description: {
          label: 'Descripción del servicio',
          help: 'Proporcione detalles sobre lo que ofrece este servicio',
        },
      },
    },
    rates: {
      searchPlaceholder: 'Buscar tarifas...',
      searchAriaLabel: 'Buscar tarifas',
      clearTooltip: 'Limpiar entrada',
      clearAriaLabel: 'Limpiar búsqueda',
      activeOnly: 'Solo activos',
      results: {
        count: '{{filtered}} de {{total}} resultados',
        none: 'Sin resultados.',
      },
      error: {
        loadFailed:
          'Error al cargar las tarifas después de {{attempts}} intentos. Por favor, inténtelo de nuevo.',
        retry: 'Reintentar',
      },
      columns: {
        name: 'Nombre',
        amount: 'Monto',
        duration: 'Duración',
        currency: 'Moneda',
        isSaveRate: 'Tarifa de ahorro',
        activeUsers: 'Usuarios activos',
      },
      isSaveRate: {
        yes: 'Sí',
        no: 'No',
      },
    },
    domainManagement: {
      description: 'Gestione los dominios asociados con este servicio.',
      addButton: 'Agregar',
      pasteButton: 'Pegar',
      copyButton: 'Copiar',
      sortButton: 'Ordenar',
      sortAsc: 'Ordenar de A a Z',
      sortDesc: 'Ordenar de Z a A',
      clearSort: 'Quitar orden',
      noDomains: 'Aún no se han agregado dominios a este servicio.',
      noResults: 'Ningún dominio coincide con su búsqueda.',
      domainCount: '{{count}} dominio(s)',
      removeTooltip: 'Eliminar dominio',
      pasteTooltip: 'Pegar dominios del portapapeles',
      copyTooltip: 'Copiar todos los dominios al portapapeles',
      sortTooltip: 'Ordenar dominios alfabéticamente',
      searchPlaceholder: 'Buscar dominios...',
      searchAriaLabel: 'Buscar dominios',
      clearTooltip: 'Limpiar búsqueda',
      clearAriaLabel: 'Limpiar búsqueda',
      results: {
        count: '{{filtered}} de {{total}} resultados',
        none: 'Sin dominios',
      },
      success: {
        update: 'Dominios actualizados correctamente',
        copy: 'Dominios copiados al portapapeles',
        paste: '{{count}} dominio(s) agregado(s)',
      },
      error: {
        update: 'Error al actualizar los dominios: {{message}}',
        duplicate: 'Este dominio ya existe en la lista',
        copy: 'Error al copiar los dominios al portapapeles',
        paste: 'Error al leer del portapapeles',
        noDomainsToPaste: 'No se encontraron dominios en el portapapeles',
      },
      info: {
        allDuplicates: 'Todos los dominios pegados ya existen en la lista',
      },
      modal: {
        title: 'Agregar dominio',
        description: 'Ingrese el nombre del dominio que desea agregar a este servicio.',
        label: 'Nombre del dominio',
        placeholder: 'ejemplo.com',
        addButton: 'Agregar dominio',
        adding: 'Agregando...',
        willBeAddedAs: 'Se agregará como: {{domain}}',
        error: {
          empty: 'Por favor ingrese un nombre de dominio',
          invalid: 'Por favor ingrese un nombre de dominio válido (ej. ejemplo.com)',
          duplicate: 'Este dominio ya existe en la lista',
        },
      },
    },
    notifications: {
      subscriberMessaging: 'Mensajería al suscriptor',
      adminNotifications: 'Notificaciones de administrador',
    },
  },
  new: {
    title: 'Nuevo servicio {{type}}',
    error: {
      missingType: 'Se requiere el tipo de servicio',
    },
  },
};

export const bloxSpanishMessages = {
  resources: {
    user: {
      fields: {
        address: 'Dirección',
        department: 'Departamento',
        email: 'Correo electrónico',
        email_placeholder: 'Ingrese la dirección de correo electrónico',
        email_required: 'El correo electrónico es obligatorio.',
        first_name: 'Nombre',
        first_name_placeholder: 'Ingrese el nombre',
        last_name: 'Apellido',
        last_name_placeholder: 'Ingrese el apellido',
        municipality: 'Municipio',
        password: 'Contraseña',
        phone: 'Teléfono',
        postal_code: 'Código postal',
        screen_name: 'Nombre de usuario',
        title: 'Título',
      },
    },
    transactions: {
      name: 'Transacciones',
      fields: {
        transactions_search: 'Todas las transacciones',
      },
    },
  },
  blox: {
    logs: {
      search_placeholder: 'Buscar mensajes de registro...',
      level: 'Nivel',
      date_range: 'Rango de fechas',
      details: {
        title: 'Entrada de registro',
        time: 'Hora',
        status: 'Estado',
        driver: 'Controlador',
        level: 'Nivel',
        message: 'Mensaje',
        fields: 'Detalles',
        no_message: 'Sin mensaje.',
        copy_message: 'Copiar mensaje',
        copy_value: 'Copiar valor',
      },
      levels: {
        debug: 'Depuración',
        info: 'Información',
        warning: 'Advertencia',
        notice: 'Aviso',
        error: 'Error',
        fatal: 'Fatal',
      },
      error: {
        failed_to_load: 'No se pudieron cargar los registros.',
      },
    },
    ai_chat: {
      label: 'Chat de IA',
      try_asking: 'Prueba a preguntar algo como:',
      need_any_help: '¿Necesita ayuda?',
      assistant_name: 'Asistente digital de BLOX',
      input_placeholder: 'Haga una pregunta…',
      send_message: 'Enviar mensaje',
      clear_messages:
        'Eliminar todos los mensajes y archivos, y restablecer el contexto de la conversación',
      stop_generating: 'Detener generación',
      beta_program: 'Esta función está actualmente en versión beta.',
      ai_warning:
        'La IA puede cometer errores, por favor verifique la información importante.',
      untitled_file: 'Archivo sin título',
      attach_files: 'Adjuntar archivos',
      attached_files: 'Archivos adjuntos',
      files_context:
        'Estos archivos se incluirán como contexto adicional para el asistente.',
      files_supported: 'Tipos de archivos compatibles: {{types}}.',
      max_files: 'Se pueden adjuntar un máximo de {{max}} archivos.',
      unsupported_files: 'El/los archivo(s) no son compatibles: {{names}}',
      files_too_large:
        'El/los archivo(s) {{names}} exceden el tamaño máximo de {{size}}.',
      file_parse_failed: 'No se pudo analizar el archivo: {{name}}',
      remove_all_files: 'Eliminar todos los archivos',
      scroll_to_end: 'Desplazarse al final',
      copy_to_clipboard: 'Copiar al portapapeles',
      regenerate_response: 'Regenerar respuesta',
      tools: {
        bias: {
          label: 'Verificador de sesgo',
          liberal: 'Liberal',
          leans_left: 'Tiende a la izquierda',
          neutral: 'Neutral',
          leans_right: 'Tiende a la derecha',
          conservative: 'Conservador',
          summary: 'Este artículo presenta un sesgo {{bias}}.',
        },
      },
    },
    ai: {
      search: {
        toggle_label: 'Búsqueda inteligente',
        toggle_on_tooltip: 'Búsqueda inteligente (beta)',
        toggle_off_tooltip: 'Volver a la búsqueda estándar',
        placeholder: 'Describe lo que estás buscando…',
        submit_tooltip: 'Ejecutar búsqueda inteligente',
      },
    },
    autosave: {
      autosaved: 'guardado automáticamente',
      type_autosaved: '{{type}} guardado automáticamente',
      tooltip: {
        saved: 'Último guardado {{time}}',
        autosaved: 'Cambios guardados automáticamente {{time}}',
        saving: 'Guardando cambios automáticamente...',
        disabled: 'El guardado automático está desactivado',
        error:
          'El guardado automático está desactivado porque el último intento de guardado automático falló',
        revisions:
          'El guardado automático está desactivado mientras se visualizan las revisiones',
        form_error:
          'El guardado automático está desactivado mientras el formulario contiene errores',
        asset_disabled:
          'El guardado automático está desactivado para recursos que no están en borrador',
      },
      dialog: {
        title: 'Cambios sin guardar',
        description: 'Tienes cambios sin guardar. ¿Qué deseas hacer?',
        actions: {
          discard: 'Descartar cambios',
          save: 'Guardar cambios',
        },
        editorial: {
          revisions: {
            errors: {
              noRevisions: 'No se encontró historial de revisiones.',
            },
            fields: {
              versionHistory: {
                label: 'Historial de versiones',
                options: {
                  all: 'Todo',
                  currentUser: 'Tu historial de revisiones',
                },
              },
              search: {
                label: 'Buscar revisiones...',
              },
              viewHistorically: {
                label: 'Ver históricamente',
              },
              revertModal: {
                label: '¿Revertir a la siguiente revisión?',
                confirm: 'Confirmar',
                cancel: 'Cancelar',
                noComment: 'Sin comentario proporcionado.',
              },
            },
            notAvailableTooltip: 'Revisión no disponible.',
            endOfResults: 'No hay más revisiones para mostrar.',
          },
        },
      },
      beforeUnload: '¿Estás seguro que deseas salir? Tienes cambios sin guardar.',
    },
    actions: {
      accept: 'Aceptar',
      archive: 'Archivar',
      add: 'Agregar',
      add_entry: 'Agregar entrada',
      new: 'Nuevo',
      apply: 'Aplicar',
      back: 'Atrás',
      cancel: 'Cancelar',
      cancel_uploads: 'Cancelar cargas',
      clear_queue: 'Borrar cola',
      change: 'Cambiar',
      clear_all: 'Borrar todo',
      clear: 'Limpiar',
      clone: 'Clonar',
      close: 'Cerrar',
      collapse: 'Colapsar',
      confirm: 'Confirmar',
      continue: 'Continuar',
      copied: 'Copiado',
      copy: {
        label: 'Copiar',
        clipboard: {
          label: 'Copiar {{item}} al portapapeles',
          copied: '{{item}} Copiado al portapapeles',
        },
      },
      create: 'Crear',
      crop: 'Recortar',
      remove_crop: 'Eliminar recorte',
      delete: 'Eliminar',
      disable: 'Deshabilitar',
      discard: 'Descartar',
      download: 'Descargar',
      duplicate: 'Duplicar',
      enable: 'Habilitar',
      enter_a_value: 'Ingrese un valor',
      export: 'Exportar',
      exporting: 'Exportando...',
      dropzone: 'Arrastra y suelta archivos aquí, o haz clic para seleccionar.',
      edit: 'Editar',
      editing: 'Editando',
      expand: 'Expandir',
      expand_preview: 'Expandir vista previa',
      failed: 'Falló',
      filter_options: 'Filtrar opciones',
      include: 'Incluir',
      insert_selected: 'Insertar seleccionado',
      add_to: 'Agregar a...',
      keep: 'Conservar',
      logout: 'Cerrar sesión',
      load_more: 'Cargar más',
      maximize: 'Maximizar',
      modify: 'Modificar',
      next: 'Siguiente',
      open: 'Abrir',
      open_in_new_window: 'Abrir en una nueva ventana',
      open_in_new_tab: 'Abrir en una nueva pestaña',
      publish: 'Publicar',
      purge: 'Purgar',
      quick_edit: 'Edición rápida',
      refresh: 'Actualizar',
      reset_filters: 'Restablecer filtros',
      remove: 'Remover',
      remove_all: 'Remover todo',
      replace: 'Reemplazar',
      required: 'Requerido',
      reset: 'Restablecer',
      restore: 'Restaurar',
      retry: 'Reintentar',
      error_click_retry: 'Ocurrió un error. Haz clic para reintentar.',
      save: 'Guardar',
      saving: 'Guardando',
      saved: 'Guardado',
      save_close: 'Guardar y cerrar',
      save_reload: 'Guardar y recargar',
      save_changes: 'Guardar',
      save_draft: 'Guardar borrador',
      save_as_draft: 'Guardar como borrador',
      save_publish: 'Guardar y publicar',
      submit: 'Enviar',
      publish_updates: 'Publicar actualizaciones',
      select_action: 'Seleccionar una acción',
      search: 'Buscar',
      select: 'Seleccionar',
      select_all: 'Seleccionar todo',
      select_all_prompt: '¿Desea seleccionar todo?',
      set_as_preview: 'Establecer como vista previa',
      set_as_teaser: 'Establecer como teaser',
      set_as_cover_art: 'Establecer como portada',
      start_listening: 'Iniciar escucha',
      stop_listening: 'Detener escucha',
      success: 'Éxito',
      show: 'Mostrar',
      undo: 'Deshacer',
      undo_deletion: 'Deshacer eliminación',
      restore_success: 'Restauración exitosa',
      restore_requested: 'Restauración solicitada',
      unpin: 'Desanclar',
      unlock: 'Desbloquear',
      use_selected: 'Usar Seleccionado',
      update: 'Actualizar',
      upload: 'Subir',
      uploading: 'Subiendo',
      view: 'Ver',
      fetching: 'Atractivo',
      copy_to_site: 'Copiar al sitio...',
    },
    copy_to_site: {
      target_sites_label: 'Sitios de destino',
      site_select: 'Seleccionar sitios para copiar',
      please_select_sites: 'Por favor, seleccione sitios para continuar',
      no_target_sites:
        'No hay otros sitios disponibles. Actualmente estás en {{site}}, que es el único sitio al que tienes acceso.',
      processing_progress: 'Procesando {{count}} sitios... {{progress}}',
      site_header: 'Sitio',
      status_header: 'Estado',
      summary: 'Copiado exitosamente a {{success}} de {{total}} sitios.',
      summary_error: '{{error}} sitios no fueron compatibles.',
      confirm_close_title: '¿Está seguro de que desea cerrar?',
      confirm_close_content: 'Cualquier copia que aún no se haya procesado se omitirá.',
      confirm_proceed_title: '¿Está seguro de que desea continuar?',
      retryable_errors_summary: '{{count}} sitios no se pudieron procesar',
    },
    errors: {
      generic: 'Algo salió mal.',
    },
    permissions: {
      msg: {
        required_short: 'Requiere permiso de {{name}}',
        required_long: 'Su cuenta requiere permiso para {{name}}',
        required_list_short: 'Requiere permisos de {{names, list}}',
        required_list_long: 'Su cuenta requiere permisos para {{names, list}}',
        access_restricted: 'Acceso restringido',
        contact_admin:
          'Comuníquese con su administrador del sistema para solicitar los permisos necesarios para su cuenta.',
      },
      site_admin: 'administrador del sitio',
      full_access: 'acceso completo',
      editorial: 'editorial',
      editorial_settings: 'configuración editorial',
      syndication: 'sindicación',
      create_assets: 'crear recursos',
      modify_assets: 'modificar recursos',
      delete_assets: 'eliminar recursos',
      change_publish_status: 'cambiar estado de publicación',
      batch_edit_search: 'edición por lotes de búsqueda',
      workflows: 'flujos de trabajo',
      change_workflow: 'cambiar flujo de trabajo',
      change_process: 'cambiar proceso',
      site_tags: 'etiquetas del sitio',
      keyword_tags: 'etiquetas de palabras clave',
      access_rules: 'reglas de acceso',
      asset_automations: 'automatizaciones de recursos',
      asset_settings: 'configuración de recursos',
      contributed_content: 'contenido contribuido',
      related_content_styles: 'estilos de contenido relacionado',
      content_importers: 'importadores de contenido',
      linked_sites_mapping: 'mapeo de sitios vinculados',
      automated_article_export: 'exportación automática de artículos',
      drm_policies: 'políticas DRM',
      semantic_analysis: 'análisis semántico',
      section_maps: 'mapas de sección',
      user: 'usuario',
      manage_user_accounts: 'gestionar cuentas de usuario',
      manage_user_groups: 'gestionar grupos de usuario',
      assign_user_groups: 'asignar grupos de usuario',
      user_groups_not_same:
        'Debes estar en los mismos grupos que el usuario para asignar grupos.',
      edit_profile: 'editar perfil',
      change_avatar: 'cambiar avatar',
      change_authentication: 'cambiar autenticación',
      override_concurrent_login_rules: 'anular reglas de inicio de sesión concurrente',
      edit_custom_properties: 'editar propiedades personalizadas',
      import_content: 'importar contenido',
      modify_channels: 'modificar canales',
      modify_importers: 'modificar importadores',
      broadcast: 'transmisión (notifier)',
      broadcast_full: 'acceso completo a la transmisión',
      broadcast_change_settings: 'cambiar configuración de transmisión',
      broadcast_read_notifications: 'leer notificaciones de transmisión',
      broadcast_send_notifications: 'enviar notificaciones de transmisión',
      email_reach_full: 'alcance de correo electrónico',
      access_control: 'control de acceso',
      access_control_edit_rules: 'editar reglas de acceso',
      access_control_full: 'acceso completo al control de acceso',
      access_control_create_rules: 'crear nuevas reglas de acceso',
      access_control_delete_rules: 'eliminar reglas de acceso',
      access_control_settings: 'configuración de control de acceso',
      subscription_any: 'suscripción',
      subscription_full: 'acceso completo a suscripciones',
      subscription_edit: 'editar suscripciones',
      subscription_create: 'crear suscripciones',
      subscription_edit_services: 'editar servicios de suscripción',
      subscription_service_modify: 'editar servicios',
      pro_data_insights_any: 'información de datos pro',
      pro_data_insights_full: 'acceso completo a información de datos pro',
      pro_data_insights_view_reports: 'ver informes de información de datos pro',
      pro_data_insights_export_data: 'exportar datos de información de datos pro',
    },
    assistant: {
      label: 'Asistente',
      score: {
        label: 'Puntuación',
        low: 'Bajo',
        medium: 'Medio',
        high: 'Alto',
      },
      content: {
        label: 'Asistente de Contenido',
        actions: {
          select: 'Seleccionar una Acción',
          complete: 'Completar',
          emojify: 'Emojificar',
          extend: 'Extender',
          rephrase: 'Reformular',
          shorten: 'Acortar',
          simplify: 'Simplificar',
        },
      },
      keyword: {
        label: 'Asistente de Palabras Clave',
      },
      seo: {
        title: {
          label: 'Asistente de Título SEO',
        },
        description: {
          label: 'Asistente de Descripción SEO',
        },
      },
      social_title: {
        label: 'Asistente de Título Social',
      },
      social_summary: {
        label: 'Asistente de Resumen Social',
      },
      summary: {
        label: 'Asistente de Resumen',
      },
      url_title: {
        label: 'Asistente de Título de la URL',
      },
      suggestion: {
        label: 'Sugerencia de IA',
        current: 'Actual',
        suggested_replacements: 'Reemplazos Sugeridos',
        dismiss: 'Descartar',
        rules: {
          spell_check: {
            title: 'Ortografía',
            prompt: 'Identificar y corregir errores ortográficos',
          },
          grammar_check: {
            title: 'Gramática',
            prompt: 'Identificar y corregir errores gramaticales',
          },
        },
      },
    },
    framework: {
      user_menu: {
        theme: 'Tema',
        theme_description:
          'Seleccione su preferencia de visualización global para la interfaz. Elija entre un tema oscuro o claro para adaptarse a su comodidad visual y entorno de trabajo. Esta configuración se aplicará en toda la plataforma, asegurando una apariencia coherente cada vez que acceda a sus herramientas y contenido.',
        theme_options: {
          light: 'Claro',
          dark: 'Oscuro',
          browser: 'Navegador (requiere actualización)',
        },
        dark_mode: 'Modo oscuro',
        language: 'Idioma',
        language_description:
          'Elija su idioma preferido para la interfaz. Esta preferencia se utiliza para su cuenta y se puede cambiar en cualquier momento.',
        tooltip: 'Perfil',
        view_site: {
          label: 'Vista previa del sitio',
          front: 'Ver la página principal',
          front_anon: 'Ver la página principal de forma anónima',
          time_preview: 'Ver vista previa de la portada en un momento específico',
          preview: 'Ver vista previa de la página principal',
        },
        tracking: 'Seguimiento de sesión',
        tracking_description:
          'Elija si el seguimiento de sesión está habilitado para su experiencia de cuenta. Esta preferencia se puede actualizar en cualquier momento.',
        my_preferences: 'Mis Preferencias',
        preferences: {
          global: {
            label: 'Preferencias Globales',
          },
          site: {
            label: 'Preferencias del Sitio',
          },
          set_title: 'Establecer {{screen}}',
          save_success: 'Preferencias guardadas correctamente.',
          save_error: 'Error al guardar las preferencias.',
          loading: 'Cargando preferencias...',
          notifications: {
            label: 'Notificaciones y Alertas',
          },
          default_asset_settings: {
            label: 'Configuración predeterminada del activo',
          },
          start_time: {
            label: 'Hora de inicio predeterminada del activo',
            title: 'Establecer hora de inicio predeterminada del activo',
            specify_time: 'Especificar hora de inicio',
            description:
              'Use esta preferencia para establecer la hora de inicio predeterminada para todos los nuevos activos que cree. Esta preferencia durará solo durante su sesión. Después de cerrar sesión y volver a iniciar sesión, el sistema volverá a usar la fecha y hora actuales hasta que vuelva a establecer esta preferencia.',
            radio_current: 'Establecer hora de inicio a la fecha y hora actuales',
            radio_specific: 'Establecer hora de inicio a una fecha y hora específica',
            helper_text:
              'La fecha de publicación está utilizando actualmente su hora de inicio establecida en la configuración.',
            invalid: 'Hora de inicio no válida',
          },
          workflow: {
            label: 'Flujo de trabajo predeterminado del activo',
            title: 'Establecer flujo de trabajo de activos predeterminado',
            input_label: 'Flujo de trabajo predeterminado',
            none: 'Seleccione un flujo de trabajo predeterminado',
            tooltip:
              'Flujo de trabajo para asignar automáticamente a nuevos activos editoriales que crees.',
          },
          author: {
            label: 'Autor predeterminado del activo',
            title: 'Autor predeterminado del activo',
            description:
              '¿Establecerte automáticamente como autor de los activos que creas?',
          },
          presentations: {
            title: 'Presentaciones Predeterminadas',
            description:
              'Elige el modo de presentación que se aplica a los nuevos activos que creas, por tipo. Esta es una preferencia personal y no afecta a otros usuarios. Los nuevos activos heredan el modo seleccionado a menos que se anule en el activo. El valor predeterminado es Ninguno.',
            none: 'Ninguno',
          },
        },
      },
      card_view: {
        grid: 'Vista de Cuadrícula',
        list: 'Vista de Lista',
        summary: 'Vista Resumen',
        preview: 'Vista previa',
      },
    },
    batch_edit: {
      label: 'Edición masiva',
      actions: {
        edit: 'Editar seleccionados',
        edit_all: 'Editar todos los resultados de búsqueda',
        clear: 'Borrar selecciones',
        undo_deletion: 'Deshacer eliminación',
        undo_deletion_help:
          'Establece el campo Fecha de eliminación en Eliminar, restaurando estos elementos.',
      },
      confirm: {
        change_count_one: 'Está a punto de modificar {{count}} resultado de búsqueda.',
        change_count_other: 'Está a punto de modificar {{count}} resultados de búsqueda.',
        type_count: 'Para confirmar, escriba el número de resultados ({{count}})',
        input_placeholder: 'Ingrese el número de resultados',
        input_error: 'El número no coincide con el total de resultados',
      },
      help: {
        success: 'Tarea de edición por lotes creada',
        selectionLimited: 'La selección está limitada a {{count}} elementos.',
        selectionExceedsLimit:
          'Por favor, reduzca su selección a {{count}} elementos o utilice la opción "Edición por lotes de resultados de búsqueda" para editar todos los resultados de su búsqueda.',
      },
      errors: {
        preflightFailed: 'Error al cargar las opciones de edición por lotes.{{message}}',
        submitFailed: 'Error al crear la tarea de edición por lotes.{{message}}',
      },
    },
    batch_import: {
      importing_assets: 'Importando recurso(s)',
      import_problems: 'Problema(s) con una importación',
      group_label: 'Importación grupal · {{count}} archivos',
      notifications: {
        bpm: {
          success_title: 'Carga BPM Completada',
          success:
            'Carga de archivo BPM exitosa. Los activos se importarán en segundo plano',
          import_success_title: 'Importación BPM Completada',
          import_success:
            'Todos los activos de {{fileName}} fueron importados exitosamente',
          import_success_link: 'Ver activos importados',
          warn_title: 'Aviso de importación BPM',
          warn: 'El archivo BPM no aceptará ajustes preestablecidos durante la importación.',
          error_title: 'Error en la carga BPM',
          error: 'Error al cargar el archivo BPM para importación',
        },
        single_upload_title: 'Carga Completada',
        single_upload_body: '{{fileName}} fue cargado exitosamente',
        single_upload_link: 'Editar {{fileName}}',
        single_upload_failed_title: 'Error en la carga',
        single_upload_failed_body: '{{errorMessage}}',
        wire_import_success_title: 'Importación Wire Completada',
        wire_import_success_body: '{{recordTitle}} fue importado exitosamente',
        wire_import_success_link: 'Editar {{recordTitle}}',
        wire_import_failed_title: 'Error en la importación Wire',
        wire_import_failed_body: '{{errorMessage}}',
        group_complete_title: 'Carga en Lote Completada',
        group_complete_body_all_success:
          'Los {{total}} archivos fueron cargados exitosamente',
        group_complete_body_partial:
          '{{success}} de {{total}} archivos cargados exitosamente. Fallidos: {{failedFiles}}',
        group_complete_body_all_failed: 'Los {{total}} archivos fallaron al cargar',
        group_complete_link: 'Ver archivos importados',
        // Legacy keys — retained for backward compatibility
        group_complete: '{{success}} de {{total}} archivos cargados exitosamente',
        single_success: 'Archivo cargado exitosamente.',
        // Fallback notify messages (used when user notifications are disabled)
        notify_import_complete: 'Importación de {{fileName}} completada.',
        notify_import_update_complete:
          'Actualización de importación de {{fileName}} completada.',
        notify_import_failed: 'Importación de {{fileName}} fallida.',
        notify_upload_failed: 'Error en la carga: {{errorMessage}}',
        notify_missing_binary_id:
          'Error en la carga: ID binario faltante en la respuesta.',
        notify_upload_canceled: 'Carga cancelada por el usuario.',
        notify_record_already_imported:
          'Registro ya importado, redireccionando a la página de edición',
        notify_import_in_progress: 'Importación ya en progreso',
        notify_record_imported: 'Registro importado exitosamente',
        notify_record_importing: 'Importando registro',
        notify_wire_import_failed:
          'Error de importación: No se pudo importar el recurso wire',
        notify_wire_import_error: 'Error durante la importación: {{errorMessage}}',
      },
      columns: {
        upload_status: 'Estado de Carga',
        file_name: 'Nombre de Archivo',
      },
      presets: {
        label: 'Ajustes Preestablecidos',
      },
    },
    export: {
      label: 'Exportación',
      msg: {
        export_success: 'Tarea de exportación creada exitosamente',
        export_ready: 'El archivo de exportación está listo para su descarga.',
        export_error: 'Error al crear la tarea de exportación',
        download_success: 'Archivo de exportación descargado exitosamente',
        download_error: 'Error al descargar el archivo de exportación',
      },
    },
    import: {
      label: 'Importar',
      files: {
        import_success: 'Importaciones exitosas',
        import_error: 'Ocurrió un error con las importaciones',
        upload_success: 'Archivo de importación subido correctamente',
        upload_error: 'Error al subir el archivo de importación',
      },
      assets: {
        imported: 'Elementos importados',
      },
    },
    business: {
      label: 'Negocio',
    },
    staticpages: {
      label: 'Páginas estáticas',
    },
    subscription: bloxSpanishSubscriptionMessages,
    transactions: bloxSpanishSubscriptionMessages.transactions,
    giftSubscription: {
      label: 'Suscripciones de regalo',
      noResults: 'No hay suscripciones de regalo disponibles.',
      loading: 'Cargando suscripciones de regalo...',
      loadingDetails: 'Cargando detalles de la suscripción de regalo...',
      loadMore: 'Cargar más',
      loadingMore: 'Cargando...',
      retry: 'Reintentar',
      errorLoadingGiftSubscriptions:
        'No se pudieron cargar las suscripciones de regalo. Por favor, inténtelo de nuevo.',
      purchased: 'Comprado {{date}}',
      toRecipient: 'Para: {{email}}',
      redeemed: 'Canjeado {{date}}',
      close: 'Cerrar',
      status: {
        redeemed: 'Canjeado',
        notRedeemed: 'No canjeado',
      },
      detail: {
        loadingHeader: 'Cargando detalles del regalo...',
        redeemedBy: 'Canjeado por',
        viewRecipientProfile: 'Ver perfil del destinatario',
        notRedeemed: 'No canjeado',
        giftDetails: 'Detalles del regalo',
        rateName: 'Nombre de la tarifa',
        rate: 'Tarifa',
        termExpires: 'El plazo expira',
        termExpired: 'El plazo expiró',
        subscriptionStart: 'Inicio de suscripción',
        giftCode: 'Código de regalo',
        purchaseDate: 'Fecha de compra',
        deliveryDate: 'Fecha de entrega',
        redeemedDate: 'Fecha de canje',
        purchaser: 'Comprador',
        purchaserName: 'Nombre del comprador',
        recipient: 'Destinatario',
        region: 'Región',
        postalCode: 'Código postal',
        country: 'País',
        recipientName: 'Nombre del destinatario',
        email: 'Correo electrónico',
        deliveryAddress: 'Dirección de entrega',
        deliveryMunicipality: 'Municipio de entrega',
        deliveryRegion: 'Región de entrega',
        deliveryPostalCode: 'Código postal de entrega',
        deliveryCountry: 'País de entrega',
        deliveryPhone: 'Teléfono de entrega',
        transaction: 'Transacción',
        transactionDate: 'Fecha de transacción',
        amount: 'Monto',
        duration: 'Duración',
        transactionId: 'ID de transacción',
        price: 'Precio',
        taxRate: 'Tasa de impuesto',
      },
    },

    user: {
      label: 'Usuarios',
      title: 'Perfil de usuario',
      unknown_user: 'Usuario Desconocido',
      account_type: {
        admin: 'Administrador',
        normal: 'Normal',
        any: 'Todos',
      },
      actions: {
        sending: 'Enviando...',
        send_password_reset: 'Enviar restablecimiento de contraseña',
        send_instant_login: 'Enviar inicio de sesión instantáneo',
        send_admin_invite: 'Enviar invitación de administrador',
        invite_to_site: 'Invitar al sitio...',
        reset_password: 'Restablecer contraseña',
        instant_login: 'Inicio de sesión instantáneo',
        set_password: 'Establecer contraseña',
        edit_profile: {
          label: 'Editar perfil',
          title: 'Editando perfil de usuario',
        },
        edit_user: {
          title: 'Editando usuario',
          title_admin: 'Editando usuario administrador',
        },
        edit_groups: {
          title: 'Grupos',
          submit_success: 'Grupos actualizados',
          errors: {
            min: 'Por favor, seleccione al menos un grupo.',
          },
        },
        change_password: {
          name: 'Contraseña',
          label: 'Cambiar contraseña',
          label_alt: 'Introducir la contraseña',
          help: 'La contraseña debe tener al menos {{minLength}} caracteres.',
          placeholder: 'Nueva contraseña',
          confirm_placeholder: 'Confirmar nueva contraseña',
          password_mismatch: 'Las contraseñas no coinciden',
          required: 'La contraseña es obligatoria.',
          success: 'Contraseña actualizada con éxito',
          error: 'Error al actualizar la contraseña',
          user_option: 'Permitir que el usuario establezca su propia contraseña',
          user_option_help:
            'Habilite esta opción para enviar un correo electrónico de restablecimiento de contraseña al usuario, lo que le permitirá establecer de manera segura su propia contraseña después de la creación.',
        },
        new_subscription: 'Nueva Suscripción',
        viewUser: 'Ver perfil público',
        auth_group: 'Seguridad de la cuenta',
        user_settings: {
          label: 'Configuración de administración de usuarios',
        },
        admin_invite: {
          submit_success:
            'Correo electrónico de invitación de administrador enviado con éxito',
          submit_error:
            'Error al enviar el correo electrónico de invitación de administrador',
          email_validation: {
            error: 'Error al validar el correo electrónico',
            error_groups: 'Por favor, seleccione al menos un grupo.',
          },
          form: {
            create_note:
              'Se enviará un correo electrónico de invitación de administrador con una cuenta creada al aceptar.',
            sending_to: 'Enviando un correo de invitación de administrador a',
            email_label: 'Correo electrónico',
            email_placeholder: 'Introduzca la dirección de correo',
            select_groups: 'Seleccione los grupos en los que inscribir a este usuario.',
          },
        },
        downgrade: {
          label: 'Eliminar privilegios de administrador',
          title: 'Eliminar privilegios de administrador para {{user}}',
          description:
            'Esta acción eliminará los privilegios de administrador de este usuario. Ya no tendrán acceso a las funciones y configuraciones de administrador.',
          warning: '¿Está seguro de que desea degradar a este usuario?',
          confirm_msg:
            '¿Está seguro de que desea degradar a este usuario a una cuenta normal?',
          confirm_btn: 'Sí, eliminar privilegios de administrador',
          submit_success: 'El administrador ha sido degradado',
          submit_error: 'Error al enviar la solicitud de degradación del administrador',
        },
      },
      avatar: {
        label: 'Avatar',
        remove: 'Eliminar avatar',
        max_size_err: 'El tamaño del archivo excede el máximo de 5 MB.',
        invalid_format:
          'Formato de archivo no válido. Por favor, suba un archivo de imagen (jpg, png, gif).',
        uploading: 'Subiendo...',
        upload_success: 'Avatar actualizado con éxito',
        upload_error: 'Error al actualizar el avatar. Por favor, inténtelo de nuevo.',
        drop_image_here:
          'Suelte una imagen aquí, o haga clic para seleccionar un archivo',
        drag_to_replace: 'Arrastre y suelte para reemplazar el avatar',
        drag_to_upload: 'Arrastre y suelte una imagen de avatar aquí',
        click_browse: 'o haga clic para buscar',
        formats: 'JPG, PNG, o GIF (máx. 5MB)',
      },
      msg: {
        instant_login_success:
          'Correo electrónico de inicio de sesión instantáneo enviado',
        instant_login_error: 'Error al enviar',
        password_reset_success:
          'Correo electrónico de restablecimiento de contraseña enviado con éxito',
        password_reset_error: 'Error al enviar',
      },
      activity_stream: {
        label: 'Flujo de actividad',
        loading: 'Cargando flujo de actividad...',
        refreshing: 'Actualizando...',
        error: 'Error al cargar el flujo de actividad.',
        no_results: 'No hay datos disponibles del flujo de actividad.',
        end_results: 'No hay más datos del flujo de actividad disponibles.',
      },
      subscriptions: {
        no_results: 'No hay suscripciones disponibles.',
      },
      payment_methods: {
        label: 'Métodos de pago',
      },
      linked_accounts: {
        label: 'Cuentas vinculadas',
        no_subscriptions_to_share: 'No hay suscripciones disponibles para compartir.',
        no_linked_accounts: 'No hay cuentas vinculadas disponibles.',
        add_account: 'Añadir cuenta',
        add_linked_account: 'Añadir cuenta vinculada',
        adding: 'Añadiendo',
        add: 'Añadir',
        revoke: 'Revocar',
        revoking: 'Revocando...',
        revoke_access: 'Revocar acceso',
        confirm_revoke_title: 'Confirmar revocación de acceso',
        confirm_revoke_message:
          '¿Estás seguro de que deseas revocar el acceso de {{email}}?',
        user_no_subscriptions: 'El usuario no tiene suscripciones',
        email_prompt:
          'Introduce la dirección de correo electrónico de la cuenta que deseas vincular.',
        view_user_in_new_tab: 'Ver usuario en una nueva pestaña',
        granted: 'Concedido',
        invited: 'Invitado',
        status_in: '{{status}} en {{date}}',
        granted_access_to: 'Acceso concedido a {{email}} en {{date}}',
        linked_subscription_inactive: 'Suscripción de la cuenta vinculada inactiva',
        grantor_subscription_inactive: 'Suscripción del otorgante inactiva',
      },
      audiences: {
        label: 'Audiencias',
        loading: 'Cargando audiencias del usuario...',
        error: 'Error al obtener las audiencias. Por favor, inténtalo de nuevo.',
        no_user_id: 'No se proporcionó ID de usuario.',
        no_description: 'No hay descripción disponible.',
        view_description_aria: 'Ver descripción de {{label}}',
        dmp_unavailable:
          'El seguimiento de datos de comportamiento no está disponible para este perfil porque tu sitio no tiene el CDP/DMP activado. Por favor, contacta con el administrador de tu sitio para hablar sobre la activación de esta función.',
        no_audiences: 'No hay audiencias disponibles.',
      },
      search: {
        action: 'Buscar cuentas de usuario...',
        loading: 'Cargando búsqueda de usuarios...',
        user_account: 'Cuenta de usuario',
        admin_account: 'Cuenta de administrador',
        multisite: {
          title: 'Contactos / Búsqueda multi-sitio',
          help: 'Busca para ver cuentas de usuario en varios sitios.',
        },
        admin: {
          action: 'Buscar cuentas de administrador...',
        },
      },
      groups: {
        label: 'Grupos',
        no_groups: 'No hay grupos disponibles.',
        edit_groups: 'Editar grupos',
        copy: {
          label: 'Copiar grupos al sitio',
          fetching_groups: 'Obteniendo datos de los grupos...',
          groups_to_copy: 'Grupos para copiar ({{count}})',
          group_fallback_name: 'Grupo {{id}}',
          members_count_one: '{{count}} miembro',
          members_count_other: '{{count}} miembros',
          name_too_long: 'El nombre del grupo debe tener 100 caracteres o menos',
          count_with_word: '{{count}} {{word}}',
          group_word_one: 'grupo',
          group_word_other: 'grupos',
          site_word_one: 'sitio',
          site_word_other: 'sitios',
          summary_copied_part: '{{groupCountText}} copiados a {{siteCountText}}',
          summary_error_part: '{{siteCountText}} con errores',
          row_groups_copied_one: '{{count}} grupo copiado',
          row_groups_copied_other: '{{count}} grupos copiados',
          row_groups_failed_one: '{{count}} grupo no copiado',
          row_groups_failed_other: '{{count}} grupos no copiados',
          confirm_copy_header: 'Confirmar copiar grupos',
          confirm_copy_sub_text_one: 'Copiar grupo a {{count}} sitio.',
          confirm_copy_sub_text_other: 'Copiar grupos a {{count}} sitios.',
          confirm_copy_sub_text_all: 'Copiar grupos a todos los sitios.',
          confirm_copy_button: 'Sí, Copiar',
        },
        form: {
          groupDetails: 'Detalles del grupo',
          assignedCapabilities: 'Capacidades asignadas',
          noCapabilities: 'No hay capacidades definidas',
          addCapabilityModalTitle: 'Agregar capacidad',
          totalCapabilities: 'Total de capacidades',
          removeCapability: 'Eliminar capacidad',
          addCapability: {
            label: 'Agregar capacidad',
            apps: 'Aplicaciones',
            additionalOptions: 'Opciones adicionales',
            preview: 'Vista previa',
            noSelection: 'No se han seleccionado capacidades',
            noOptionsSelected: 'No se han seleccionado opciones',
            editOptions: 'Editar opciones',
          },
          create: {
            success: 'Grupo creado',
            error: 'Error al crear el grupo',
            title: 'Crear nuevo grupo',
            selectedCapabilities: 'Capacidades seleccionadas',
          },
          edit: {
            title: 'Editar grupo',
          },
          name: {
            required: 'El nombre del grupo es obligatorio',
            label: 'Nombre del grupo',
            placeholder: 'Introduzca el nombre del grupo',
          },
          members: {
            label: 'Miembros',
          },
        },
      },
      profile_information: {
        label: 'Información de perfil',
        edit_profile: 'Editar perfil',
        about: 'Acerca de',
        topic_focus: 'Tema principal',
        location_focus: 'Ubicación principal',
        demographic_focus: 'Enfoque demográfico',
        languages: 'Idiomas',
        memberships: 'Membresías',
        awards: 'Premios',
        also_available: 'También disponible',
        no_information: 'No hay información de perfil disponible.',
        edit_field_tooltip: 'Introduce el valor del campo {{field}} del usuario',
        update_success: 'Perfil actualizado con éxito',
        update_error: 'Error al actualizar el perfil',
      },
      fields: {
        location: 'Ubicación',
        birthday: 'Cumpleaños',
        country: 'País',
        region: 'Región',
        facebook: 'Facebook',
        linkedin: 'LinkedIn',
        x: 'X',
        social_url_tooltip: 'URL de la cuenta de {{account}}',
      },
      sections: {
        details: 'Detalles',
        addresses: 'Direcciones adicionales',
        byline: 'Firma',
        tagline: 'Lema',
        personal_info: 'Información personal',
        address_info: 'Dirección',
        professional_info: 'Información profesional',
        admin_info: 'Información de administrador',
        social_info: 'Redes sociales',
      },
      empty: {
        address: 'No se proporcionó dirección',
      },
      meta: {
        created: 'Unido',
      },
      settings: {
        admins: {
          label: 'Administradores',
          manage: 'Gestionar administradores',
          groups: 'Grupos',
          invite: 'Invitar administrador',
        },
      },
      quick_filters: {
        label: 'Filtros rápidos',
        no_saved_searches: 'No hay filtros rápidos.',
        columns: {
          name: 'Nombre',
          application: 'Aplicación',
        },
      },
      invite_to_site: {
        title: 'Invitar al sitio',
        button_label: 'Invitar al sitio...',
        send_button: 'Enviar invitaciones',
        groups_label: 'Grupos para asignar ({{count}} seleccionados)',
        users_to_invite: 'Usuarios para invitar ({{count}})',
        select_groups_error: 'Seleccione al menos un grupo',
        groups_help_text: 'Se crearán los grupos que no existan en el sitio de destino.',
        search_groups_placeholder: 'Buscar grupos...',
        selected_groups_one: '{{count}} seleccionado',
        selected_groups_other: '{{count}} seleccionados',
        no_groups_match: 'Ningún grupo coincide con la búsqueda',
        group_ensure_error:
          'No se pudo asegurar el grupo "{{group}}" en {{domain}}: {{error}}',
        invite_error: 'No se pudo invitar a {{email}} a {{domain}}: {{error}}',
        summary_success_one: '{{count}} usuario invitado a {{siteCountText}}',
        summary_success_other: '{{count}} usuarios invitados a {{siteCountText}}',
        summary_partial_success_one: '{{count}} usuario invitado a {{siteCountText}}',
        summary_partial_success_other: '{{count}} usuarios invitados a {{siteCountText}}',
        site_count_one: '{{count}} sitio',
        site_count_other: '{{count}} sitios',
        row_users_invited_one: '{{count}} usuario invitado',
        row_users_invited_other: '{{count}} usuarios invitados',
        row_users_failed_one: '{{count}} fallido',
        row_users_failed_other: '{{count}} fallidos',
        row_invite_failed_one: '{{count}} invitación fallida',
        row_invite_failed_other: '{{count}} invitaciones fallidas',
        row_groups_failed_one: '{{count}} grupo no agregado',
        row_groups_failed_other: '{{count}} grupos no agregados',
        group_not_added: 'Grupo no agregado: {{group}}',
        confirm_close_title: '¿Está seguro de que desea cerrar?',
        confirm_close_content: 'Se omitirán las invitaciones no procesadas aún.',
        confirm_invite_header: 'Confirmar invitación',
        confirm_invite_sub_text_one: 'Invitar usuarios a {{count}} sitio.',
        confirm_invite_sub_text_other: 'Invitar usuarios a {{count}} sitios.',
        confirm_invite_sub_text_all: 'Invitar usuarios a todos los sitios.',
        confirm_invite_button: 'Sí, Invitar',
      },
    },
    adowl: {
      label: 'Ad Owl',
    },
    calendar: {
      label: 'Calendario',
    },
    classifieds: {
      label: 'Clasificados',
    },
    eedition: {
      label: 'Edición digital',
    },
    electionsstats: {
      label: 'Estadísticas electorales',
    },
    email: {
      label: 'Correo electrónico',
    },
    form: {
      label: 'Formulario',
    },
    html: {
      label: 'HTML',
    },
    search: {
      label: 'Buscar',
      placeholder: 'Buscar contenido...',
      runtime: 'Tiempo de ejecución',
      actions: {
        return: 'Volver a la búsqueda',
        returnAlt: 'Volver a los resultados de búsqueda',
      },
      view: {
        card_view: 'Vista de tarjetas',
        list_view: 'Vista de lista',
        summary_view: 'Vista de resumen',
      },
      sort: {
        label: 'Ordenar',
        sorted: 'Ordenado',
        sorted_label_dir: 'Ordenado: {{label}} ({{direction}})',
        ascending: 'Ascendente',
        descending: 'Descendente',
        remove_sort: 'Eliminar orden',
      },
      // saved search / quick filters
      saved: {
        shared_with_org: 'Compartido con la organización',
        shared: 'Compartido',
        quick_filters: 'Filtros rápidos',
        saved_filters: 'Filtros guardados',
        my_filters: 'Mis filtros',
        shared_filters: 'Filtros compartidos',
        create_new_filter: 'Crear nuevo filtro',
        applied_filter: 'Filtro aplicado',
        new_quick_filter: 'Nuevo filtro rápido',
        new_quick_filter_desc:
          'Guarda los criterios de búsqueda actuales como un filtro rápido.',
        replace_quick_filter: 'Reemplazar filtro rápido',
        replace_quick_filter_desc:
          'Reemplaza un filtro rápido existente con los criterios de búsqueda actuales.',
        quick_filter_name: 'Nombre del filtro rápido',
        for_working_privately: 'Para trabajar de forma privada',
        for_share_with_org: 'Para compartir con tu organización',
        save_quick_filter: 'Guardar filtro rápido',
        edit_quick_filter: 'Editar filtro rápido',
        delete_success: 'Filtro rápido eliminado exitosamente.',
        delete_confirm: '"{{name}}" será eliminado.',
        this_quick_filter: 'Este filtro rápido',
        default_modal: {
          title: {
            remove: 'Eliminar por defecto',
            replace: 'Reemplazar por defecto',
            confirm: 'Confirmar por defecto',
          },
          content: {
            remove:
              '¿Confirma la eliminación de <b>{{name}}</b> como búsqueda por defecto?',
            replace:
              '¿Reemplazar <b>{{currentName}}</b> con <b>{{newName}}</b> como búsqueda por defecto?',
            set: '¿Establecer <b>{{name}}</b> como búsqueda por defecto?',
          },
          actions: {
            cancel: 'Cancelar',
            confirm: 'Confirmar',
          },
        },
      },
      batch: {
        label: 'Editar en lote los resultados de búsqueda',
      },
      multisite: {
        domains: {
          label: 'Dominios',
          action: 'Seleccionar dominios',
          help: 'Dominios seleccionados',
          filter: 'Buscar dominios...',
          all: 'Todos los sitios',
        },
      },
      table: {
        last_modified_by: 'Última modificación por',
        owner: 'Propietario',
        default: 'Por defecto',
        categories: 'Categorías',
        uuid: 'UUID',
        created_date: 'Fecha de creación',
        domain: 'Dominio',
        subscription_state: 'Estado de suscripción',
        term: 'Plazo',
        services: 'Servicios',
        rate_name: 'Nombre de tarifa',
        term_expires: 'Vencimiento del plazo',
        service_icon: 'Icono de servicio',
        service_title: 'Título del servicio',
        service_type: 'Tipo de servicio',
        active_subscribers: 'Suscriptores activos',
        new_subscribers: 'Nuevos suscriptores',
        stopped_subscribers: 'Suscriptores detenidos',
        payment_handler: 'Gestor de pagos',
        service_id: 'ID del servicio',
        author: 'Autor',
        created: 'Creado',
        actions: 'Acciones',
        search_templates: 'Buscar plantillas...',
      },
    },
    asset_library: {
      label: 'Biblioteca de Activos',
      action: {
        drag: 'Arrastra y suelta recursos desde la biblioteca de recursos.',
      },
    },
    editorial: {
      label: 'Editorial',
      loading: 'Cargando editorial...',
      help: {
        no_access: 'Se requiere permiso para modificar activos',
      },
      infobar: {
        status: 'Estado',
        online: 'En línea',
        published: 'Publicado',
        unpublished: 'No publicado',
        offline: 'Fuera de línea',
        revision: 'Rev',
        access: 'Acceso',
        expires: 'Expira',
        workflow: 'Flujo de trabajo',
        title: 'Título',
        words: 'Palabras',
        characters: 'Caract.',
        web: '(Web)',
        words_print: 'Palabras (Impr.)',
        depth: 'Profundidad',
        images: 'Imágenes',
        rich_media: 'Medios',
        new: 'Nuevo',
        draft: 'Borrador',
        live: 'En vivo',
        yes: 'Sí',
        no: 'No',
        default: 'Predeterminado',
        scheduled: 'Programado',
        rev_no_live: 'Este activo está publicado sin una revisión en vivo.',
        rev_not_loaded: 'En vivo (rev. no cargada)',
        rev_not_loaded_tip:
          'Este activo está en vivo pero la revisión publicada no se obtuvo. Consulta el historial de revisiones para más detalles.',
      },
      batchImport: {
        label: 'Carga por lotes',
      },
      templates: {
        newStory: 'Nuevo artículo',
        createMenu: {
          heading: 'Plantillas de artículo',
          empty:
            'Aún no hay plantillas de artículo. Cree una para reutilizar su estructura y metadatos.',
          error: 'No se pudieron cargar las plantillas de artículo.',
          createFromAria: 'Crear desde la plantilla: {{title}}',
          untitled: 'Plantilla sin título',
        },
      },
      assetQuickLaunch: {
        createTitle: 'Crear {{label}}',
        createAction: 'Crear {{label}}',
        duplicateTitle: 'Duplicar {{label}}',
        duplicateAction: 'Duplicar {{label}}',
        templateTitle: 'Guardar como plantilla {{label}}',
        createTemplateTitle: 'Nueva plantilla {{label}}',
        templateAction: 'Crear plantilla',
        template: {
          nameLabel: 'Título de la plantilla',
          nameHelp: 'Opcional — usa el título existente por defecto',
          nameHelpNew: 'Opcional — puedes renombrar la plantilla más tarde',
        },
        useTemplate: {
          title: 'Crear {{label}} desde plantilla',
          action: 'Crear {{label}}',
        },
        apply: {
          warning_duplicate:
            'No se pudieron aplicar los valores de lanzamiento rápido a la duplicación.',
        },
        workflows: {
          error:
            'No se pueden cargar los flujos de trabajo en este momento. Puedes intentarlo de nuevo o continuar sin un flujo de trabajo.',
        },
        workflow: {
          label: 'Flujo de trabajo',
          helper: 'Opcional: usa la configuración predeterminada del sitio.',
          untitled: 'Flujo de trabajo sin título',
        },
        startTime: {
          label: 'Hora de inicio',
          helper: 'Opcional: se guarda en {{timeZone}}.',
        },
        slug: {
          label: 'Identificador',
          placeholder: 'Introduce un identificador',
          helper: 'Opcional: completa el identificador de impresión del activo.',
          helper_duplicate:
            'Opcional: dejar en blanco para generar automáticamente desde el titular.',
        },
        storyTemplate: {
          label: 'Plantilla de historia',
          helper:
            'Selecciona una plantilla para prellenar el activo con contenido y metadatos predefinidos.',
          blank: 'En blanco',
          error:
            'No se pueden cargar las plantillas de historia en este momento. Puedes continuar con un activo en blanco.',
        },
      },
      asset: {
        // Save messaging...
        created: '{{type}} creado',
        updated: '{{type}} actualizado',
        saved: '{{type}} guardado',
        saved_draft: '{{type}} guardado como borrador.',
        workflow_updated: 'Flujo de trabajo actualizado',
        workflow_process_updated: 'Proceso del flujo de trabajo actualizado',
        confirm_publish: 'Confirmar y publicar',
        confirm_demotion: 'Confirmar degradación',
        confirm_demotion_and_publish: 'Confirmar degradación y publicar',
        confirm_promotion: 'Confirmar promoción',
        confirm_promotion_and_publish: 'Confirmar promoción y publicar',
        promote_to: 'Promover a',
        demote_to: 'Degradar a',
        promote_and_publish_to: 'Promover y publicar a',
        demote_and_publish_to: 'Degradar y publicar a',
        published_draft: 'El estado es borrador y publicado.',
        published_live: 'El estado es en vivo y publicado.',
        unpublished_draft: 'El estado es borrador y no publicado.',
        unpublished_live: 'El estado es en vivo y no publicado.',
        dates_updated: 'Fechas actualizadas',
        delete_date_updated: 'Fecha de eliminación actualizada',
        archive_date_updated: 'Fecha de archivo actualizada',
        archive_and_delete_updated: 'Fechas de archivo y eliminación actualizadas',
        // Asset fields
        title: {
          label: 'Titular',
          label_alt: 'Título',
          help_alt: 'Introduce un título...',
          help_alt_poll: 'Introduce una pregunta...',
        },
        byline: {
          label: 'Firma',
          help: 'Introduce una firma...',
        },
        caption: {
          label: 'Leyenda',
          help: 'Introduce un pie de foto...',
          description: 'Suelta un nuevo archivo de subtítulos para agregar otro formato',
          supported_formats: 'Formatos soportados: WebVVT (.vtt), SubRip (.srt)',
          invalid_format: 'La URL no termina en .vtt, o .srt',
        },
        content: {
          label: 'Contenido',
        },
        content_characters: {
          label: 'Caracteres',
        },
        cover: {
          label: 'Portada',
          description:
            'Sube una imagen de portada para mostrarla en el diseño del artículo.',
          properties: {
            label: 'Propiedades de visualización de la portada',
            description: 'Establecer las propiedades de visualización de la portada',
            cover_img: {
              label: 'Imagen de portada',
              help: 'Arrastra y suelta o haz clic en el área de arriba para subir una nueva imagen de portada',
              invalid: 'La URL no termina en .jpeg, .jpg, .png, .gif, .tiff, o .bmp',
            },
            cover_align_horizontal: {
              label: 'Alineación horizontal del texto',
              options: {
                center: 'Centrado',
                left: 'Izquierda',
                right: 'Derecha',
              },
            },
            cover_align_vertical: {
              label: 'Alineación vertical del texto',
              options: {
                top: 'Arriba',
                middle: 'Centro',
                bottom: 'Abajo',
              },
            },
            cover_text_color: {
              label: 'Color del texto',
              options: {
                light: 'Claro',
                dark: 'Oscuro',
              },
            },
            cover_text_background: {
              label: 'Fondo del texto',
              options: {
                none: 'Ninguno',
                background_box: 'Caja de fondo',
                text_in_a_box: 'Texto en una caja',
              },
            },
            cover_effect: {
              label: 'Efecto',
              options: {
                none: 'Ninguno',
                parallax: 'Parallax',
                ken_burns: 'Paneo y zoom',
                blur: 'Desenfoque',
                grayscale: 'Escala de grises',
                sepia: 'Sepia',
                desaturate: 'Desaturar',
              },
            },
          },
        },
        tagline: {
          label: 'Eslogan',
        },
        address: {
          label: 'Dirección',
        },
        municipality: {
          label: 'Ciudad',
        },
        postal_code: {
          label: 'Código postal',
        },
        country: {
          label: 'País',
        },
        region: {
          label: 'Región',
        },
        related_content: {
          label: 'Contenido relacionado',
          relationships_label: 'Relaciones',
          actions: {
            insert: {
              label: 'Crear e insertar contenido relacionado',
            },
            add: {
              label: 'Agregar a relaciones',
              label_specific: 'Agregar a {{relationship}}',
            },
            view_selected: 'Ver seleccionados',
            close_selected: 'Cerrar seleccionados',
            unselect_all: 'Deseleccionar todos los elementos',
            remove: {
              label: 'Eliminar los recursos seleccionados',
              confirm: 'Confirmar eliminación',
              help_one:
                '¿Está seguro de que desea eliminar {{count}} elemento relacionado de este recurso?',
              help_other:
                '¿Está seguro de que desea eliminar {{count}} elementos relacionados de este recurso?',
              warn: 'No se pueden eliminar los recursos en línea',
              note: 'Nota: los elementos en línea no se pueden eliminar.',
            },
            search: {
              label: 'Buscar contenido relacionado...',
            },
            move_to_top: 'Mover arriba',
            move_to_bottom: 'Mover abajo',
          },
          table: {
            type: 'Tipo',
            title: 'Título',
            start_date: 'Fecha de inicio',
            status: 'Estado',
          },
          aria_labels: {
            drag_handle: 'Arrastrar para reordenar',
            more_options: 'Más opciones',
          },
          moving: 'Moviendo...',
          notifications: {
            added: 'Se agregaron {{count}} a {{relationship}}.',
            added_with_duplicates:
              'Se agregaron {{count}} a {{relationship}}. (Duplicados: {{duplicates}})',
            all_duplicates:
              'Todos los elementos seleccionados ya estaban en {{relationship}}.',
          },
          help: {
            no_selection: 'No hay elementos seleccionados',
          },
          parents: {
            label: 'Principales',
          },
          siblings: {
            label: 'Relacionados',
          },
          related_content: {
            label: 'Contenido',
          },
        },
        latitude: {
          label: 'Latitud',
        },
        longitude: {
          label: 'Longitud',
        },
        archive_time: {
          label: 'Fecha de archivo',
        },
        delete_time: {
          label: 'Fecha de eliminación',
        },
        files: {
          label: 'Archivos',
          social: {
            label: 'Imagen de vista previa social',
          },
        },
        flags: {
          label: 'Etiquetas',
        },
        site_tags: {
          label: 'Etiquetas del sitio',
          confirm_delete: {
            header: 'Confirmar eliminación',
            title: '¿Está seguro de que desea eliminar?',
            description: 'Esta acción es irreversible.',
            pre_confirm: 'Escriba',
            post_confirm: 'a continuación para permitir la eliminación.',
            input_label: 'Confirmación',
            cancel: 'Cancelar',
            confirm: 'Sí, eliminar',
          },
        },
        keywords: {
          label: 'Palabras clave',
          help: 'Buscar o agregar palabras clave',
          not_found: 'No se encontraron resultados. Presiona enter para agregar.',
          caption:
            'Asigna palabras clave para mejorar cómo se descubre tu video en sitios web, aplicaciones y feeds. Estas palabras clave ayudan a que tu video coincida con búsquedas relevantes.',
        },
        children: {
          label: 'Secundarios',
          add_to_children: 'Agregar a secundarios',
        },
        parents: {
          label: 'Principales',
          add_to_parents: 'Agregar a principales',
        },
        siblings: {
          label: 'Relacionados',
          add_to_siblings: 'Agregar a relacionados',
        },
        url: {
          label: 'URL',
        },
        properties: {
          label: 'Propiedades',
          abuse: {
            label: 'Marcado como abuso',
            description:
              'Indica si la comunidad ha marcado colectivamente este activo como una violación de las políticas del sitio.',
            reset_by_admin: 'reiniciado por admin',
          },
          altext: {
            label: 'Texto alternativo',
            help: 'Introduce texto alternativo, para accesibilidad...',
          },
          article_type: {
            label: 'Tipo de trabajo',
            description:
              'Categoriza este contenido según las definiciones de schema.org.',
            placeholder: 'Seleccione tipo de trabajo',
          },
          app: {
            label: 'Aplicación de origen',
            help: 'Solo lectura',
          },
          canonical_url: {
            label: 'URL Canónica',
            description:
              'La URL canónica completamente calificada para este activo. Principalmente útil si el contenido proviene de una fuente externa. Las URLs deben contener un protocolo, un host y una ruta para ser consideradas completamente calificadas.',
          },
          custom: {
            label: 'Propiedades personalizadas',
            name: {
              label: 'Nombre',
              help: {
                spaces: 'No se permiten espacios',
                unique: 'El nombre debe ser único',
                required: 'El nombre es obligatorio',
              },
            },
            value: {
              label: 'Valor',
              help: {
                required: 'El valor es obligatorio',
              },
            },
          },
          external_id: {
            label: 'ID CMS importado',
            help: 'Solo lectura',
          },
          hammer: {
            label: 'Título impactante',
          },
          kicker: {
            label: 'Título llamativo',
          },
          subheadline: {
            label: 'Subtítulo',
          },
          no_publish: {
            label: 'No publicar',
            label_alt: 'Estado de publicación',
            description: 'Establecer estado de publicación',

            // Remove/Restore Web Modal
            remove_from_web: 'Eliminar de la web',
            restore_to_web: 'Restaurar en la web',
            type_removed_from_web: '{{type}} eliminado de la web',
            type_restored_to_web: '{{type}} restaurado en la web',
            choose_web_version: 'Elige qué versión restaurar en la web',
            saves_all_as_draft: 'Guarda todos los cambios actuales como borrador',
            remove_current_version: 'Eliminar la versión publicada (no publicar)',
            remove_current_version_desc: 'El recurso ya no será visible en el sitio web.',

            apply_latest_changes:
              'Aplicar los últimos cambios (Publicar Actualizaciones)',
            apply_latest_changes_desc:
              'Guarda todos los cambios actuales en vivo y los publica en la web',
            restore_prior_version: 'Restaurar una versión publicada anteriormente',
            restore_prior_version_desc:
              'Restaura la visibilidad en la web de la última versión publicada.',
            controlled_by_workflow: 'Opción controlada por el flujo de trabajo asociado',
            disabled_in_create_mode:
              'La opción de publicación no está disponible al crear un nuevo recurso. Guarde el recurso para habilitar las opciones de publicación.',
            disabled_in_draft:
              'Esta opción está deshabilitada mientras esté en estado de borrador.',

            help: {
              workflow:
                'El proceso actual del flujo de trabajo está listo para la web y no se puede despublicar',
              permission: 'Permiso requerido para cambiar el estado de publicación',
              allow: 'Ok para publicar',
              scheduled: 'Programado',
              disallow: 'Publicación deshabilitada',
            },
          },
          no_reactions: {
            label: 'Reacciones de los usuarios',
            help: 'Cuando está habilitado, todas las herramientas de reacción (por ejemplo, me gusta, reacciones con emoji) están disponibles para el recurso si están configuradas en la sección o página. Desactivar las reacciones para este recurso reemplazará cualquier configuración a nivel de sitio o sección.',
          },
          no_comments: {
            label: 'Comentarios',
            help: 'Cuando está habilitado, los comentarios de los usuarios están disponibles en el recurso si los comentarios están configurados en la sección o página. Desactivar los comentarios para este recurso reemplazará cualquier configuración a nivel de sitio o sección.',
          },
          video360: {
            label: 'Modo de video 360°',
            help: 'Si está habilitado, el video se mostrará en modo 360.',
          },
          disable_advertising: {
            label: 'Desactivar publicidad',
            help: 'Si está habilitado, esta configuración evitará que se apliquen etiquetas de anuncios a este video.',
            warning: 'Publicidad desactivada. Este video se reproducirá sin anuncios.',
            confirm_title: 'Desactivar los anuncios afectará los ingresos',
            confirm_description:
              'Desactivar la publicidad para este video evitará cualquier llamada de anuncios y reducirá los ingresos publicitarios potenciales. ¿Está seguro de que desea continuar?',
          },
          photo_sales: {
            label: 'Venta de fotos',
          },
          priority: {
            label: 'Prioridad de visualización',
            help: 'Solo números',
            placeholder: 'Ingrese una prioridad numérica',
          },
          seo_description: {
            label: 'Descripción SEO',
          },
          seo_title: {
            label: 'Título SEO',
            description: 'El título a utilizar para SEO.',
            warning_length:
              'El título SEO supera los 60 caracteres recomendados para un SEO óptimo.',
          },
          social_title: {
            label: 'Título social',
            description:
              'Título alternativo para las redes sociales. Por defecto, utiliza el título principal del activo si está vacío.',
          },
          social_summary: {
            label: 'Resumen social',
            description:
              'Resumen alternativo para las redes sociales. Por defecto, utiliza el resumen principal del activo si está vacío.',
          },
          social_twitter_card: {
            label: 'Tarjeta',
            description: 'Configura la visualización de la tarjeta X cuando se presente.',
            auto: 'Automático',
            large_image: 'Imagen grande',
            summary: 'Resumen',
          },
          url_title: {
            label: 'Título de la URL',
            description:
              'Un título consistente para mostrar en la URL si los títulos en las URL están activados. Todos los títulos se mostrarán en la URL en minúsculas, con solo letras, números, espacios y guiones.',
          },

          workflow: {
            label: 'Flujo de trabajo',
            current_workflow: 'Flujo de trabajo actual: {{workflow}}',
            default_workflow: 'Flujo de trabajo predeterminado',
            default_workflow_description_p1:
              'El flujo de trabajo predeterminado permite un proceso sencillo de publicación de borrador a publicación. El contenido comienza en borrador, donde se puede editar libremente. Cuando esté listo, utilice Guardar y publicar para publicar el recurso en la web.',
            default_workflow_description_p2:
              'Para los recursos que ya están publicados, Guardar borrador le permite trabajar en actualizaciones sin afectar la versión publicada. La última versión publicada permanece visible hasta que seleccione Guardar y publicar para publicar los cambios.',
            default_workflow_description_p3:
              'Puede sacar un recurso de la web seleccionando “Quitar de la web”. Mientras el recurso no esté publicado, los cambios pueden seguir guardándose. Cuando esté listo para volver a publicarlo, seleccione “Restaurar en la web” para publicar la versión actualizada.',
            change_workflow_or_process: 'Cambiar flujo de trabajo o proceso',
            new_workflow_and_process: 'Nuevo flujo de trabajo y proceso',
            no_workflow_assigned: 'Ningún flujo de trabajo asignado',
            no_site_workflows: 'No hay flujos de trabajo disponibles para este sitio.',
            // Warnings for save actions
            change_warning:
              'Advertencia: Cambiar el flujo de trabajo moverá este activo a un proceso editorial diferente.',
            workflow_please_be_aware:
              'Este recurso está dentro de un flujo de trabajo; tenga en cuenta lo siguiente.',
            process_forces_draft: 'El proceso forzará el borrador.',
            process_forces_live: 'El proceso forzará en vivo.',
            process_resets_start_time: 'El proceso restablecerá la hora de inicio.',
            process_returns_on_draft: 'El proceso volverá al borrador.',

            actions: {
              change: 'Cambiar flujo de trabajo',
              remove: 'Eliminar flujo de trabajo actual',
            },
          },

          workflow_process: {
            label: 'Proceso',
            current_process: 'Proceso actual: {{process}}',
            select_process_step: 'Seleccionar paso del proceso',
            print_ready: 'Listo para imprimir',
            web_ready: 'Listo para la web',
            no_syndicate: 'Bloquear la sindicación',
            reset_start_time: 'Restablecer la hora de inicio',
            force_draft: 'Forzar borrador',
            force_live: 'Forzar en vivo',
            return_on_draft: 'Volver al borrador',
            disable_collaboration: 'Desactivar la colaboración',
            help: {
              change: 'Cambiar el proceso de flujo de trabajo',
              restricted: 'Cambio del proceso de flujo de trabajo restringido',
              promote:
                'Utilice el menú desplegable Guardar cambios para promocionar a través de los pasos del flujo de trabajo.',
            },
          },

          publish: {
            live_view: 'Vista en vivo',
            copy_live_url: 'Copiar URL en vivo',
            help: {
              force_draft_workflow:
                'El flujo de trabajo seleccionado impone el estado de publicación',
            },
          },
        },
        update_time: {
          label: 'Fecha de actualización',
        },
        authors: {
          label: 'Autores',
          label_one: 'Autor',
          help: 'Agregar autores...',
          help_reorder: 'El primer autor de esta lista es el lead.',
          primary_tooltip: 'Lead',
        },
        creators: {
          label: 'Creadores',
          help: 'Agregar creadores...',
        },
        body_copy: {
          label: 'Cuerpo del Texto',
          help: 'Ingresa el cuerpo del texto...',
        },
        description: {
          label: 'Descripción',
          help: 'Agregar una descripción...',
        },
        captions: {
          label: 'Subtítulos',
          help: 'Agregar subtítulos...',
          description:
            'Sube archivos de subtítulos para proporcionar texto para personas con discapacidad auditiva. Los formatos admitidos incluyen WebVTT (.vtt) y SubRip (.srt).',
          invalid_format: 'La URL no termina en .vtt, .srt o .ttml',
        },
        video: {
          label: 'Video',
          help: 'Agregar video...',
          poster: {
            label: 'Póster',
            description: 'La imagen del póster del reproductor.',
          },
          preview: {
            label: 'Avance',
            description: 'La imagen mostrada en la vista previa del bloque.',
          },
        },
        start_time: {
          label: 'Fecha de publicación',
          alt_label: 'Hora de inicio',
          errors: {
            invalid: 'Hora de inicio inválida',
          },
        },
        draft: {
          label: 'Borrador',
          description: 'Tiene cambios no publicados',
        },
        save: {
          label: 'Guardar',
          ariaLabel: 'Guardar y acciones de flujo de trabajo',
        },
        publish: {
          label: 'Publicar',
          aria_label: 'Publicar y acciones de flujo de trabajo',
          buttons: {
            cancel: {
              label: 'Cancelar',
            },
            publish: {
              label: 'Actualizar',
            },
          },
          fields: {
            revision_comment: {
              label: 'Comentario de Revisión',
              placeholder: 'Agregar un comentario a esta actualización...',
            },
            mark_important: {
              label: 'Marcar esta actualización como importante',
            },
            do_not_publish: {
              label: 'No publicar',
              set_publish: 'Establecer estado de publicación',
              current_workflow:
                'El proceso de flujo de trabajo actual está listo para web y no se puede despublicar',
              change_publish: 'Se requiere permiso para cambiar el estado de publicación',
            },
            optimization: {
              label: 'Puntuación de Optimización',
            },
            pub_date: {
              label: 'Fecha de publicación',
            },
          },
        },
        source: {
          label: 'Fuente',
          description: 'La agencia que generó el contenido de este activo.',
        },
        sections: {
          label: 'Secciones',
          search_view: 'búsqueda',
          tree_view: 'árbol',
          switch_view: 'Cambiar a la vista de {{view}}',
          error_fetch_tree: 'Error al obtener el árbol de secciones',
          caption:
            'Asigna etiquetas de sección para guiar dónde aparece el video en tu sitio y en los feeds de contenido. Estas etiquetas ayudan al sistema a decidir dónde colocar el video.',
          help_reorder:
            'La primera sección de esta lista será la sección principal para este {{type}}.',
          help_drag_drop: 'Arrastra y suelta elementos para reordenar.',
        },
        summary: {
          label: 'Resumen',
          description:
            'Ingrese aquí un resumen conciso de su activo. Debe ser una visión general breve, idealmente no superior a 150-200 palabras, que resalte los puntos o temas principales del contenido.',
        },
        teaser: {
          label: 'Imagen de vista previa',
          label_preview: 'Imagen de previsualización',
          description: {
            article: `Utilice el campo de Imagen de vista previa para cargar una imagen de previsualización para su historia. Esta imagen aparecerá como una miniatura o previsualización en las listas de artículos y los resultados de búsqueda. Es independiente de las imágenes de contenido principal y no se mostrará en la página de destino del artículo. Ideal para atraer la atención de los lectores y proporcionar un resumen visual del tema del artículo.`,
            image: `Esta imagen aparecerá cuando este recurso se presente como una previsualización o miniatura.`,
            default: `Esta imagen aparecerá como la previsualización o miniatura para este recurso.`,
          },
        },
        type: {
          label: 'Tipo',
        },
        update_comment: {
          label: 'Comentario de revisión',
          description: 'Agregue un comentario a esta actualización...',
        },
        important_update: {
          label: 'Actualización importante',
          description: 'Marque esta actualización como importante',
        },
        presentation: {
          label: 'Presentación',
          description:
            'Seleccione cómo debe presentarse este contenido a los lectores. Diferentes estilos de presentación pueden ayudar a enfatizar ciertos aspectos de su contenido.',
        },
        poll: {
          answer: 'Respuesta',
          answers: 'Respuestas',
          add_answer: 'Agregar Respuesta',
          add_answer_desc: 'Presiona el botón "Agregar Respuesta" para añadir opciones.',
          remove_choice: 'Eliminar Opción',
          votes: 'Votos',
          color: 'Color',
          bar_graph: 'Gráfico de Barras',
          pie_chart: 'Gráfico Circular',
          total_votes: 'Votos Totales',
        },
      },
      collab: {
        disconnected: 'Desconectado',
        disconnect_warning:
          'Por favor, verifica tu conexión a internet, ya que pareces estar desconectado o sin conexión.',
        sessions: 'Sesiones',
        current_session: 'Sesión actual',
        other_sessions: 'Otras sesiones',
        no_other_sessions: 'No hay otras sesiones',
        collaborators: 'Colaboradores',
        no_other_collaborators: 'No hay otros colaboradores',
      },
      metadata: {
        group: {
          uuid: {
            label: 'UUID',
          },
          workflow: {
            label: 'Flujo de trabajo',
            help: {
              restricted: 'Acceso bloqueado por un paso del flujo de trabajo',
              reset_start_time:
                'La hora de inicio se restablece a "Ahora" por el proceso de flujo de trabajo asignado',
            },
          },
          dates: {
            label: 'Fechas',
          },
          label: 'Ubicación',
          map: {
            invalid_coordinates: 'Coordenadas inválidas',
            helper:
              'Introduce latitud y longitud válidas para ver la ubicación en el mapa',
          },
          seo: {
            label: 'SEO',
            description:
              'Define cómo aparecerá el artículo en los resultados de búsqueda.',
          },
          social: {
            label: 'Social',
            description: 'Defina cómo aparecerá el artículo en las redes sociales.',
          },
          print_depth: {
            label: 'Profundidad de impresión',
            label_alt: 'Rango de profundidad de impresión',
          },
          print_publication: {
            label: 'Publicación impresa',
            fields: {
              publication: {
                label: 'Publicación',
              },
              edition: {
                label: 'Edición',
              },
              section: {
                label: 'Sección',
              },
              zone: {
                label: 'Zona',
              },
              page: {
                label: 'Página',
              },
              location: {
                label: 'Ubicación',
              },
              date: {
                label: 'Fecha',
              },
              placed: {
                label: 'Colocado',
              },
            },
          },
          print_publication_date_range: {
            label: 'Rango de fechas de publicación impresa',
            help: 'Seleccione una publicación para establecer un rango de fechas',
          },
          print_publication_status: {
            label: 'Estado de publicación impresa',
            help: 'Seleccione una publicación para seleccionar el estado',
          },
          print_ready: {
            label: 'Listo para impresión',
          },
          print_slug: {
            label: 'Identificador',
            placeholder: 'Ingrese un identificador de impresión',
            help: 'Buscar identificador exacto...',
            description:
              'Un Identificador sirve como ID de proyecto para su contenido, conteniendo letras, números, guiones bajos, guiones, espacios y más. Se utiliza para el seguimiento interno, la gestión del flujo de trabajo y la organización del contenido dentro de Blox CMS.',
          },
          print: {
            label: 'Propiedades de impresión',
            ready: {
              label: 'Listo para imprimir',
              description: '',
            },
            not_ready: {
              label: 'No listo para imprimir',
            },
            headline: {
              label: 'Titular',
              description: 'Titular personalizado para imprimir.',
            },
            subheadline: {
              label: 'Subtítulo',
              description: 'Subtítulo personalizado para imprimir.',
            },
            printpriority: {
              label: 'Prioridad',
              description: 'Determina el orden de impresión del activo.',
            },
            printImageColor: {
              label: 'Imagen de impresión',
              description: 'Imagen utilizada para impresión.',
            },
            printImageBlackWhite: {
              label: 'Imagen de impresión en blanco',
              description: 'Imagen utilizada para impresión en blanco',
            },
            jumpkeyword: {
              label: 'Saltar palabra clave',
              description: 'Palabra clave utilizada para referencias de salto.',
            },
            jumphead: {
              label: 'Saltar cabeza',
              description: 'Título personalizado para contenido continuo.',
            },
            notes: {
              label: 'Notas',
              description: 'Información adicional para imprimir.',
            },
          },
        },
      },
      // For article asset type
      article: {
        label: 'Artículo',
      },
      // For image asset and image general use where applicable
      image: {
        label: 'Imagen',
        description: 'El archivo asociado a este recurso.',
        help: 'Arrastra y suelta o haz clic en el área de arriba para subir una nueva imagen.',
        invalid: 'La URL no termina en .jpeg, .jpg, .png, .gif, .tiff, o .bmp',
        view_full_size: 'Ver imagen a tamaño completo',
        dropzone: {
          label: 'Arrastra y suelta una imagen aquí, o haz clic para seleccionar una.',
        },
        photo_sales: {
          label: 'Venta de fotos',
          description:
            'Declare si se pueden vender copias de esta foto. La opción Automático examinará los datos del recurso para determinar si la foto es vendible.',
          options: {
            automatic: 'Automático',
            //Enabled and Disabled use blox.general.enabled and blox.general.disabled for consistency in the UI
          },
        },
      },
      audio: {
        dropzone: {
          label:
            'Arrastra y suelta un archivo de audio aquí, o haz clic para seleccionar uno.',
        },
      },
      file: {
        success: 'Archivo subido con éxito.',
        transfering: 'Transfiriendo...',
        dropzone: {
          label: 'Arrastra y suelta un archivo aquí, o haz clic para seleccionar uno.',
        },
        error: {
          asset: 'No se pudo establecer desde el recurso proporcionado',
          invalid: 'La URL no termina con una extensión de archivo aceptada.',
          failed: 'Error al obtener el archivo desde la URL.',
        },
      },
      video: {
        dropzone: {
          label:
            'Arrastra y suelta un archivo de video aquí, o haz clic para seleccionar uno.',
        },
        processing:
          'Tu video se está convirtiendo a un formato compatible con la web y aún no está disponible para su visualización.',
        drop_to_upload: 'Suelta para subir un nuevo video.',
        blackbird: {
          not_configured: 'Blackbird no está configurado',
        },
      },
      revisions: {
        label: 'Revisiones',
        endOfResults: 'No hay más revisiones...',
        noChanges: 'No se encontraron cambios.',
        notAvailableTooltip: 'No disponible',
        buttons: {
          restore_previous: 'Restaurar revisión anterior',
          restore_selected: 'Restaurar revisión seleccionada',
          selected_revision: 'Revisión seleccionada',
          most_recent_save: 'Último guardado',
          previous_revision: 'Revisión anterior',
          restore: 'Restablecer a esta revisión',
          duplicate_revision: 'Duplicar desde revisión {{revisionId}}',
          duplicate_revision_simple: 'Duplicar {{assetType}}',
        },
        before: {
          label: 'Antes',
        },
        after: {
          label: 'Después',
        },
        removed: {
          label: 'Eliminado',
        },
        fields: {
          versionHistory: {
            label: 'Historial de versiones',
            options: {
              all: 'Todo',
              currentUser: 'Tu historial de revisiones',
            },
          },
          search: {
            label: 'Buscar revisiones...',
          },
          viewHistorically: {
            label: 'Ver históricamente',
          },
          revertModal: {
            label: '¿Revertir a la siguiente revisión?',
            confirm: 'Confirmar',
            cancel: 'Cancelar',
            noComment: 'Sin comentario proporcionado.',
          },
        },
        current: {
          label: 'Actual',
        },
        previous: {
          label: 'Anterior',
        },
        unknownUser: {
          label: 'Usuario desconocido',
        },
        errors: {
          noRevisions: 'No se encontraron revisiones.',
          noRevisionsCurrentUser: 'No se encontraron revisiones para el usuario actual.',
          revert: 'Hubo un error al intentar revertir a la revisión anterior.',
          header: `Hubo un error al procesar su solicitud.`,
          duplicate_error: 'Error al duplicar la revisión.',
        },
        duplicate_success: 'Revisión {{revisionId}} duplicada',
        quick_launch: {
          revision_label: 'Revisión {{revisionId}}',
          revision_label_fallback: 'Revisión',
        },
        asset_fallback: 'Recurso',
        viewableTooltip: 'Visible',
        draftTooltip: 'Borrador',
      },
      settings: {
        label: 'Configuraciones',
        help: 'Selecciona una configuración del panel lateral para ver y editar su configuración.',
        ai: {
          label: 'Configuraciones de IA',
          help: 'Configuraciones editoriales de IA.',
          summary: `Controla varias funciones impulsadas por IA para mejorar tu flujo de trabajo editorial. Activa o desactiva
          sugerencias del asistente para titulares, resúmenes y metadatos, o habilita opciones avanzadas
          de edición de contenido como reformulación y extensión de texto con extensiones de contenido.`,
          siteLevel: 'Estas configuraciones se aplican únicamente a: ',
          fields: {
            assistantSuggestions: {
              label: 'Habilitar Sugerencias del Asistente',
              description:
                'Activa o desactiva sugerencias para titulares, resúmenes y elementos de metadatos.',
            },
            contentExtensions: {
              label: 'Habilitar Extensiones de Contenido',
              description:
                'Activa el acceso a opciones avanzadas de edición de contenido como reformulación y extensión de oraciones o párrafos usando la paleta de formato.',
            },
            contentSuggections: {
              label: 'Habilitar Sugerencias de Contenido',
              description:
                'Activa o desactiva sugerencias para mejoras de gramática y ortografía del contenido.',
            },
          },
        },
        relatedContentStyles: {
          label: 'Estilos de Contenido Relacionado',
          help: 'Configuraciones para los estilos de contenido relacionado.',
          addButton: 'Agregar Nuevo',
          updateButton: 'Actualizar',
          cancelButton: 'Cancelar',
          error: 'Ocurrió un error.',
          drawer: {
            new: {
              title: 'Agregar Nuevo Estilo de Contenido Relacionado',
            },
            edit: {
              title: 'Editar Estilo de Contenido Relacionado',
            },
          },
          columns: {
            name: 'Nombre del estilo',
            type: 'Tipo',
            edit: 'Editar estilo',
            delete: 'Eliminar estilo',
            deleteConfirmation:
              '¿Estás seguro de que deseas eliminar este estilo de contenido relacionado?',
          },
          fields: {
            name: {
              label: 'Nombre',
              requiredMsg: 'Requerido.',
            },
            type: {
              label: 'Tipo',
              requiredMsg: 'El tipo es requerido',
              placeholder: 'Seleccionar tipo',
            },
            default_title: {
              label: 'Título Predeterminado',
              invalid: 'Inválida',
            },
            force_title: {
              label: 'Forzar Uso del Título Predeterminado',
              helpText: 'Forzar el uso del título predeterminado',
            },
          },
          notifications: {
            deleted: 'Estilo de contenido relacionado eliminado.',
            error: 'Error al actualizar el estilo de contenido relacionado.',
            deleteError: 'Error al eliminar el estilo de contenido relacionado.',
            success: 'Estilo de contenido relacionado guardado.',
          },
        },
      },
      collection: {
        label: 'Colección',
        add_items:
          'Utiliza la biblioteca de activos para agregar elementos a la colección.',
        insert_or_drag:
          'Inserta o arrastra elementos de la biblioteca de activos para agregarlos a la colección.',
        max_limit: 'Las colecciones tienen un máximo de {{max}} elementos.',
        duplicates: 'No se agregaron nuevos elementos. (Duplicados omitidos: {{count}})',
        selectionLimited: 'La selección está limitada a {{count}} elementos.',
        selectionLimitedSelectAll:
          'Selección limitada a los primeros {{count}} elementos.',
        added_one: 'Se agregó {{count}} elemento a la colección.',
        added_other: 'Se agregaron {{count}} elementos a la colección.',
        added_with_duplicates_one:
          'Se agregó {{count}} elemento a la colección. (Duplicados omitidos: {{duplicates}})',
        added_with_duplicates_other:
          'Se agregaron {{count}} elementos a la colección. (Duplicados omitidos: {{duplicates}})',
        hide_headlines: {
          label: 'Ocultar títulos',
          tooltip: 'Oculta los títulos de los elementos secundarios.',
        },
        hide_details: {
          label: 'Ocultar detalles',
          tooltip:
            'Oculta la firma, el pie de foto y otros detalles de los elementos secundarios.',
        },
        upload: {
          label: 'Subir a la colección',
          description: 'Sube archivos a esta colección.',
          close_warning:
            'Los archivos subidos no se agregarán a la colección. Las cargas restantes serán canceladas.',
          rejected_files: 'Tipo(s) de archivo no compatible(s): {{rejectedNames}}',
          untitled_file: 'Archivo sin título',
          preview_of: 'Vista previa de {{name}}',
        },
      },
      dynamic_collection: {
        label: 'Colección dinámica',
        curated: 'Curada',
        dynamic: 'Dinámica',
        curated_info:
          'Las colecciones curadas se gestionan manualmente; añade y reordena recursos desde la Biblioteca de recursos.',
        dynamic_info:
          'Las colecciones dinámicas se actualizan automáticamente cuando el nuevo contenido coincide con tus reglas de búsqueda.',
        change_type_header: '¿Cambiar el tipo de colección?',
        modify_search: 'Modificar búsqueda',
        create_search: 'Crear búsqueda',
        search_info:
          'Rellena automáticamente esta colección con recursos que coincidan con los criterios de búsqueda.',
      },
      moreActions: {
        button: 'Más acciones',
        saveTemplate: 'Guardar como plantilla',
        useTemplate: 'Usar plantilla',
        duplicate_disabled: 'Duplicar deshabilitado',
        duplicate_failed: 'Error al duplicar: {{error}}',
        save_template_failed: 'Error al guardar como plantilla: {{error}}',
        archive_and_delete_date: 'Fecha de archivado y eliminación',
        archive_date: 'Fecha de archivado',
        delete_date: 'Fecha de eliminación',
      },
      template: {
        label: 'Esto es una plantilla {{type}}',
        live_view: {
          tooltip: 'Las plantillas no ofrecen vista en vivo',
        },
      },
      deleted: {
        banner: 'Este elemento ha sido eliminado.',
      },
      inline: {
        insert_inline: 'Insertar en línea',
        placeholder: 'Marcador de posición',
        align: 'Alinear',
        width: 'Ancho',
        presentation: 'Presentación',
        displayProperties: {
          alignment: {
            left: 'Izquierda',
            center: 'Centro',
            right: 'Derecha',
            default: 'Predeterminado',
          },
          width: {
            default: 'Predeterminado',
            'one-third': 'Un tercio',
            half: 'Mitad',
            'two-thirds': 'Dos tercios',
            full: 'Completo',
          },
          presentation: {
            default: 'Predeterminado',
            headline: 'Enlace de titular',
            summary: 'Resumen',
            short_summary: 'Resumen breve',
            presentation: 'Presentación del recurso',
            parallax: 'Paralaje',
            fullbleed: 'Sangrado completo',
            hide_details: 'Ocultar detalles',
            player: 'Reproductor de medios',
            html: 'HTML',
            preview: 'Vista previa',
            download: 'Enlace de descarga',
            pdf: 'Vista previa de PDF',
            poll: 'Encuesta',
            mosaic: 'Mosaico',
            table: 'Tabla',
          },
        },
        article_specific: 'Anulado',
        asset_value: 'Anular',
        article_specific_tooltip: 'Usando valor específico del artículo',
        asset_value_tooltip: 'Usando valor original del recurso',
        reset_to_asset: 'Restablecer al recurso {{field}}',
        override_save_reminder:
          'Las personalizaciones específicas del artículo han sido modificadas. Guarde el artículo para aplicar estos cambios.',
      },
      locked: {
        label: 'Contenido bloqueado',
        reason: {
          env: 'Este contenido está bloqueado en otro entorno.',
          user: 'Este contenido está bloqueado por otro usuario.',
          default: 'Este contenido está bloqueado.',
        },
        action: {
          force_unlock: {
            label: 'Forzar desbloqueo en el Administrador Legacy',
            help: 'Este recurso está siendo editado actualmente en el Administrador Legacy por {{user}}. Forzar el desbloqueo puede causar la pérdida del trabajo del otro usuario. ¿Estás seguro de que deseas continuar?',
            success: 'Recurso desbloqueado',
            error: 'Error al desbloquear el recurso',
          },
        },
        origin: 'Origen del bloqueo:',
        by: 'Bloqueado por:',
        help: {
          readonly: 'Estás en modo de solo lectura',
        },
      },
      toolbar: {
        search_replace: {
          tooltip: 'Buscar y reemplazar',
          find: {
            label: 'Buscar',
            placeholder: 'Buscar...',
          },
          replace: {
            label: 'Reemplazar',
            placeholder: 'Reemplazar con...',
          },
          match_case: 'Coincidir mayúsculas y minúsculas',
          match_whole_word: 'Palabra completa',
          results: 'Resultados: {{current}} / {{total}}',
          button: {
            previous: 'Anterior',
            next: 'Siguiente',
            replace: 'Reemplazar',
            replace_all: 'Reemplazar todo',
          },
        },
        undo: 'Deshacer | Ctrl+Z',
        undo_change: 'deshacer cambio',
        redo: 'Rehacer | Ctrl+Y',
        redo_change: 'rehacer cambio',
        heading_level: 'nivel de encabezado',
        bold: 'Negrita | Ctrl+B',
        italic: 'Cursiva | Ctrl+I',
        underline: 'Subrayado | Ctrl+U',
        insert_link: 'Insertar enlace',
        link_to_url: 'Enlazar a URL',
        link_to_asset: 'Enlazar a recurso',
        edit_link: 'Editar enlace',
        remove_link: 'Eliminar enlace',
        insert_comment: 'Insertar comentario',
        edit_comment: 'Editar comentario',
        remove_comment: 'Eliminar comentario',
        bullet_list: 'Lista con viñetas | Ctrl+Shift+8',
        bullet_list_aria: 'lista con viñetas',
        numbered_list: 'Lista numerada | Ctrl+Shift+7',
        horizontal_rule: 'Línea horizontal',
        horizontal_rule_aria: 'línea horizontal',
        page_break: 'Salto de página',
        page_break_aria: 'salto de página',
        inline_note: 'Nota en línea',
        omitted_from_published: 'Se omitirá del contenido publicado',
        print_trim: 'Omitir en impresión',
        trim_from_print: 'Eliminar de la impresión',
        omitted_from_print: 'Se omitirá del contenido impreso',
        block_quote: 'Bloque de cita',
        table: 'Tabla',
        more: 'Más',
        open_more_options: 'Abrir más opciones',
        widgetselect: {
          dividers: {
            utilities: 'Utilidades',
            headlines: 'Encabezados',
          },
          inline_assets: {
            insert_type: 'Insertar {{type}}',
            image: 'Imagen',
            audio: 'Audio',
            video: 'Vídeo',
            link: 'Enlace',
            html: 'HTML',
            file: 'Archivo',
            open_asset_in_new_window: 'Abrir recurso en nueva ventana',
          },
          plaintext: {
            label: 'Pegar como texto sin formato',
            description: 'Insertar el contenido del portapapeles como texto sin formato.',
            error: 'Error al pegar como texto sin formato.',
            empty: 'El portapapeles está vacío.',
          },
        },
      },
      syndication: {
        actions: {
          add_to_site: 'Agregar al sitio',
          view_original: 'Ver original',
          view_remote: 'Ver activo remoto',
          cancel: 'Cancelar',
          save: 'Guardar',
          add_rules: 'Agregar reglas',
          update_rules: 'Actualizar reglas',
        },
        channels: {
          label: 'Canales',
          confirm_delete: {
            help: '¿Está seguro de que desea eliminar el canal {{channel}} del activo?',
          },
        },
        labels: {
          category_map: 'Mapa de categoría',
          category_map_for: 'Mapa de categoría para {{name}}',
          channel_category_map_for: 'Mapa de categoría de canal para {{name}}',
          channels: 'Canales',
          channels_info: 'Le permite acceder y administrar los canales de sindicación.',
          add_channel: 'Agregar canal',
          settings: 'Configuración del canal',
          select_driver: 'Seleccionar controlador',
          choose_categories: 'Elija una o más categorías de canal...',
          categories: 'Categorías',
          categories_hint: 'Presione Enter o Tab para agregar',
          choose_sections: 'Elija las secciones del sitio para asignarlas...',
          sections: 'Secciones',
          rules_info:
            'Las reglas a continuación se utilizarán para convertir las categorías del canal en secciones cuando se agreguen activos a su sitio. La regla de una categoría principal se utilizará para cualquiera de sus hijos que no estén presentes en sus propias reglas.',
          no_rules: 'Categoría no asignada o activo sin categorizar',
        },
        errors: {
          select_category: 'Por favor seleccione al menos una categoría',
          select_section: 'Por favor seleccione al menos una sección',
        },
        notifications: {
          channel_config_updated: 'Configuración del canal actualizada',
          channel_config_created: 'Configuración del canal creada',
          category_map_deleted:
            'Mapa de categoría para la configuración {{name}} eliminado',
          category_map_updated:
            'Mapa de categoría para la configuración {{name}} actualizado',
          failed_to_edit_setting: 'Error al editar la configuración: {{error}}',
          error: 'Error: {{error}}',
        },
      },

      save: {
        successful: 'Guardado exitoso',
      },
      buttons: {
        save_workflow_actions: 'Guardar y acciones de flujo de trabajo',
      },
      status: {
        published: {
          label: 'Publicado',
          label_alt: 'Publicar',
          description: 'El contenido está publicado y disponible',
        },
        draft: {
          label: 'Borrador',
          description: 'Trabajo en curso',
        },
        scheduled: {
          label: 'Programado',
          description: 'Programado para publicarse en una fecha futura',
          scheduled_date: 'Programado para publicarse el {{date}}',
        },
        unpublished: {
          label: 'No publicado',
          label_alt: 'No publicar',
          description: 'Retirado de la publicación',
        },
        processing: {
          label: 'Procesando',
          description: 'El contenido está siendo procesado',
        },
        deleted: {
          label: 'Eliminado',
          description: 'El contenido ha sido eliminado',
        },
        unpublished_changes: {
          label: 'Cambios sin publicar',
          description: 'Publicado con borradores pendientes',
        },
      },
    },
    static: {
      label: 'Estático (sin activos)',
    },
    urlmap: {
      label: 'Constructor de páginas',
      input: {
        label: 'Mapa de URL',
        help: 'Selecciona un Mapa de URL',
      },
      actions: {
        add_url: 'Agregar URL hijo',
        set_skin: 'Establecer la apariencia de la URL',
        inherit_skin: 'Heredar apariencia del padre',
        confirm_delete: {
          label: 'Confirmar eliminación',
          help: '¿Está seguro de que desea eliminar esta URL? Esta acción no se puede deshacer.',
        },
        restore_alias: {
          label: 'Restaurar',
          help: 'Restaurar el valor de la URL de redirección',
        },
        search: {
          label: 'Buscar páginas',
        },
        cancel_alias: {
          label: 'Cancelar redirección',
          help: 'Cancelar y volver a Editar',
        },
        filter: {
          label: 'Filtrar resultados',
          alias: 'Solo redirecciones',
          app: 'Filtrar por aplicación',
        },
      },
      customizations: {
        label: 'Personalizaciones de la página',
        notifications: {
          saved: 'Las personalizaciones de la página se guardaron correctamente',
          error: 'Error al guardar las personalizaciones de la página',
          reset:
            'Las personalizaciones de la página se restablecieron a los valores anteriores',
          empty: 'No hay personalizaciones de página disponibles',
        },
        confirmations: {
          reload: {
            title: 'Cambios no guardados',
            message:
              'Tienes personalizaciones de página no guardadas en esta página. ¿Estás seguro de que quieres recargar y perder estos cambios?',
            confirm: 'Recargar de todos modos',
          },
          navigation: {
            title: 'Cambios no guardados',
            message:
              'Tienes personalizaciones de página no guardadas. ¿Quieres continuar sin guardar?',
            confirm: 'Continuar',
          },
        },
        validation: {
          invalid_before_saving: 'Corrige los valores inválidos antes de guardar.',
        },
      },
      properties: {
        label: 'Propiedades de la página',
      },
      map: {
        name: {
          label: 'Nombre del mapa',
        },
        global: {
          label: 'Piel global',
          help: 'Establecer la piel global',
        },
        template_library: {
          label: 'Biblioteca de plantillas',
        },
      },
      node: {
        label: 'Propiedades de la página',
        name: {
          label: 'Nombre',
          description: 'El nombre de la URL.',
          help: 'El nombre es obligatorio',
        },
        app: {
          label: 'Aplicación',
        },
        alias: {
          label: 'URL de redirección',
          short_label: 'Redirección',
          help: 'Se requiere la URL de redirección',
          warning:
            'Establecer una URL de redirección puede resultar en la pérdida de la ubicación de los bloques de esta página y otras configuraciones.',
        },
        title: {
          label: 'Título de la página',
          description:
            'Una frase concisa y legible para describir esta página, que los motores de búsqueda utilizan para determinar la relevancia de la página y mejorar su calificación.',
        },
        node_label: {
          label: 'Etiqueta',
          description:
            'Una palabra o frase descriptiva muy breve que describe esta página y que puede contribuir a que los motores de búsqueda determinen su relevancia.',
        },
        parent: {
          label: 'URL padre',
        },
        allow_archiving: {
          label: 'Permitir archivado',
        },
        prevent_indexing: {
          label: 'Prevenir indexación',
        },
        searchable: {
          label: 'Buscable',
        },
        template: {
          label: 'Apariencia',
        },
      },
      help: {
        select_view: 'Seleccione una URL para ver.',
        select_edit: 'Seleccione una URL para editar.',
        no_results: 'No se han devuelto URLs.',
        redirects_to: 'Esta página redirige a',
      },
    },
    dashboards: {
      label: 'Tableros',
      titles: {
        default: 'Panel de Control',
        editorial: 'Panel Editorial',
        subscription: 'Panel de Usuario',
        emailreach: 'Panel de Campañas',
        journeys: 'Panel de Viajes',
      },
      table: {
        no_data: 'Sin datos',
        rows_per_page: 'Filas por página:',
        of: 'de',
        more_than: 'más de',
      },
      errors: {
        error: 'Ocurrió un error desconocido.',
        noData: 'No hay datos disponibles.',
      },
      exports: {
        title: 'Exportar como CSV',
        description:
          'Los datos exportados coincidirán con los filtros aplicados actualmente.',
        description_all: 'Se exportarán todos los datos.',
        button: 'Exportar CSV',
        download: 'Iniciar exportación',
        download_started:
          'Su exportación CSV se está preparando y la descarga comenzará en breve.',
        export_started: 'Exportación CSV iniciada',
        export_failed: 'Exportación CSV falló',
        preparing: 'Preparando tu exportación CSV...',
        error:
          'Hubo un error al preparar su exportación CSV. Por favor, inténtelo de nuevo.',
        table_field: {
          label: 'Especifique cuántos datos exportar:',
          all: 'Todas las filas',
          25: 'Primeras 25 filas',
          50: 'Primeras 50 filas',
          100: 'Primeras 100 filas',
        },
      },
      needHelp: {
        header: '¿Necesitas ayuda?',
        subtitle: 'Has venido al lugar correcto.',

        title: 'Empezando',
        resources: 'Recursos',
        bloxUniversity: {
          title: 'Universidad BLOX',
          subtitle: 'Explora nuestros cursos de formación en video',
        },
        documentation: {
          title: 'Documentación',
          subtitle: 'Explora nuestra documentación',
        },
        support: {
          title: 'Soporte',
          subtitle: 'Obtén ayuda para resolver un problema o ver tus solicitudes',
        },
        updates: {
          title: 'Novedades en BLOX NXT',
          subtitle: 'Consulta las últimas actualizaciones y mejoras del producto',
        },
      },
      kpis: {
        trend_sprites: {
          up: 'Sube desde {{priorValue}}',
          down: 'Baja desde {{priorValue}}',
          neutral: 'Sin cambios respecto al período anterior',
        },
        kpi_bar: {
          filters: {
            title: 'Filtros',
            description:
              'Aplica filtros para actualizar los datos mostrados en este ticker.',
          },
        },
      },
      charts: {
        funnel: {
          percent_diff: '{{percent}}% {{direction}} desde el anterior',
        },
      },
      loading_chip: {
        live: 'En vivo',
        live_on:
          'Actualizaciones en vivo ACTIVADAS - Actualiza cada {{refresh}} segundos',
        live_off:
          'Actualizaciones en vivo DESACTIVADAS - Actualiza cada {{refresh}} segundos',
        updating: 'Actualizando',
        error: 'Error',
        refresh: 'Se actualiza cada {{refresh}} minutos',
        min15: 'Actualiza cada 15 minutos',
        min30: 'Actualiza cada 30 minutos',
        hour: 'Actualiza cada hora',
        off: 'APAGADO',
      },
      mask: {
        title: 'Desbloquear {{title}} Analíticas',
        gen_title: 'Desbloquear Analíticas',
        dashboard: 'Desbloquear Analíticas',
        description:
          'Obtenga acceso a análisis detallados y conocimientos con nuestro complemento de Analíticas.',
        tooltip: 'Disponible con el paquete Pro DataInsights.',
      },
      controls: {
        error: 'No se pudieron aplicar los filtros.',
        success: 'Filtros aplicados con éxito.',
        filters_tip:
          'Usa los filtros para personalizar los datos mostrados en el tablero. Las opciones de filtro pueden variar según el widget.',
        filters_warning: 'No todos los widgets admiten estos filtros.',
      },
      widgets: {
        applied_filters: 'Filtros aplicados: {{count}}',
        widget_has_custom_parameters:
          'Este widget está configurado con filtros específicos.',
        dashboard_filters_may_not_apply: 'Los filtros del tablero no se aplicarán.',
        filters: 'filtros',
        filter: 'filtro',
        the: 'Los',
        do_not_apply: 'no se aplican',
        does_not_apply: 'no se aplica',
        to_this_widget: 'a este widget.',
        filters_still_apply: 'filtros todavía se aplican.',
        filter_still_applies: 'filtro todavía se aplica.',
        all_other_filters_applied: 'Todos los demás filtros se han aplicado.',
        locked_widget: 'Widget bloqueado',
        filter_info: 'Información del filtro',
      },
      user_permissions: {
        title: 'Permisos faltantes',
        description:
          'Actualmente no tienes acceso para ver este panel. Contacta a tu administrador de cuenta para solicitar acceso.',
      },
      custom_dashboards: {
        search: {
          title: 'Título',
          status: 'Estado',
          publish: 'Público',
          private: 'Privado',
          created_by: 'Creado por',
          columns: {
            title: 'Nombre del panel',
            status: 'Estado',
            created_by: 'Creado por',
          },
          app: {
            label: 'Aplicación',
            placeholder: 'Selecciona una aplicación',
            options: {
              editorial: 'Editorial',
              community: 'Comunidad',
            },
          },
          name: {
            label: 'Nombre del panel',
            placeholder: 'Ingresa el nombre del panel',
          },
          type: {
            all: {
              label: 'Todos',
              desc: 'Todos los paneles a los que tienes acceso',
            },
            public: {
              label: 'Público',
              desc: 'Disponible para todos los usuarios',
            },
            private: {
              label: 'Privado',
              desc: 'Solo visible para ti',
            },
          },
        },
        edit: {
          title: 'Editar Panel: {{dashboardName}}',
          title_disabled: 'Habilita la edición para cambiar el nombre del panel',
          success: 'Panel actualizado correctamente',
          error: 'Error al actualizar el panel. Por favor, intenta de nuevo.',
          label: 'Editar título del panel',
          close_btn: 'Salir del modo de edición y previsualizar el panel',
          configure_widget: 'Configurar Widget - Próximamente',
          change_layout: 'Cambiar diseño',
          column_empty_msg: 'Arrastra un widget a esta columna para agregarlo a tu panel',
          cancel_title: 'Tienes cambios sin guardar',
          cancel_confirmation:
            'Tienes cambios sin guardar. ¿Estás seguro de que deseas descartarlos y salir del modo de edición?',
          save_success: 'Panel guardado correctamente',
          save_error: 'Error al guardar el panel',
          changes_discarded: 'Cambios descartados',
          module: {
            modify: 'Configurar widget',
            remove_confirm: '¿Eliminar widget?',
            remove_msg: '¿Está seguro de que desea eliminar "{{widgetTitle}}" del panel?',
            tooltip:
              'Edite los filtros del panel, como rango de fechas, nombre de host y más.',
            save_error:
              'Error al guardar la configuración del widget. Por favor, intenta de nuevo.',
            save_success: 'Configuración del widget guardada correctamente',
            display_type: 'Tipo de visualización',
            display_type_help: 'Selecciona cómo deseas mostrar los datos de este widget',
          },
        },
        create: {
          title: 'Crear Panel',
          success: 'Panel creado correctamente',
          error: 'Error al crear el panel. Por favor, intenta de nuevo.',
          form: {
            title: {
              req: 'El título es obligatorio.',
              min: 'El título debe tener al menos 3 caracteres.',
              label: 'Título del panel',
              placeholder: 'Ingresa el título del panel',
            },
            select_layout: 'Seleccionar diseño',
          },
        },
        duplicate: {
          title: 'Duplicar Panel',
          success: 'Panel duplicado correctamente',
          error: 'Error al duplicar el panel. Por favor, intenta de nuevo.',
          form: {
            title: {
              req: 'El título es obligatorio.',
              max: 'El título no puede exceder los 140 caracteres.',
              min: 'El título debe tener al menos 3 caracteres.',
              label: 'Título del panel',
              placeholder: 'Ingresa el título del panel',
            },
            duplicate_restrictions: {
              label: 'Duplicar restricciones de acceso',
              caption: 'Copia los usuarios y grupos que pueden ver este panel.',
            },
            copy_suffix: {
              placeholder: 'Copy of {{title}}',
            },
          },
        },
        widget_library: {
          title: 'Biblioteca de widgets',
          desc: 'Haz clic para agregar o arrastra widgets a tu panel',
          coming_soon:
            'Nota: La integración de la Biblioteca de widgets está en desarrollo (CMSADMIN-721)',
          search_placeholder: 'Buscar widgets...',
          drag_help: 'Arrastra los widgets a tu panel para agregarlos',
          save_success: 'Widget agregado correctamente',
          save_error: 'Error al agregar el widget, por favor intenta de nuevo',
          drag_success: 'Widget movido correctamente',
          drag_error: 'Error al mover el widget, por favor intenta de nuevo',
          delete_success: 'Widget eliminado',
          delete_error: 'Error al eliminar el widget, por favor intenta de nuevo',
        },
        no_access: {
          header: 'Aplicación no habilitada',
          details:
            'El dominio seleccionado actualmente no tiene acceso a esta aplicación.',
          contact: 'Por favor, contacta a tu administrador para más información.',
          not_owner_header: 'Acceso Denegado',
          not_owner_details:
            'Solo puedes editar paneles personalizados que posees. Este panel pertenece a otro usuario.',
        },
        errors: {
          loading: 'Error al cargar el panel. Por favor, intenta de nuevo.',
        },
      },
      alerts: {
        label: 'Alertas',
        set_alert: 'Establecer alerta para {{widgetTitle}}',
        manage_alerts: 'Gestionar alertas para {{title}}',
        create_alert: 'Crear alerta para {{title}}',
        edit_alert: 'Editar alerta para {{title}}',
        create_new: 'Crear nueva alerta',
        cadence: 'Cadencia',
        domains: 'Dominios',
        no_more_alerts: 'No hay más alertas',
        form: {
          when_the: 'Cuando el ',
          of: 'de',
          when_value_of_prefix: 'Cuando el valor de ',
          when_value_of_suffix: ' es: ',
          description:
            'Configure alertas para monitorear indicadores clave de rendimiento y reciba notificaciones cuando se cumplan umbrales específicos, permitiendo decisiones y acciones oportunas.',
        },
        delete: {
          title: '¿Eliminar alerta?',
          warning:
            '¿Está seguro de que desea eliminar esta alerta? Esta acción no se puede deshacer.',
        },
        success: {
          create: 'Alerta creada exitosamente',
          update: 'Alerta actualizada exitosamente',
          delete: 'Alerta eliminada exitosamente',
        },
        errors: {
          no_alerts: 'Sin alertas establecidas',
          no_fields: 'No se puede crear alerta',
        },
      },
    },
    dynamic_fields: {
      image: {
        dropzone: {
          subtitle: 'Suelta la imagen aquí',
          caption: 'Arrastra y suelta la imagen o haz clic para buscar archivos',
          uploading: 'Subiendo...',
        },
      },
    },
    block_manager: {
      block_library: {
        label: 'Biblioteca de Bloques',
      },
      duplicate_block: {
        label: 'Duplicar bloque',
        success: 'Bloque duplicado con éxito',
        error: 'Error al duplicar el bloque',
      },
      copy_block: {
        error_no_template_library_for_domain:
          'No se encontró biblioteca de plantillas para este dominio',
        error_template_library_mismatch:
          'Desajuste de biblioteca de plantillas en mapa de URL activo',
        error_fetch_all_sites: 'Error al obtener todos los sitios',
        error_invalid_domain: 'Dominio inválido',
        error_no_active_url_map: 'No se encontró mapa de URL activo',
        error_fetch_url_map: 'Error al obtener mapa de URL',
        error_missing_ids: 'Falta ID de mapa o ID de bloque',
        label: 'Copiar al sitio',
        site_select: 'Seleccionar sitios de destino',
        target_sites_label: 'Sitios de destino',
        no_target_sites:
          'No hay otros sitios disponibles para copiar. Actualmente estás en {{site}}, que es el único sitio al que tienes acceso.',
        processing_progress: 'Procesando {{count}} sitios... {{progress}}',
        processing_progress_one: 'Procesando {{count}} sitio... {{progress}}',
        retryable_errors_summary: '{{count}} sitios fallaron al procesar',
        retryable_errors_summary_one: '{{count}} sitio falló al procesar',
        summary: 'Copiado exitosamente a {{success}} de {{total}} sitios.',
        summary_one: 'Copiado exitosamente a {{total}} sitio.',
        summary_error: '{{error}} sitios no fueron compatibles.',
        summary_error_one: '{{error}} sitio no fue compatible.',
        site_header: 'Sitio',
        status_header: 'Estado',
        confirm_close_title: '¿Estás seguro de que quieres cerrar?',
        confirm_close_content:
          'Cualquier copia que aún no se haya procesado será cancelada.',
        confirm_copy_header: 'Confirmar copiar bloque',
        confirm_copy_sub_text_one: 'Copiar este bloque a {{count}} sitio',
        confirm_copy_sub_text_other: 'Copiar este bloque a {{count}} sitios.',
        confirm_copy_sub_text_all: 'Copiar este bloque a todos los sitios.',
        confirm_copy_button: 'Sí, Copiar',
      },
      create_block: {
        label: 'Crear un nuevo bloque',
        app_not_installed: 'Aplicación requerida no instalada',
      },
      edit_block: {
        label: 'Editar el bloque {{type}} #{{id}}',
        loading: 'Cargando los datos del bloque...',
        error: 'Error al guardar el bloque',
        fail: 'Error al cargar los datos del bloque',
        validation: {
          name_required: 'El nombre del bloque es requerido',
        },
      },
      delete_block: {
        label: 'Eliminar bloque',
        confirm:
          '¿Estás seguro de que deseas eliminar este bloque? Esta acción no se puede deshacer.',
        success: 'Bloque eliminado con éxito',
        error: 'No se pudo eliminar el bloque',
      },
      unsaved_changes: {
        title: 'Cambios sin guardar',
        message:
          'Tienes cambios de diseño de bloques sin guardar. ¿Quieres guardar estos cambios antes de salir?',
      },
      place_block: {
        label: 'Colocar bloque',
        help: 'Por favor selecciona bloques para colocar desde la biblioteca de bloques',
        status: 'Colocado',
      },
      search_blocks: {
        label: 'Buscar bloques',
        empty: 'No se encontraron bloques',
        filter: {
          label: 'Opciones de filtro',
          options: {
            all: 'Todos',
            app_business: 'app: Negocios',
            app_calendar: 'app: Calendario',
            app_classifieds: 'app: Clasificados',
            app_editorial: 'app: Editorial',
            app_electionstats: 'app: Estadísticas electorales',
            app_eedition: 'app: Edición digital',
            app_static: 'app: Bloques estáticos',
            placed_yes: 'Colocados: Sí',
            placed_no: 'Colocados: No',
            sort_name_asc: 'Ordenar: Nombre (ascendente)',
            sort_date_created_desc: 'Ordenar: Fecha creada (descendente)',
            sort_date_modified_desc: 'Ordenar: Fecha modificada (descendente)',
          },
        },
      },
      query_results: {
        label: 'Resultados de la consulta',
        empty: 'No se devolvieron resultados',
        actions: {
          pin: {
            label: 'Fijar activo',
            description: 'No desanclar automáticamente',
            help: 'El activo permanecerá fijado hasta que se desanclado manualmente.',
          },
          pin_multiple: {
            label: 'Fijar activos',
          },
          unpin: {
            label: 'Desfijar activo',
          },
          pin_options: 'Opciones de activos fijados',
          schedule_unpin: {
            label: 'Programar desfijación',
            description: 'Desfijar activo en una fecha y hora específicas',
          },
          edit: {
            help: {
              draft_no_publish:
                'Nota: Este activo es un borrador y no se puede editar. Por favor, publique el activo para habilitar la edición.',
            },
          },
          override_display: {
            label: 'Modificar visualización',
            toggle: {
              label: 'Modificar propiedades de visualización',
              description: 'Marque para habilitar los reemplazos',
              description_off: 'Desmarque para usar los valores del activo',
            },
            fields: {
              title: {
                label: 'Título',
                description: 'Ingrese un reemplazo para el título de este activo',
                help: 'El título es obligatorio',
              },
              summary: {
                label: 'Resumen',
                description: 'Ingrese un reemplazo para el resumen de este activo',
              },
            },
          },
        },
      },
      query_rules: {
        label: 'Reglas de consulta',
        add: 'Agregar regla de consulta',
        help: 'Seleccione la regla de consulta a aplicar',
        empty: 'No se han definido reglas de consulta',
      },
      query_size: {
        label: 'Cambiar el tamaño de la consulta',
        first_result: 'Primer resultado',
        max_results: 'Máximo de resultados',
        tooltip_first_result: 'Establecer el resultado inicial',
        tooltip_max_results: 'Establecer el número máximo de resultados a mostrar',
        error_first_result: 'El valor debe ser mayor que 0',
        error_max_results: 'El valor debe estar entre 1 y 50',
      },
      sort_rules: {
        label: 'Reglas de orden',
        add: 'Agregar regla de orden',
        help: 'Seleccione la regla de orden a aplicar',
        empty: 'No se han establecido reglas de orden',
        random: {
          label: 'Ordenar aleatoriamente',
          help: 'Los elementos se ordenarán aleatoriamente.',
        },
        direction: 'Dirección',
      },
      customizations: {
        label: 'Personalizaciones',
        search: 'Buscar personalizaciones',
        loading: 'Cargando opciones de apariencia...',
        error: 'Error al cargar las opciones de apariencia',
      },
      block_title: {
        label: 'Título del bloque',
        help: 'Ingrese el título del bloque',
      },
      block_title_link: {
        label: 'URL del enlace del título',
        help: 'Ingrese una URL para vincular el título',
        new_window: 'Abrir el enlace en una nueva ventana',
        error: 'Ingrese una URL válida (https://example.com)',
      },
      links: {
        label: 'Enlaces',
        empty: 'No se ingresaron enlaces',
        help: 'Agregar un nuevo enlace',
        help_edit: 'Editar enlace',
        options: {
          use_url_map: {
            label: 'Seleccionar desde el mapa de página',
          },
        },
        fields: {
          link_label: {
            label: 'Etiqueta',
            help: 'Ingrese la etiqueta del enlace',
          },
          link_url: {
            label: 'URL',
            help: 'Ingrese la URL para el enlace',
            error_duplicate: 'Este enlace ya existe tal como se ingresó',
            error_invalid: 'Ingrese una URL válida (https://ejemplo.com)',
          },
        },
      },
      css_classes: {
        label: 'Clases CSS',
        help: 'Acepta múltiples clases',
        count: '{{count}} en total',
      },
      configuration: {
        label: 'Configuración',
        fields: {
          name: {
            label: 'Nombre del bloque',
            description: 'Ingrese un nombre para el bloque',
            help: 'El nombre del bloque es obligatorio',
          },
          description: {
            label: 'Descripción',
            description: 'Ingrese una descripción para el bloque',
          },
          tag: {
            label: 'Agregar una etiqueta',
            description: 'Ingrese etiquetas para el bloque',
          },
        },
        help: 'Seleccione la configuración a aplicar',
        empty: 'No se han configurado configuraciones',
      },
      block_preview: { label: 'Vista previa del bloque' },
      block_usage: {
        label: 'Uso del bloque',
        empty: 'Este bloque no se utiliza actualmente en ninguna página.',
      },
      template: {
        label: 'Plantilla',
        selected: 'Plantilla seleccionada',
        loading: 'Cargando opciones de plantilla...',
        not_found: 'No se encontraron plantillas de {{app}} para "{{search}}"',
      },
      application: {
        label: 'Tipo de bloque',
        no_edit: 'El tipo de bloque no se puede cambiar',
      },
    },
    region_manager: {
      page_rendering_failures: 'Se produjeron errores al renderizar la pagina.',
      region: {
        label: 'Regiones de la página',
        options: 'Opciones',
        add_blocks: 'Agregar bloques',
        disinherit_blocks: 'Desheredar bloques',
        inherit_blocks: 'Heredar bloques',
        unlock_region: 'Desbloquear region',
        lock_region: 'Bloquear region',
        thumbnail_alt: 'Miniatura de region',
        full_size_image_alt: 'Imagen de tamano completo',
        search: {
          label: 'Buscar regiones',
          no_results: 'No se encontraron bloques o regiones',
        },
        filter: {
          label: 'Filtrar regiones',
          description: 'Mostrar regiones con bloques de:',
        },
      },
      utility_region: {
        label: 'Regiones utilitarias',
        ungrouped: 'Sin grupo',
        block_count_one: '{{count}} bloque',
        block_count_other: '{{count}} bloques',
      },
      navigation_region: {
        label: 'Regiones de navegación',
        search: {
          label: 'Buscar en la navegación',
        },
      },
    },
    state: {
      disabled: 'Desactivado',
      enabled: 'Activado',
    },
    email_reach: {
      actions: {
        new: 'Nuevo',
        reconnect: 'Reconectar proveedor de servicio de correo',
      },
      common: {
        lists: 'Listas',
        default: 'Predeterminado',
        status: {
          label: 'Estado de suscripción',
          active: 'Suscrito',
          unsubscribed: 'Dado de baja',
        },
      },

      // Search functionality
      search: {
        title: 'Búsqueda de Email Reach',
        contact_lists: 'Listas de contactos',
        loading: 'Cargando listas de contactos...',
        loading_contacts: 'Cargando contactos...',
        loading_messages: 'Cargando mensajes...',
        loading_campaigns: 'Cargando campañas...',
        no_results: 'No se encontraron listas de contactos',
        error: 'Error al cargar las listas de contactos',
        label: 'Buscar un contacto específico...',
        placeholder: 'Buscar listas de contactos...',
        kpi_bar: {
          date_range: 'Cambiar rango de fechas',
          start: 'Inicio',
          end: 'Fin',
        },
      },

      // Account management
      account: {
        loading: 'Cargando cuentas...',
        error: 'Error al cargar las cuentas',
        empty:
          'No se encontraron cuentas. Por favor, cree una cuenta ESP para usar esta función.',
        placeholder: 'Seleccionar cuenta',
        aria_label: 'Seleccionar cuenta de Email Reach',
        creating: 'Creando cuenta…',
        notifications: {
          connected: '¡Cuenta ESP conectada exitosamente!',
          create_failed: 'Error al crear la cuenta: {{error}}',
        },
        defaults: {
          account_name: 'Mi cuenta ESP',
        },
        table: {
          name: 'Nombre',
          provider: 'Proveedor de correo electrónico',
          default: 'Predeterminado',
        },
        connect_modal: {
          header: 'Conectar cuenta de servicio de correo',
          section: {
            account_information: 'Información de la cuenta',
          },
          fields: {
            account_name: {
              label: 'Nombre de la cuenta',
              placeholder: 'Ingresa un nombre fácil de reconocer',
              help: 'Este nombre te ayudará a identificar esta conexión en tu panel',
            },
            email_provider: {
              label: 'Proveedor de correo electrónico',
              placeholder: 'Selecciona un proveedor de correo electrónico',
              help: 'Selecciona el servicio de correo con el que deseas conectar',
              no_vendors: 'No hay proveedores disponibles',
            },
          },
          alert_redirect: 'Serás redirigido a {{vendor}} para autorizar esta conexión.',
          error_loading_vendors: 'Error al cargar los proveedores. Inténtalo de nuevo.',
          connect_button: 'Conectar cuenta',
        },
      },

      // Account dropdown
      account_dropdown: {
        label: 'Cuenta',
        tooltip: 'Seleccionar cuenta de Email Reach',
        switch_account: 'Cambiar cuenta',
      },

      // Pre-search content
      pre_search: {
        welcome: 'Bienvenido a Email Reach',
        select_account: 'Seleccione una cuenta para ver las listas de contactos',
        getting_started: 'Comenzar',
      },

      // Contact management
      contact: {
        modal: {
          create_title: 'Crear nuevo contacto',
          edit_title: 'Editar contacto',
          loading_contact: 'Cargando contacto...',
          initializing: 'Inicializando...',
        },
        fields: {
          email: {
            from_email: 'Correo electrónico de respuesta',
            label: 'Dirección de correo electrónico',
            required: 'El correo electrónico es obligatorio',
            invalid: 'Ingrese un correo electrónico válido',
            email_optional_replies:
              'Dirección de correo electrónico de respuesta opcional para que los destinatarios respondan',
          },
          first_name: {
            label: 'Nombre',
            placeholder: 'Juan',
          },
          last_name: {
            label: 'Apellido',
            placeholder: 'Pérez',
          },
          lists: {
            label: 'Listas de contactos',
            placeholder: 'Seleccionar listas de contactos...',
            help: 'Agregar este contacto a una o más listas (opcional)',
          },
        },
        actions: {
          create: 'Crear contacto',
          update: 'Actualizar contacto',
          creating: 'Creando…',
          updating: 'Actualizando…',
          delete: {
            title: 'Eliminar contacto',
            warning: 'Esta acción no se puede deshacer.',
          },
        },
        subscription: {
          toggle_label: 'Suscripción por correo electrónico',
          toggle_helper:
            'Controla si este contacto debe recibir correos de Constant Contact.',
          button_unsubscribe: 'Dar de baja contacto',
          button_resubscribe: 'Volver a suscribir contacto',
          status_active:
            'Da de baja globalmente a este usuario de todos los correos que envíes como remitente. Esta acción no se puede deshacer desde Email Reach.',
          status_unsubscribed:
            'Este contacto está dado de baja globalmente. Haga clic a continuación para enviar un correo de confirmación de re-suscripción.',
          description:
            'Dar de baja detiene los correos de Constant Contact y mantiene las membresías de lista.',
          resubscribe_tooltip:
            'Se enviará un correo con un enlace de confirmación al contacto. Debe confirmar antes de recibir correos nuevamente.',
          resubscribe_lists_helper:
            'Selecciona al menos una lista antes de intentar volver a suscribir a este contacto.',
          errors: {
            no_lists:
              'Selecciona al menos una lista antes de intentar volver a suscribir este contacto.',
          },
        },
        resubscribe_modal: {
          header: 'Confirmar re-suscripción',
          title: 'Volver a suscribir contacto',
          description:
            'La re-suscripción enviará un correo de confirmación a este contacto. Debe hacer clic en el enlace de confirmación antes de poder recibir correos nuevamente.',
          impact_notice:
            'El contacto recibirá un correo de confirmación y debe confirmar explícitamente antes de ser re-suscrito. Su estado de suscripción se mostrará como pendiente hasta que confirme.',
          consent_checkbox:
            'Confirmo que este usuario ha solicitado explícitamente ser re-suscrito y ha dado su consentimiento para recibir correos.',
          confirm_button: 'Enviar correo de re-suscripción',
        },
        notifications: {
          created: 'Contacto creado exitosamente',
          updated: 'Contacto actualizado exitosamente',
          deleted: 'Contacto eliminado exitosamente',
          unsubscribed: 'Contacto cancelado correctamente',
          resubscribed:
            'Correo de re-suscripción enviado exitosamente. El contacto debe confirmar para completar la re-suscripción.',
        },
        errors: {
          no_account: 'Sin ID de cuenta',
          no_account_selected: 'Ninguna cuenta de correo seleccionada.',
          not_found: 'Contacto no encontrado',
          load_failed: 'Error al cargar el contacto',
          create_failed: 'Error al crear el contacto',
          update_failed: 'Error al actualizar el contacto',
          delete_failed: 'Error al eliminar el contacto',
          missing_ids: 'IDs faltantes',
          name_max_length: 'Debe tener como maximo {{max}} caracteres',
          unknown: 'Error desconocido',
          subscription_failed: 'No se pudo actualizar el estado de suscripción',
        },
        lists: {
          no_lists_available: 'No hay listas disponibles',
          loading_more: 'Cargando más…',
          all_loaded_prefix: 'Todas las listas cargadas',
          total: 'en total',
          unnamed: 'Lista sin nombre',
        },
        table: {
          email: 'Correo electrónico',
          first_name: 'Nombre',
          last_name: 'Apellido',
        },
      },

      export: {
        button: 'Exportar',
        preparing: 'Preparando…',
        queued: 'Exportación solicitada. Preparando la descarga…',
        success: 'Exportación de contactos descargada.',
        failed: 'No se pudieron exportar los contactos.',
        timeout: 'La exportación está tardando más de lo esperado. Inténtelo de nuevo.',
        account_required: 'Seleccione una cuenta para exportar contactos.',
        list_required: 'Seleccione una lista para exportar contactos.',
        single_list: 'Exporte una lista a la vez.',
        default_title: 'Exportación de contactos de Email Reach',
        menu_label: 'Contactos de Email Reach',
      },

      // Contact list management
      contact_list: {
        modal: {
          create_title: 'Crear nueva lista de contactos',
          edit_title: 'Editar lista de contactos',
          loading_contact_list: 'Cargando lista de contactos...',
          initializing: 'Inicializando...',
        },
        fields: {
          name: {
            label: 'Nombre de la lista',
            required: 'El nombre de la lista es obligatorio',
            min_length: 'El nombre de la lista debe tener al menos 2 caracteres',
          },
          from_name: {
            label: 'Nombre del remitente',
            required: 'El nombre del remitente es obligatorio',
            min_length: 'El nombre del remitente debe tener al menos 2 caracteres',
          },
          priority: {
            label: 'Prioridad',
            required: 'La prioridad es obligatoria',
            min: 'La prioridad debe ser al menos 1',
            max: 'La prioridad no puede exceder 99',
            help: 'Las listas de mayor prioridad se muestran primero (1-99)',
          },
          icon: {
            label: 'Ícono',
            options: {
              email: 'Correo electrónico',
              newsletter: 'Boletín',
              announcement: 'Anuncio',
              marketing: 'Marketing',
              notification: 'Notificación',
              update: 'Actualización',
              promotion: 'Promoción',
              event: 'Evento',
              news: 'Noticias',
              alert: 'Alerta',
            },
          },
          frequency: {
            label: 'Frecuencia',
            options: {
              daily: 'Diario',
              weekly: 'Semanal',
              bi_weekly: 'Quincenal',
              monthly: 'Mensual',
              quarterly: 'Trimestral',
              as_needed: 'Según necesidad',
              never: 'Nunca',
            },
          },
          toggles: {
            title: 'Configuración de la lista',
          },
          anonymous: {
            label: 'Lista anónima',
            help: 'Permite que los usuarios se suscriban sin registrarse ni iniciar sesión en el sitio',
          },
          display_on_signup: {
            label: 'Mostrar en el registro',
            help: 'Muestra esta lista como opción de suscripción cuando los usuarios se registran en el sitio',
          },
          hide: {
            label: 'Ocultar lista',
            help: 'Oculta esta lista en el sitio y solo la muestra en el administrador',
          },
        },
        actions: {
          create: 'Crear lista',
          update: 'Actualizar lista',
          creating: 'Creando…',
          updating: 'Actualizando…',
          delete: {
            title: 'Eliminar lista de contactos',
            warning:
              'Esta acción no se puede deshacer. Todos los contactos serán eliminados de esta lista.',
          },
        },
        notifications: {
          created: 'Lista de contactos creada exitosamente',
          updated: 'Lista de contactos actualizada exitosamente',
          deleted: 'Lista de contactos eliminada exitosamente',
        },
        errors: {
          no_account: 'No se proporcionó ID de cuenta',
          no_account_selected:
            'Ninguna cuenta de correo electrónico seleccionada. Por favor seleccione una cuenta primero.',
          not_found: 'Lista de contactos no encontrada',
          load_failed: 'Error al cargar la lista de contactos',
          create_failed: 'Error al crear la lista de contactos',
          update_failed: 'Error al actualizar la lista de contactos',
          delete_failed: 'Error al eliminar la lista de contactos',
          missing_ids: 'IDs requeridos faltantes',
          name_max_length: 'Usa {{max}} caracteres o menos',
          unknown: 'Ocurrió un error desconocido',
          fetch_lists: 'Error al obtener las listas de contactos',
          invalid_account: 'Cuenta seleccionada inválida',
        },
        table: {
          name: 'Nombre de la lista',
          contacts: 'Contactos',
          frequency: 'Frecuencia',
          last_updated: 'Última actualización',
          actions: 'Acciones',
        },
        status: {
          active: 'Activo',
          inactive: 'Inactivo',
          hidden: 'Oculto',
          anonymous: 'Anónimo',
        },
        loading: {
          lists: 'Cargando listas de contactos...',
          more: 'Cargando más listas...',
          account: 'Cargando datos de la cuenta...',
        },
        empty: {
          title: 'Sin listas de contactos',
          description: 'Crea tu primera lista de contactos para comenzar',
          create_button: 'Crear lista de contactos',
        },
      },
      message_modal: {
        header: {
          message_details: 'Detalles del mensaje',
          loading_message: 'Cargando mensaje...',
          no_subject: '(Sin asunto)',
        },
        status: {
          not_sent: 'No enviado',
          invalid_date: 'Fecha inválida',
        },
        status_labels: {
          sent: 'Enviado',
          completed: 'Completado',
          delivered: 'Entregado',
          active: 'Activo',
          queued: 'En cola',
          processing: 'Procesando',
          bounced: 'Rebotado',
          failed: 'Fallido',
          error: 'Error',
          spam: 'Spam',
          blocked: 'Bloqueado',
        },
        metrics: {
          title: 'Métricas de rendimiento',
          sent: 'Enviado',
          opens: 'Aperturas',
          clicks: 'Clics',
          forwards: 'Reenvíos',
          bounces: 'Rebotes',
          spam: 'Spam',
        },
        links: {
          title: 'Enlaces rastreados',
          total: 'total',
          url_header: 'URL',
          clicks_header: 'Clics',
          no_tracked_links: 'Sin enlaces rastreados',
        },
        technical: {
          title: 'Detalles técnicos',
          uuid: 'UUID',
          campaign_id: 'ID de campaña',
          external_id: 'ID externo',
          no_value: '—',
        },
        loading: 'Cargando...',
        error: {
          failed_to_load: 'Error al cargar el mensaje',
          missing_account_id: 'ID de cuenta o mensaje faltante',
          message_not_found: 'Mensaje no encontrado',
        },
      },
      messages: {
        search: {
          label: 'Buscar mensaje específico...',
        },
        filter: {
          label: 'Filtrar por',
          placeholder: 'Seleccionar tipo',
          all_types: 'Todos los tipos',
          list: 'Lista',
          segment: 'Segmento',
          list_type_label: 'Tipo de lista',
          campaign_type_label: 'Tipo de campaña',
          select_list_or_segment: 'Seleccionar lista/segmento',
          scheduled: 'Programado',
          single_run: 'Ejecución única',
          unnamed_list: 'Lista sin nombre',
          unnamed_segment: 'Segmento sin nombre',
        },
        table: {
          title: 'Título',
          status: 'Estado',
          sent_date: 'Fecha de envío',
        },
      },
      campaign: {
        pre_search: {
          filter_label: 'Audiencia',
          all_campaigns: 'Todas las campañas',
          active_filter: 'Filtro activo',
          loading_more: 'Cargando más...',
          scroll_for_more: 'Desplázate para ver más',
        },
        modal: {
          create_title: 'Crear campaña',
          edit_title: 'Editar campaña',
        },
        table: {
          active: 'Activo',
          schedule: 'Horario',
          title: 'Título',
          subject: 'Asunto del correo',
        },
        mini_menu: {
          duplicate: 'Duplicar',
          edit: 'Editar',
        },
        logs: {
          action: 'Ver registros',
          title: 'Registros de la campaña',
          log_date: 'Fecha del registro',
          loading_more: 'Cargando más...',
          no_results: 'No se encontraron registros para esta campaña.',
          unavailable:
            'Los registros no están disponibles o han expirado para esta campaña.',
          column: {
            time: 'Hora',
            status: 'Estado',
            driver: 'Controlador',
            message: 'Mensaje',
          },
          target_status: {
            success: 'Exitoso',
            failed: 'Error',
            warning: 'Advertencia',
            info: 'Info',
            unknown: 'Desconocido',
          },
          error: {
            failed_to_load: 'No se pudieron cargar los registros de la campaña.',
            missing_params: 'Falta información de la campaña.',
          },
        },
        steps: {
          type: {
            label: 'Tipo de campaña',
            title: 'Selecciona el tipo de campaña',
            required: 'Selecciona un tipo de campaña',
          },
          details: {
            label: 'Detalles',
            title: 'Detalles de la campaña',
          },
          schedule: {
            label: 'Programación',
            title: 'Configuración de la programación',
          },
          recurrence: {
            label: 'Recurrencia',
            title: 'Configuración de la recurrencia',
          },
          review: {
            label: 'Revisión',
            title: 'Revisar campaña',
          },
        },
        types: {
          single: {
            title: 'Campaña de envío único',
            description:
              'Una campaña de envío único entrega un mensaje dirigido una sola vez para impulsar la participación inmediata.',
          },
          scheduled: {
            title: 'Campaña programada',
            description:
              'Una campaña programada automatiza una serie de correos para lograr un compromiso continuo a largo plazo.',
          },
          single_run: 'campaña de envío único',
          campaign: 'campaña',
        },
        fields: {
          type: {
            label: 'Tipo de campaña',
          },
          audience: {
            label: 'Seleccionar audiencia',
            help: 'Elige si deseas enviar a una lista de contactos específica o a un segmento dinámico',
            required: 'Selecciona una audiencia',
            type_required: 'Selecciona un tipo de audiencia',
            select: 'Seleccionar {{type}}',
            all_loaded: 'Todos los {{type}} cargados',
          },
          title: {
            label: 'Título de la campaña',
            required: 'Se requiere el título de la campaña',
          },
          url: {
            label: 'URL de la campaña',
            help: 'La URL de la página de destino a la que se dirigirán los destinatarios',
            required: 'La URL es obligatoria',
            invalid: 'Introduce una URL válida que comience con http:// o https://',
            placeholder: 'https://www.ejemplo.com/pagina-de-destino',
          },
          custom_subject: {
            label: 'Usar asunto personalizado',
            help: 'Reemplaza la línea de asunto predeterminada con una personalizada',
          },
          subject: {
            label: 'Asunto del correo',
            required: 'El asunto personalizado es obligatorio',
          },
          disable: {
            label: 'Desactivar campaña',
            help: 'Crea la campaña en estado desactivado. Podrás activarla más adelante.',
          },
          schedule_type: {
            label: 'Tipo de programación',
            help: 'Elige con qué frecuencia debe ejecutarse la campaña',
            required: 'Selecciona un tipo de programación',
          },
          start_date: {
            label: 'Fecha de inicio',
            required: 'La fecha de inicio es obligatoria',
            future: 'La fecha de inicio no puede estar en el pasado',
          },
          send_time: {
            label: 'Hora de envío',
            required: 'La hora de envío es obligatoria',
          },
          run_indefinitely: {
            label: 'Ejecutar indefinidamente',
            help: 'La campaña continuará ejecutándose hasta que la detengas manualmente',
          },
          end_date: {
            label: 'Fecha de finalización',
            required: 'La fecha de finalización es obligatoria',
            after_start:
              'La fecha de finalización debe ser posterior a la fecha de inicio',
          },
          interval: {
            label: 'Intervalo de recurrencia',
            required: 'El intervalo es obligatorio',
            recur_every: 'Repetir cada',
            week: 'semana',
            weeks: 'semanas',
            min: 'El intervalo debe ser de al menos 1 semana',
            max: 'El intervalo no puede ser mayor a 52 semanas',
          },
          days_of_week: {
            label: 'Días de la semana',
            help: 'Selecciona en qué días debe enviarse la campaña',
            required: 'Selecciona al menos un día',
          },
          monthly_type: {
            label: 'Tipo de recurrencia mensual',
            required: 'Selecciona un tipo de recurrencia',
            specific_date: 'Fecha específica cada mes',
            specific_weekday: 'Día específico de la semana cada mes',
          },
          day_of_month: {
            label: 'Día del mes',
            required: 'El día del mes es obligatorio',
            range: 'El día debe estar entre 1 y 31',
          },
          occurrence: {
            label: 'Ocurrencia',
            required: 'La ocurrencia es obligatoria',
            select: 'Seleccionar ocurrencia',
          },
          weekday: {
            label: 'Día de la semana',
            required: 'El día de la semana es obligatorio',
            select: 'Seleccionar día',
          },
          timezone_notice:
            'Todos los horarios están en la zona horaria de tu sitio ({{timezone}}).',
          timezone_utc: 'La hora de envío seleccionada es {{utcTime}} UTC.',
        },
        recurrence: {
          description:
            'Elige con qué frecuencia se repite la campaña y en qué días se enviará.',
          frequency_label: 'Frecuencia',
          frequency_options: {
            weekly: 'Cada semana',
            biweekly: 'Cada dos semanas',
            every_four_weeks: 'Cada cuatro semanas',
          },
          custom_label: 'Personalizado',
          custom_every_prefix: 'Cada',
          week_singular: 'semana',
          week_plural: 'semanas',
          days_heading: 'Días de envío',
          days_presets: {
            weekdays: 'Días laborables',
            weekends: 'Fin de semana',
            mwf: 'Lun., Mié., Vie.',
            tth: 'Mar. y Jue.',
          },
          monthly_heading: 'Programación mensual',
          monthly: {
            options: {
              specific_date: {
                title: 'Fecha específica',
                description: 'Por ejemplo, el día 15 de cada mes',
              },
              specific_weekday: {
                title: 'Día específico de la semana',
                description: 'Por ejemplo, el primer lunes del mes',
              },
            },
            select_day: 'Selecciona el día',
            day_option: 'Día {{day}}',
            last_day: 'Último día',
            custom_input_label: 'Día del mes:',
            configure_weekday: 'Configurar el día de la semana',
            weekday_occurrence_prompt: '¿Qué ocurrencia?',
            weekday_day_prompt: '¿Qué día?',
          },
        },
        sections: {
          information: 'Información de la campaña',
          time_duration: 'Programar hora y duración',
        },
        audience: {
          contact_list: 'Lista de contactos',
          segment: 'Segmento',
          lists: 'listas',
          segments: 'segmentos',
        },
        schedule: {
          weekly: 'Semanal',
          monthly: 'Mensual',
        },
        schedule_preview: {
          upcoming: 'Próximos envíos',
          summary_label: 'Programación:',
        },
        schedule_details: {
          single: {
            summary: 'Programado como un envío único.',
            detail: 'Esta campaña se enviará una sola vez en la fecha programada.',
          },
          incomplete: {
            summary: 'Completa la programación para ver un resumen.',
          },
          weekly: {
            summary_every_week: 'Se repite cada semana.',
            summary_every_interval: 'Se repite cada {{interval}} semanas.',
            days_label: 'Días de envío',
          },
          monthly: {
            summary_specific_date: 'Se repite el día {{day}} de cada mes.',
            day_label: 'Día del mes',
            warning_short_months: 'Los meses con menos de {{day}} días se omitirán.',
            summary_specific_weekday: 'Se repite el {{occurrence}} {{day}} de cada mes.',
            weekday_label: 'Envío mensual',
          },
          time_label: 'Hora de envío',
          not_set: 'Sin definir',
          start_label: 'Fecha de inicio',
          end_label: 'Fecha de finalización',
          duration_label: 'Duración',
          run_indefinitely: 'Se ejecuta indefinidamente',
        },
        occurrence: {
          first: 'primer',
          second: 'segundo',
          third: 'tercer',
          fourth: 'cuarto',
          last: 'último',
        },
        occurrence_short: {
          first: '1.º',
          second: '2.º',
          third: '3.º',
          fourth: '4.º',
          last: 'Último',
        },
        review: {
          campaign_type: 'Tipo de campaña',
          audience: 'Audiencia',
          details: 'Detalles de la campaña',
          schedule: 'Programación',
          disabled_state: 'La campaña se creará en estado desactivado',
          ready_message: {
            create_scheduled:
              'Tu campaña está lista. Haz clic en «Crear campaña» para continuar.',
            create_single:
              'Tu campaña de ejecución única está lista para enviarse. Haz clic en «Crear ejecución única» para continuar.',
            edit: 'Revisa tus cambios y haz clic en «Actualizar campaña» para guardarlos.',
          },
        },
        actions: {
          creating: 'Creando...',
          create_single_run: 'Crear ejecución única',
          create_campaign: 'Crear campaña',
          update_campaign: 'Actualizar campaña',
          updating: 'Actualizando...',
          back_to_review: 'Volver a la revisión',
        },
        notifications: {
          created: '{{type}} creada correctamente!',
          updated: '¡Campaña actualizada correctamente!',
          load_failed: 'Error al cargar la campaña',
          update_failed: 'Error al actualizar {{type}}',
          duplicate_expired_dates:
            'Las fechas de la campaña original han expirado. Por favor, actualiza las fechas de inicio y fin.',
        },
        errors: {
          no_account: 'Ninguna cuenta seleccionada',
          not_found: 'Campaña no encontrada',
          create_failed: 'Error al crear {{type}}',
          update_failed: 'Error al actualizar {{type}}',
          load_failed: 'Error al cargar la campaña',
        },
        loading: 'Cargando campaña...',
        loading_description: 'Preparando los detalles de tu campaña...',
      },

      // Reauthentication
      reauth: {
        success_notification: '¡Reconectado a {{vendor}} correctamente!',
        error_start_login: 'Error al iniciar sesión. Por favor, inténtalo de nuevo.',
        success_message: '¡Cuenta reconectada correctamente!',
        error_message:
          'Hubo un problema al reconectar tu cuenta. Por favor, inténtalo de nuevo.',
        prompt_message:
          'Tu sesión de {{vendor}} ha expirado. Por favor, inicia sesión de nuevo para continuar.',
        success_title: 'Conexión restablecida',
        success_description: 'Tu cuenta de {{vendor}} se ha reconectado correctamente.',
        redirect_message: 'Redirigiendo a {{vendor}}...',
        warning_verify_account:
          'Por favor, verifica que estás iniciando sesión en la cuenta correcta de {{vendor}}.',
        loading_provider: 'Cargando información del proveedor...',
        done_button: 'Hecho',
      },

      // Widget de la vista de usuario
      user_widget: {
        title: 'Listas de boletines',
        add_button: 'Agregar',
        save_button: 'Guardar',
        saving_button: 'Guardando...',
        cancel_button: 'Cancelar',
        unsubscribe_all_button: 'Dar de baja al usuario globalmente',
        unsubscribing_button: 'Dando de baja...',
        remove_button: 'Eliminar',
        email_newsletter_list_header: 'Lista de boletines por correo',
        newsletter_subscriptions_header: 'Suscripciones a boletines',
        account_label: 'Cuenta',
        email_reach_lists_label: 'Listas de Email Reach',
        select_lists_help:
          'Selecciona listas de boletines para {{email}}. Desplázate para cargar más listas.',
        all_lists_loaded: 'Todas las listas disponibles están cargadas.',
        newsletter_actions_aria: 'Acciones del boletín para {{listName}}',
        remove_from_list: 'Eliminar de {{listName}}',
        list_fallback: 'la lista',
        untitled_list: 'Lista sin título',
        empty: {
          requires_permission: 'Requiere {{permission}}.',
          no_account: 'No hay una cuenta de Email Reach configurada.',
          setup_cta: 'Configurar Email Reach',
          no_email: 'Este usuario no tiene dirección de correo electrónico.',
          globally_unsubscribed: 'Este contacto está dado de baja globalmente.',
          no_lists_available: 'No hay listas de boletines de Email Reach disponibles.',
          unsubscribed_from_all:
            'Este contacto está dado de baja de todos los boletines de Email Reach.',
          no_subscriptions: 'No hay suscripciones a boletines disponibles.',
        },
        unsubscribe_all_modal: {
          title: '¿Dar de baja al usuario globalmente?',
          description:
            'Esto dará de baja globalmente a {{email}} de los correos de Email Reach para este remitente.',
          warning:
            'Este usuario tendrá el estado de baja y ya no podrá recibir correos de este remitente. Esto no se puede deshacer desde la sección de Contactos de NXT, y los usuarios deberán confirmar por correo electrónico para volver al estado de suscrito.',
          acknowledgement:
            'Entiendo que este contacto no puede volver a suscribirse desde aquí.',
        },
        notifications: {
          subscriptions_updated: 'Suscripciones a boletines actualizadas.',
          subscriptions_update_failed:
            'No se pudieron actualizar las suscripciones a boletines.',
          create_contact_failed: 'No se pudo crear el contacto de Email Reach.',
          unsubscribed_all:
            'Contacto dado de baja de todos los boletines de Email Reach.',
          unsubscribe_failed: 'No se pudo dar de baja al contacto.',
          cannot_resubscribe:
            'Este contacto está dado de baja globalmente y no puede volver a suscribirse aquí.',
        },
      },
    },
    modal: {
      confirmClose: 'Confirmar cierre',
      confirmClosePrimary: '¿Estás seguro de que deseas cerrar?',
      confirmCloseSecondary: '¡Esta acción descartará los cambios no guardados!',
      cancelCloseBtn: 'Cancelar',
      confirmCloseBtn: 'Sí, cerrar',
      prompt_delete: '¿Estás seguro de que deseas eliminar: {{name}}?',
      prompt_delete_basic: '¿Estás seguro de que deseas eliminar?',
      no_undo: 'Esta acción no se puede deshacer.',
      confirm_close: {
        header: 'Confirmar cierre',
        title: '¿Estás seguro de que deseas cerrar?',
        description: '¡Esta acción descartará los cambios no guardados!',
        cancel: 'Cancelar',
        confirm: 'Sí, cerrar',
      },
      confirm_delete: {
        header: 'Confirmar eliminación',
        title: '¿Seguro que deseas eliminar?',
        description: 'Esta acción no se puede deshacer.',
        pre_confirm: 'Por favor escribe',
        post_confirm: 'a continuación para permitir la eliminación.',
        input_label: 'Confirmación',
        cancel: 'Cancelar',
        confirm: 'Sí, eliminar',
      },
      simple_confirm: {
        header: 'Confirmar',
        title: '¿Está seguro?',
        description: '',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      simple_confirm_delete: {
        header: 'Confirmar eliminación',
        title: '¿Seguro que deseas eliminar?',
        description: 'Todos los elementos seleccionados se eliminarán.',
        cancel: 'Cancelar',
        confirm: 'Sí, eliminar',
        purge: {
          header: 'Confirmar eliminación permanente',
          title: '¿Seguro que deseas eliminar permanentemente?',
          description:
            'Esta acción no se puede deshacer. El elemento seleccionado, {{name}}, será eliminado de forma permanente.',
          cancel: 'Cancelar',
          confirm: 'Sí, eliminar permanentemente',
        },
        undo_deletion: {
          header: 'Confirmar restauración',
          title: '¿Seguro que deseas restaurar este elemento?',
          description: 'El elemento seleccionado, {{name}}, será restaurado.',
          description_multiple: '{{count}} elementos seleccionados serán restaurados',
          cancel: 'Cancelar',
          confirm: 'Sí, restaurar',
        },
      },
    },
    nav_builder: {
      header: 'Editar región de navegación "{{navRegionKey}}"',
      edit_navigation: 'Editar navegación',
      no_regions_found: 'No se encontraron regiones de navegación.',
      region_type_tab: 'Tipo de región',
      navigation_items_tab: 'Elementos de navegación',
      custom_item: 'Elemento en blanco',
      url_map_link: 'Enlace de mapa de URL',
      empty_state:
        'Aún no hay elementos de navegación. Haga clic en Agregar para crear elementos.',
      edit_navigation_item: 'Editar elemento de navegación',
      save_success: 'Navegación guardada correctamente',
      save_error: 'Error al guardar la navegación',
      autofill_selector: {
        placeholder: 'Seleccionar URL del mapa',
        error: 'Por favor seleccione una URL del mapa',
        manage_exclusions: 'Gestionar URLs excluidas ({{count}})',
      },
      exclusions: {
        header: 'Exclusiones de autocompletar',
        empty_state: 'Aún no se han agregado exclusiones.',
      },
      title: {
        label: 'Título',
        error: 'El título es obligatorio',
      },
      link: {
        label: 'Enlace',
        url_map_node: 'Enlazar al nodo del mapa de URL',
        custom_url: 'Enlazar a URL personalizada',
        none: 'No enlazar a nada',
        placeholder_select: 'Seleccionar URL del mapa',
        placeholder_enter: 'Ingresar URL',
      },
      children: {
        label: 'Hijos',
        manual: 'Crear hijos manualmente (usando el menú Agregar)',
        autofill: 'Autocompletar hijos desde el mapa de URL',
      },
      region_types: {
        inherit: {
          label: 'Heredar navegación de URL principal',
          description:
            'Esta región utilizará los elementos de navegación definidos o heredados por una región con nombre idéntico en una URL principal.',
        },
        define: {
          label: 'Definir nueva navegación en esta URL',
          description:
            'Defina nuevos elementos de navegación para esta región. Las regiones con nombre idéntico en las URL secundarias heredarán de esta.',
        },
        autofill: {
          label: 'Autocompletar navegación desde el mapa de URL',
          description:
            'La región se llenará automáticamente con los descendientes de la URL seleccionada.',
        },
        blank: {
          label: 'No mostrar ninguna navegación en esta URL',
          description:
            'Establecer esto en blanco garantiza que la región no aparezca. Las regiones con nombre idéntico en las URL secundarias heredarán este estado en blanco.',
        },
      },
      region_metadata_labels: {
        inherited_from: 'Heredado de {{sourcePath}}',
        autofilled_from: 'Rellenado automáticamente desde {{sourcePath}}',
        blank_display: 'No mostrar',
      },
    },
    site_selector: {
      // Site Selector and NoCosmosPermissions
      no_permissions: 'Sin permisos',
      message: 'Este sitio o cuenta no participa actualmente en BLOX NXT Admin.',
      contact:
        'Por favor, pruebe con un sitio diferente o contacte a un administrador para más información.',
      list_error:
        'Lo sentimos, se produjo un error al obtener los datos de la lista de sitios.',
      default_error:
        'Lo sentimos, se produjo un error al obtener los datos del sitio predeterminado.',
      redirected_to_1: 'Fue redirigido a:',
      redirected_to_2: 'ya que no tenía acceso a',
      switch_default_domain:
        'Cambie a un sitio diferente para cambiar su sitio predeterminado de inicio de sesión.',
      enable_login_default:
        'Active para establecer el sitio actual como su sitio predeterminado de inicio de sesión.',
      on_current_site: 'Actualmente se encuentra en este sitio.',
      active_site: {
        label: 'Sitio activo',
        placeholder: 'Filtrar lista de sitios...',
      },
    },
    common: {
      days: {
        short: {
          sun: 'Dom',
          mon: 'Lun',
          tue: 'Mar',
          wed: 'Mié',
          thu: 'Jue',
          fri: 'Vie',
          sat: 'Sáb',
        },
        full: {
          sunday: 'Domingo',
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sábado',
        },
      },
      address_suggestions: {
        searching: 'Buscando direcciones...',
        empty_prompt: 'Escribe para empezar a buscar direcciones',
      },
    },
    general: {
      asset_types: {
        anywhere: 'En cualquier lugar',
        article: 'Artículo',
        image: 'Imagen',
        collection: 'Colección',
        audio: 'Audio',
        file: 'Archivo',
        flash: 'Flash',
        html: 'HTML',
        link: 'Enlace',
        pdf: 'PDF',
        poll: 'Encuesta',
        table: 'Tabla',
        video: 'Video',
        youtube: 'YouTube',
        zip: 'ZIP',
      },
      aspect_ratio: 'Relación de aspecto',
      please_be_aware: 'Tenga en cuenta lo siguiente.',
      no_access: 'Lo sentimos, no tienes acceso a esta función.',
      no_options: 'No hay opciones disponibles.',
      contact_us: 'Contáctanos',
      contact_blox: 'Contáctanos para más información.',
      any: 'Cualquiera',
      auto: 'Automático',
      appearance: 'Apariencia',
      asset: 'Activo',
      assets: 'Activos',
      block: 'Bloque',
      blocks: 'Bloques',
      blox: 'BLOX',
      beta: 'Beta',
      beta_feature: 'Esta función está actualmente en versión beta.',
      canceled_by_user: 'Cancelado por el usuario',
      canceled: 'Cancelado',
      characters: 'caracteres',
      close_without_applying: 'Cerrar sin aplicar',
      coming_soon: 'Próximamente',
      comments: 'Comentarios',
      created: 'creado',
      configuration: 'Configuración',
      contact_sales: 'Contactar ventas',
      contributed: 'Contribuido',
      default: 'Predeterminado',
      disabled: 'Deshabilitado',
      count_selected: '{{count}} seleccionado',
      show_count_results: 'Mostrando {{count}} resultados',
      count_total: '{{count}} total',
      count_results: '{{count}} resultados',
      count_results_one: '{{count}} resultado',
      count_results_other: '{{count}} resultados',
      will_delete_one: '{{count}} elemento será eliminado.',
      will_delete: '{{count}} elementos serán eliminados.',
      collaborators: 'Colaboradores',
      current: 'Actual',
      disconnected: 'Desconectado',
      no_results: 'Sin resultados',
      search_text_disabled_placeholder: 'Búsqueda de texto deshabilitada...',
      flags: 'Indicadores',
      date: {
        label: 'Fecha',
        start_date: 'Fecha de inicio',
        end_date: 'Fecha de finalización',
        range: {
          custom: 'Rango de fechas personalizado',
          week: 'Últimos 7 días',
          month: 'Últimos 30 días',
          year: 'Último año',
          select: 'Seleccionar rango de fechas',
        },
      },
      date_range: {
        select: 'Seleccionar rango de fechas',
        invalid_input: 'Entrada no válida.',
        range_invalid:
          'Rango no válido: la fecha de fin es anterior a la fecha de inicio.',
        start_prefix: 'Inicio: {{date}}',
        end_prefix: 'Fin: {{date}}',
        clear_input: 'Limpiar entrada',
        help_text:
          'Este campo admite formatos de fecha relativos y absolutos, como los ejemplos a continuación.',
        presets: {
          today: 'Hoy',
          yesterday: 'Ayer',
          tomorrow: 'Mañana',
          last_30_days: 'Últimos 30 días',
          next_30_days: 'Próximos 30 días',
        },
        examples: {
          standard_textual: 'Fechas textuales estándar',
          american_mdy: 'Mes/día/año americano',
          month_and_year: 'Mes y año',
          start_of_today: 'Inicio de hoy',
          start_of_next_monday: 'Inicio del próximo lunes',
          days_ago: 'Hace 7 días',
          weeks_from_now: 'En 2 semanas',
        },
      },
      deleted: 'Eliminado',
      description: 'Descripción',
      end_of_results: 'Fin de resultados',
      entry: 'Entrada',
      enter_type: 'Ingresar {{type}}',
      enter_a_type: 'Ingresar un {{type}}',
      no_entries: 'No hay entradas',
      no_fields_configured: 'No hay campos configurados',
      items: 'Elementos',
      design: 'Diseño',
      display: 'Mostrar',
      error: 'Error',
      filter: 'Filtrar',
      filters: 'Filtros',
      import_mode: 'Modo de importación',
      import: 'Importar',
      invalid_url_help: 'URL no válida o debe comenzar con http:// o https://',
      export: 'Exportar',
      export_mode: 'Modo de exportación',
      include_children: 'Incluir hijos',
      edit_not_supported: 'La edición de {{type}} no está soportada',
      importing: 'Importando',
      label: 'Etiqueta',
      loading: 'Cargando...',
      initializing: 'Inicializando...',
      login: 'Iniciar sesión',
      more: 'Más',
      name: 'Nombre',
      new: 'Nuevo',
      no: 'No',
      no_selections: 'No hay selecciones',
      none: 'Ninguno',
      preview: 'Vista previa',
      primary: 'Primario',
      live: 'En vivo',
      live_view: 'Vista en vivo',
      group: 'Grupo',
      no_preview: 'Vista previa no disponible',
      no_more_results: 'No hay más resultados',
      no_results_found: 'No se encontraron resultados',
      off: 'Apagado',
      on: 'Encendido',
      options: 'Opciones',
      origin: 'Origen',
      original: 'Original',
      permission_required: 'Permiso requerido',
      placed_on_page: 'Colocado en la página',
      provide_url: 'Proporcionar una URL',
      publications: 'Publicaciones',
      processing: 'Procesando',
      privacy: 'Privacidad',
      private: 'Privado',
      range: 'Rango',
      readonly: 'Solo lectura',
      relationships: 'Relaciones',
      required: 'Requerido',
      retry: 'Reintentar',
      results_of_total_one: 'Mostrando {{results}} de {{count}} resultado',
      results_of_total_other: 'Mostrando {{results}} de {{count}} resultados',
      save_success: 'Guardado exitoso',
      search: 'Buscar',
      searchEllipsis: 'Buscar...',
      search_groups: 'Buscar grupos...',
      search_url: 'Buscar o pegar una URL',
      search_results: 'Resultados de búsqueda',
      select_date: 'Seleccionar fecha',
      selected_assets: 'Recursos seleccionados',
      selected: 'seleccionado',
      send_to_top: 'Enviar al principio',
      set_as_origin: 'Establecer como origen',
      search_or_add: 'Buscar o agregar',
      showing_total_results: 'Mostrando {{total}} resultados en total',
      no_results_press_enter_to_add:
        'No se encontraron resultados. Presiona Enter para agregar.',
      menu_of: 'Menú - {{label}}',
      remove_item: 'Eliminar {{label}}',
      remove_origin: 'Eliminar origen',
      settings: 'Configuración',
      sessions: 'Sesiones',
      showing: 'Mostrando',
      status: 'Estado',
      status_primary: 'Estado principal',
      suggestion: 'Sugerencia',
      ignore: 'Ignorar',
      shareable: 'Compartible',
      shared: 'Compartido',
      success: 'Éxito',
      title: 'Título',
      target: 'Objetivo',
      type: 'Tipo',
      test: 'Prueba',
      hidden: 'Oculto',
      updated: 'actualizado',
      untitled: 'Sin título',
      use_url: 'Usar URL',
      update_required: 'Actualización requerida',
      update_app_help:
        'Una nueva versión de BLOX NXT está lista. Haz clic para actualizar todas las pestañas.',
      update_app_suggest:
        'Una nueva versión de BLOX NXT está lista. Proceda a actualizar todas las pestañas, pero asegúrese de guardar cualquier cambio en las pestañas abiertas primero.',
      valid_hex: 'Ingrese un valor hexadecimal válido (por ejemplo, #FF0000)',
      words: 'palabras',
      yes: 'Sí',
      message: {
        label: 'Mensaje',
        unexpectedError: 'Se produjo un error inesperado.',
        no_preview: 'Vista previa no disponible',
        oops: '¡Ups! Algo salió mal',
      },
      noAccess: 'Lo sentimos, no tienes acceso a esta función.',
      noAccessSimple: 'Acceso requerido',
      contactBlox: 'Contáctanos para más información.',
      screenshot: 'Crear una captura de pantalla',
      capture_screenshot: 'Capturar una captura de pantalla',
      play_video_to_capture: 'Reproducir el video para capturar una captura de pantalla',
      screenshot_not_supported: 'La captura de pantalla no es compatible con este video',
      value_added_content: 'Contenido de valor añadido',
      view_at_site: 'Ver en el sitio',
    },
    error: {
      label: 'Error',
      invalid_form: 'El formulario no es válido. Corrija los errores.',
      unexpectedError: 'Ocurrió un error inesperado.',
      bad_request: 'Solicitud incorrecta',
      oops: '¡Vaya! Algo salió mal',
      unknown: 'Error desconocido',
      sorry_try_again:
        'Lo sentimos, ocurrió un error inesperado. Por favor, inténtelo de nuevo.',
      required: 'Obligatorio',
      min: '{{field}} debe ser al menos {{min}}',
      max: '{{field}} debe ser como máximo {{max}}',
      type_not_accepted: 'Este tipo de archivo no es aceptado.',
      only_one_file: 'Solo se puede proporcionar un archivo a la vez.',
    },
    validation: {
      form_invalid: 'El formulario no es válido',
      form_invalid_long: 'El formulario no es válido, por favor revise los errores.',
      value_invalid_generic: 'La entrada no es válida.',
      value_must_be_array: 'El {{label}} debe ser un arreglo',
      value_required: '{{label}} es obligatorio',
      value_count_required: '{{label}} debe tener al menos {{count}} seleccionado',
      value_invalid: '{{label}} no es válido',
      value_incomplete: '{{label}} está incompleto',
      value_empty: '{{label}} no puede estar vacío',
      value_too_long: '{{label}} es demasiado largo',
      date_invalid: '{{label}} no es una fecha válida',
      date_invalid_past: '{{label}} no puede estar en el pasado',
      date_ininvalid_future: '{{label}} no puede estar en el futuro',
      field_required: 'Este campo es obligatorio',
      incomplete_form: 'Por favor, complete todos los campos obligatorios',
      email_invalid: 'El correo electrónico no es válido',
    },

    notifier: {
      label: 'Notificador',
      disabled_create: 'Notificador deshabilitado en modo de creación',
      disabled_import: 'Notificador deshabilitado en modo de importación',
      disabled_mode: 'Notificador deshabilitado en este modo',
      draft_asset_disabled: 'Los activos en estado de borrador no se pueden programar',
      no_posts_found: 'No se encontraron publicaciones',
      no_channels_found: 'No se encontraron canales',
      create_post: 'Crear publicación',
      notifier_post: 'Publicación de notificador',
      editing_post: 'Editando publicación',
      viewing_post: 'Viendo publicación',
      save_draft: 'Guardar borrador',
      schedule_post: 'Programar publicación',
      scheduled_date_and_time: 'Fecha y hora programada',
      channels: 'Canales',
      channel_disabled: 'canal deshabilitado',
      message_published: 'Mensaje publicado',
      status_uneditable: '{{status}} las publicaciones no se pueden editar',
      status_undeletable: '{{status}} las publicaciones no se pueden eliminar',
      target_info: 'Seleccione un activo o proporcione una URL.',
      validation: {
        valid_target_required: 'Se requiere un activo o una URL válida',
        publish_channels_required: 'Se requiere al menos un canal para programar',
        date_invalid_start_time:
          'La fecha debe ser posterior o igual a la fecha de inicio de los activos',
        date_in_past_warning:
          'Con la fecha establecida en el pasado, la publicación se hará lo antes posible.',
      },
      status: {
        draft: 'borrador',
        canceled: 'cancelado',
        failed: 'fallido',
        pending: 'pendiente',
        sent: 'enviado',
        staged: 'preparado',
        undelivered: 'no entregado',
        partially_sent: 'parcialmente enviado',
        partially_sent_info: 'Entregado en algunas plataformas, fallido en otras',
        unknown: 'desconocido',
      },
      logs: {
        action: 'Ver registros',
        title: 'Registros de entrega',
        log_date: 'Fecha del registro',
        send_status: 'Estado de envío',
        loading_more: 'Cargando más...',
        no_results: 'No se encontraron registros de entrega para este envío.',
        column: {
          time: 'Hora',
          status: 'Estado',
          driver: 'Controlador',
          message: 'Mensaje',
        },
        target_status: {
          success: 'Exitoso',
          failed: 'Fallido',
          warning: 'Advertencia',
          info: 'Info',
          unknown: 'Desconocido',
        },
        error: {
          failed_to_load: 'No se pudieron cargar los registros de entrega.',
          missing_params: 'Falta información del envío.',
        },
      },
      search: {
        search_messages: 'Buscar mensajes...',
        asset_app: 'Aplicación',
        domain: 'Dominio',
        target: 'Objetivo',
        message: 'Mensaje',
        title: 'Título',
        social_title: 'Título social',
        social_summary: 'Resumen social',
        send_date: 'Fecha de envío',
        send_status: 'Estado',
        type: 'Tipo',
        channels: 'Canales',
      },
      channel: {
        title: 'Canal',
        create_channel: 'Crear canal',
        edit_channel: 'Editar canal',
        delete_channel: 'Eliminar canal',
        channel_name: 'Nombre del canal',
        general: 'General',
        automatic_notification_rules: 'Reglas de notificación automática',
        delivery_targets: 'Destinos de entrega',
        select_delivery_targets: 'Seleccionar destinos de entrega',
        add_targets: 'Agregar destinos',
        manage_targets: 'Gestionar destinos',
        no_targets_selected: 'No se han seleccionado destinos de entrega',
        enabled: 'Habilitado',
        disabled: 'Deshabilitado',
        all_systems_operational: 'Todos los sistemas operativos',
        auto_notification: 'Notificación automática',
        last_active: 'Última actividad',
        automatic_notify: 'Notificación automática',
        last_used_days_ago: 'Último uso hace {{days}} días',
        last_used_months_ago: 'Último uso hace {{months}} meses',
        never_used: 'Nunca usado',
        search_channels: 'Buscar canales...',
        no_channels: 'No se encontraron canales',
        filter_message_id: 'Mensaje',
        targets: {
          mobile_app: 'Aplicación móvil',
          facebook: 'Facebook',
          webhook: 'Webhook',
          push_notification: 'Notificación push',
        },
        rules: {
          title: 'Reglas de notificación automática',
          create_rule: 'Crear regla',
          edit_rule: 'Editar regla',
          delete_rule: 'Eliminar regla',
          rule_type: 'Tipo de regla',
          asset_type: 'Tipo de recurso',
          asset_types_label: 'Tipos de recursos',
          flags: 'Indicadores',
          keyword_tags: 'Etiquetas de palabras clave',
          section_tags: 'Etiquetas de sección',
          select_criteria: 'Seleccionar criterios',
          step_choose_type: 'Elegir tipo de regla',
          step_select_criteria: 'Seleccionar criterios',
          step_save: 'Guardar regla',
          no_rules: 'No hay reglas de notificación automática configuradas',
          inclusion_rule: 'Regla de inclusión',
          rule_name: 'Nombre de la regla (Opcional)',
          rule_name_helper:
            'Asigne un nombre descriptivo a su regla para facilitar la gestión',
          selected_values: 'Valores seleccionados',
          enter_keyword: 'Ingrese una palabra clave',
          no_flags: 'No hay indicadores disponibles',
          no_sections: 'No hay secciones disponibles',
          review_rule: 'Revise su regla',
          select_type_desc:
            'Seleccione un tipo de regla para determinar cómo se activan las notificaciones',
          suggestions: 'Sugerencias',
        },
        confirm_delete: '¿Está seguro de que desea eliminar este canal?',
        channel_created: 'Canal creado con éxito',
        channel_updated: 'Canal actualizado con éxito',
        channel_deleted: 'Canal eliminado con éxito',
      },
      channel_grid: {
        name: 'Nombre',
        delivery_targets: 'Destinos de entrega',
        auto_notification_rules: 'Reglas de notificación automática',
      },
      settings: {
        title: 'Configuración del notificador',
        social_accounts: {
          title: 'Cuentas sociales',
          description: 'Gestionar las cuentas de redes sociales para el notificador.',
          disconnect: 'Desconectar',
          disconnect_confirm: '¿Está seguro de que desea desconectar esta cuenta?',
          no_accounts: 'No se encontraron cuentas sociales.',
          platform: 'Plataforma',
          account_name: 'Nombre de la cuenta',
          actions: 'Acciones',
          account_disconnected: 'Cuenta social desconectada con éxito.',
          error_disconnect: 'Error al desconectar la cuenta social.',
          error_loading: 'Error al cargar las cuentas sociales.',
          account_count: '{{count}} conectada',
          account_count_plural: '{{count}} conectadas',
          unknown_provider: 'Desconocido',
        },
        automatic_notifications: {
          title: 'Configuración de notificaciones automáticas',
          description:
            'Activar o desactivar las notificaciones automáticas para los canales del notificador con un desplazamiento de tiempo.',
          enable_label: 'Activar notificaciones automáticas',
          enable_description:
            'Cuando están activadas, las notificaciones se envían automáticamente para los contenidos elegibles.',
          disable_description:
            'Cuando están desactivadas, las notificaciones deben activarse manualmente.',
          time_offset: 'Desplazamiento de tiempo',
          time_offset_help: 'Define cuánto tiempo atrás buscar contenidos elegibles.',
          time_offset_unit: {
            minutes: 'Minutos',
            hours: 'Horas',
          },
          time_offset_preview:
            'Las notificaciones buscarán contenidos elegibles en los últimos {{value}} {{unit}}.',
          save_success: 'Configuración de notificaciones automáticas guardada con éxito.',
          save_error: 'Error al guardar la configuración de notificaciones automáticas.',
        },
      },
    },
    journeys: {
      // Journey (Access Criteria)
      journey: 'Recorrido',
      update_journey: 'Actualizar recorrido',
      create_journey: 'Crear recorrido',
      delete_journey: 'Eliminar recorrido permanentemente',
      // Offer Group
      offer_group: 'Grupo de ofertas',
      create_offer_group: 'Crear grupo de ofertas',
      update_offer_group: 'Actualizar grupo de ofertas',
      edit_offer_group: 'Editar grupo de ofertas',
      delete_offer_group: 'Eliminar definitivamente el grupo de ofertas',
      offer_group_name_info: 'Un nombre corto para identificar este grupo de ofertas',
      // Method Group
      method_group: 'Grupo de métodos',
      method_group_id: 'ID del grupo de métodos',
      new_method_group: 'Nuevo grupo de métodos',
      create_method_group: 'Crear grupo de métodos',
      update_method_group: 'Actualizar grupo de métodos',
      edit_method_group: 'Editar grupo de métodos',
      delete_method_group: 'Eliminar grupo de métodos permanentemente',
      method_group_name_info: 'Un nombre corto para identificar este grupo de métodos',

      // Connections Sidepanel - Method Target
      connections: 'Conexiones',
      method_create_first:
        'La información se mostrará después de crear el grupo de métodos.',
      method_group_used: 'Este grupo de métodos está conectado a recorridos.',
      method_group_not_used:
        'Este grupo de métodos no está conectado a ningún recorrido.',
      // Connections Sidepanel - Rate Target
      rate_used: 'Esta tarifa está conectada a recorridos.',
      rate_not_used: 'Esta tarifa no está conectada a ningún recorrido.',
      rate_create_first: 'La información se mostrará después de crear la tarifa.',

      method: 'Método',
      methods: 'Métodos',
      wall_behavior: 'Comportamiento del muro',
      display_content: 'Mostrar contenido',
      hard_paywall_block: 'Bloqueo estricto de contenido de pago',
      hard_paywall_block_info:
        'El usuario debe suscribirse o realizar la acción para ver el contenido',
      nag_mode: 'Modo de insistencia',
      nag_mode_info:
        'El usuario puede cerrar haciendo clic en la X y luego ver el contenido',
      select_methods: 'Seleccionar métodos',
      customjavascript: 'JavaScript personalizado',
      mailinglist: 'Registro al boletín informativo por correo electrónico',
      subscription: 'Suscripción',
      user_registration: 'Registro de usuario',
      free_access: 'Acceso gratuito',
      meter: 'Contador',
      // Access Criteria Labels
      criteria_name_desc: 'Nombra este criterio',
      appman_title: 'Perfil de la aplicación',
      archivetime_title: 'Hora de archivo',
      asseteditortoggle_title: 'Alternar editor de activos',
      assetflag_title: 'Marca',
      customjs_title: 'JavaScript personalizado',
      dmp_title: 'Audiencia DMP',
      gdpr_title: 'País del RGPD',
      hostname_title: 'Nombre del host',
      incognito_title: 'Navegadores privados/de incógnito',
      ip_title: 'Dirección IP',
      keyword_title: 'Palabras clave',
      metatag_title: 'Metaetiqueta',
      metercheck_title: 'Verificación del medidor',
      queryparams_title: 'Parámetros de consulta',
      referrer_title: 'Referente',
      starttime_title: 'Hora de inicio',
      assettype_title: 'Tipo de recurso',
      subscriberstatus_title: 'Estado del suscriptor',
      url_title: 'URL',
      urlpattern_title: 'Patrón de URL',
      user_title: 'Inicio de sesión del usuario',
      useragent_title: 'Agente de usuario',
      // Access Criteria Labels
      offer_group_preview: 'Vista previa del grupo de ofertas',
      offer_group_preview_empty:
        'Selecciona un grupo de ofertas para generar una vista previa.',
      offer_group_preview_disabled:
        'La vista previa está deshabilitada mientras se crean nuevos grupos de ofertas.',
      offer_group_preview_error:
        'Lo siento, ocurrió un error al generar la vista previa. Por favor, verifique que el formulario sea válido y vuelva a intentarlo.',
      offer_group_refresh_preview:
        'Actualizar la vista previa utilizando los datos actuales del formulario.',
      offer_group_please_validate:
        'Por favor, valide el formulario antes de actualizar la vista previa.',
    },
    components: {
      copy_button: {
        tooltip: {
          default: 'Copiar al portapapeles',
          success: '¡Copiado!',
          error: 'Error al copiar',
        },
      },
    },
    navigation: {
      common: {
        divider: 'Divisor',
        ariaOpen: '{{label}} abierto',
        ariaClose: '{{label}} cerrado',
      },
      beta_requires_program:
        'Esta función está actualmente en beta. Contacte con soporte si tiene alguna pregunta.',
      settings: {
        label: 'Configuración',
        general: 'Configuración General',
        appearance: 'Configuración de Apariencia',
        advanced: 'Configuración Avanzada',
        advanced_description:
          'La Configuración Avanzada le permite acceder y gestionar funciones experimentales que estamos probando actualmente. Estas funciones se implementan de forma aislada para recopilar comentarios y perfeccionar su funcionalidad antes de un lanzamiento más amplio.',
      },
      root: {
        home: 'Inicio',
        boards: 'Tableros',
        dashboards_management: 'Paneles',
      },
      assets: {
        title: 'Gestión de Contenido',
        label: 'Recursos',
        all: 'Todos los Recursos',
        articles: 'Artículos',
        images: 'Imágenes',
        videos: 'Videos',
        collections: 'Colecciones',
        templates: 'Plantillas',
        dashboard: 'Panel',
        video_dashboard: 'Reproducción de Videos',
        advanced_filters: 'Filtros avanzados',
        quick_filters: 'Filtros Rápidos',
        standard_filters: 'Filtros estándar',
        more_filters: 'Más filtros',
      },
      feeds: {
        label: 'Feeds',
        all: 'Todos los Feeds',
        channels: 'Canales',
      },
      user: {
        title: 'Comunidad',
        contacts: 'Contactos',
        all_contacts: 'Todos los Contactos',
        admin_management: 'Gestión de Administradores',
        services: 'Servicios',
        all_services: 'Todos los Servicios',
        reports: 'Informes',
        reports_dashboard: 'Actividad de Suscripción',
        journeys: 'Viajes',
        all_journeys: 'Todos los Viajes',
        transactions: 'Transacciones',
        transactions_search: 'Todas las transacciones',
        email_reach: 'Alcance por Correo Electrónico',
        email_reach_search: 'Todas las Cuentas',
        email_reach_contacts: 'Contactos',
        email_reach_lists: 'Listas de Contactos',
        email_reach_messages: 'Mensajes',
        multisite_search: 'Búsqueda multi-sitio',
        account_type: {
          admin: 'Administrador',
          normal: 'Normal',
          any: 'Todos',
        },
      },
      notifier: {
        title: 'Notificador',
        messages: 'Mensajes',
        channels: 'Canales',
        connections: 'Conexiones',
        settings: 'Configuración',
        social_accounts: 'Cuentas sociales',
        automatic_notifications: 'Notificaciones automáticas',
      },
      design: {
        title: 'Diseño',
        maps: 'Mapas',
      },
    },
    reports: {
      domain_filter: {
        label: 'Dominios',
        placeholder: 'Seleccionar dominios',
        disabled_message: 'Se requiere el derecho de Audience+ para cambiar dominios.',
        clear: 'Borrar dominios',
      },
    },
    service: bloxSpanishServiceMessages,
    services: bloxSpanishServiceMessages,
    video_field_input: {
      uploading_percentage: 'Subiendo... {{percentage}}%',
      uploading_poster: 'Subiendo póster...',
      upload_success: 'Archivo subido con éxito.',
      upload_unsuccessful: 'La subida del archivo no tuvo éxito.',
      transfer_success: '¡Archivo transferido con éxito!',
      transfer_error: 'Error al transferir el archivo.',
      error: {
        wait_upload: 'Por favor espere, subiendo archivo...',
        file_required: 'Por favor adjunte un archivo.',

        no_video: 'No se encontró ningún video para capturar una captura de pantalla',
        no_file_playback: 'Archivo no disponible para reproducción',
        canvas_context: 'Error al obtener el contexto del canvas',
        screenshot_capture: 'Error al capturar la pantalla',
        screenshot_upload: 'Error al subir la captura de pantalla',
        poster_save: 'Error al guardar como póster',
        media_playback: {
          generic:
            'Se produjo un error desconocido durante la reproducción del contenido multimedia.',
          aborted: 'La reproducción del contenido multimedia fue interrumpida.',
          network_error:
            'Se produjo un error de red que impidió la correcta obtención del contenido multimedia.',
          decode_error:
            'La reproducción del contenido multimedia se interrumpió debido a un error al intentar decodificar el recurso multimedia.',
          format_converting:
            'Convirtiendo video al formato web. Vista previa disponible pronto.',
        },
      },
      screenshot: {
        preview: 'Vista previa de la captura de pantalla',
        captured: 'Captura de pantalla exitosa',
        use_as_preview: 'Usar como vista previa',
        use_as_poster: 'Usar como póster',
        discard: 'Descartar',
        saved: 'Captura de pantalla guardada con éxito',
      },
      remote_url: {
        title: 'Añadir video desde URL',
        description:
          'Introduzca la URL de un archivo de video o código de inserción de un servicio compatible.',
      },
      play_to_capture: 'Reproducir el video para capturar una imagen',
      not_supported: 'La captura de pantalla no es compatible con este video',
      trim_video: {
        label: 'Recortar video',
        help: 'Recorta el video a una duración específica',
        description: 'Especifique los puntos de inicio y fin para recortar el video.',
        errors: {
          invalid_range:
            'Rango inválido: el tiempo de inicio debe ser anterior al tiempo de fin.',
          out_of_bounds:
            'Fuera de rango: los tiempos deben estar dentro de la duración del video.',
          processing:
            'Error al procesar el nuevo clip de video. Por favor, inténtelo de nuevo.',
          unsupported_format: 'Formato no compatible para recortar el video.',
          unknown: 'Se produjo un error desconocido durante el recorte del video.',
        },
        actions: {
          preview: {
            label: 'Vista previa del recorte',
            tooltip: 'Muestra una vista previa del video recortado',
          },
          cancel: {
            label: 'Cancelar recorte',
            tooltip: 'Cancela la operación de recorte',
          },
          trim_new: {
            label: 'Recortar y nuevo',
            tooltip:
              'Crea un nuevo video con la sección recortada y duplica los metadatos',
            success: 'Nuevo video recortado creado con éxito',
          },
          play: {
            label: 'Reproducir',
            tooltip: 'Reproducir el vídeo',
          },
          pause: {
            label: 'Pausar',
            tooltip: 'Pausar el vídeo',
          },
          reverse: {
            label: 'Retroceder 5 segundos',
            tooltip: 'Retroceder el vídeo',
          },
          forward: {
            label: 'Adelantar 5 segundos',
            tooltip: 'Adelantar el vídeo',
          },
        },
        details: {
          in: 'Inicio',
          out: 'Fin',
          duration: 'Duración',
          original_duration: 'Duración original',
        },
      },
    },
    download_menu: {
      label: 'Descargas',
      title: 'Exportaciones',

      button: {
        tooltip: {
          all_ready: 'Exportaciones listas',
          of: 'de',
          exports_ready: 'exportaciones listas',
          preparing: 'Preparando exportaciones',
        },
      },

      empty: {
        message: 'No hay exportaciones activas disponibles.',
      },

      export: {
        label: 'Exportación',
        status: {
          ready: 'Listo para descargar',
          processing: 'Procesando…',
        },
      },

      actions: {
        download: 'Descargar',
        delete: 'Eliminar',
        clear: 'Borrar',
        close: 'Cerrar',
      },

      notifications: {
        download_started: 'Descarga iniciada',
        download_failed: 'Error en la descarga',
        export_ready_suffix: 'exportación lista',
        export_cleared: 'Exportación borrada',
        export_processing: 'La exportación aún se está procesando',
        export_not_found: 'Exportación no encontrada o expirada',
      },

      footer: {
        availability: 'Sus exportaciones estarán disponibles durante 24 horas.',
      },

      file: {
        prefix: 'blox',
        suffix: 'exportacion',
      },
    },
    export_button: {
      label: 'Exportar',
      menu: {
        loading: 'Cargando opciones de exportación...',
      },
      notifications: {
        export_started: 'Exportación iniciada',
        export_failed: 'Error al iniciar la exportación',
        export_unavailable: 'Función de exportación no disponible',
        load_options_failed: 'Error al cargar las opciones de exportación',
      },
    },
    notification_return: {
      processing: 'Procesando notificación, por favor espere...',
      loading: 'Cargando detalles de la notificación...',
      preparing_download: 'Preparando su descarga...',
      downloading: 'Descargando...',
      modal: {
        title: 'Descarga lista',
        description:
          'Revise los detalles anteriores y haga clic en Descargar para guardar el archivo en su dispositivo.',
      },
      success: {
        download_started: 'Su descarga ha comenzado',
      },
      error: {
        fetch_failed:
          'No se pudieron cargar los detalles de la notificación. Por favor, inténtelo de nuevo.',
        unknown_action: 'Esta acción de notificación no es compatible.',
        missing_export_id:
          'La notificación no contiene el identificador de exportación requerido.',
        download_failed:
          'Error al descargar el archivo de exportación. Por favor, inténtelo de nuevo.',
      },
    },
    notifications_panel: {
      title: 'Notificaciones',
      settings_title: 'Configuración de notificaciones',
      mark_all_read: 'Marcar todo como leído',
      filters: {
        all: 'Todos',
        unread: 'No leídos ({{count}})',
        read: 'Leídos',
      },
      sections: {
        today: 'Hoy',
        earlier: 'Anteriores',
      },
      empty: 'Sin notificaciones',
      error: 'Error al cargar las notificaciones',
      settings_placeholder: 'Contenido de configuración próximamente...',
    },
    welcome: {
      title: '¡Bienvenido a ',
    },
  },
  wizard: {
    stepper: {
      currentStepToggle:
        'Paso actual: {{label}}. Haz clic para {{action}} todos los pasos',
      collapse: 'contraer',
      expand: 'expandir',
      stepCounter: 'Paso {{current}} de {{total}}',
      listLabel: 'Todos los pasos',
      itemLabel: '{{label}}, paso {{current}} de {{total}}',
      statusSuffix: ', {{status}}',
      status: {
        active: 'paso actual',
        completed: 'completado',
        disabled: 'deshabilitado',
        inactive: 'inactivo',
      },
      iconLabel: 'Paso {{status}}',
      clickToGo: 'Haz clic para ir a este paso',
      navigationLabel: 'Pasos de progreso',
      regionLabel: 'Indicador de progreso de pasos',
    },
  },
};
